var _defs, _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDev(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 704 642",
    width: 704,
    height: 642,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 107.5,
    y1: 340.2,
    x2: 619.1,
    y2: 340.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#311b61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#8770b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#311b61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200041"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x1: 79.3,
    y1: 326.8,
    x2: 821.8,
    y2: 326.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311b61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f001f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g3",
    x1: 107.5,
    y1: 453.5,
    x2: 619.1,
    y2: 453.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#311b61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#8770b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#311b61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200041"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g4",
    x1: 84.8,
    y1: 332.3,
    x2: 565.9,
    y2: 332.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g5",
    cx: 382.7,
    cy: 502,
    r: 184.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g6",
    cx: 239.9,
    cy: 390,
    r: 68.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#972a74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g7",
    x1: 236.2,
    y1: 523.8,
    x2: 296.9,
    y2: 360.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g8",
    x1: 343.8,
    y1: 273.8,
    x2: 512,
    y2: 537.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g9",
    x1: 297.4,
    y1: 441.9,
    x2: 307,
    y2: 457,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g10",
    x1: 303.7,
    y1: 426.8,
    x2: 313.5,
    y2: 442.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g11",
    x1: 314.5,
    y1: 451.7,
    x2: 324,
    y2: 466.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g12",
    x1: 348.5,
    y1: 471.4,
    x2: 358,
    y2: 486.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g13",
    x1: 331.5,
    y1: 461.6,
    x2: 341,
    y2: 476.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g14",
    x1: 371.7,
    y1: 466.1,
    x2: 381.5,
    y2: 481.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g15",
    x1: 337.7,
    y1: 446.5,
    x2: 347.5,
    y2: 461.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g16",
    x1: 320.7,
    y1: 436.7,
    x2: 330.5,
    y2: 452,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g17",
    x1: 388.7,
    y1: 475.9,
    x2: 398.5,
    y2: 491.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g18",
    x1: 382.5,
    y1: 491,
    x2: 392,
    y2: 506,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g19",
    x1: 280.4,
    y1: 432.1,
    x2: 290,
    y2: 447.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g20",
    x1: 405.7,
    y1: 485.7,
    x2: 415.5,
    y2: 501.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g21",
    x1: 295.3,
    y1: 403.9,
    x2: 304.9,
    y2: 419,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g22",
    x1: 354.7,
    y1: 456.3,
    x2: 364.5,
    y2: 471.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g23",
    x1: 365.5,
    y1: 481.2,
    x2: 375,
    y2: 496.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g24",
    x1: 414.3,
    y1: 472.5,
    x2: 424.1,
    y2: 487.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g25",
    x1: 380.3,
    y1: 452.9,
    x2: 390.1,
    y2: 468.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g26",
    x1: 371.5,
    y1: 429.7,
    x2: 381.2,
    y2: 444.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g27",
    x1: 354.5,
    y1: 419.9,
    x2: 364.2,
    y2: 435,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g28",
    x1: 405.5,
    y1: 449.3,
    x2: 415.2,
    y2: 464.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g29",
    x1: 388.5,
    y1: 439.5,
    x2: 398.2,
    y2: 454.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g30",
    x1: 337.5,
    y1: 410.1,
    x2: 347.2,
    y2: 425.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g31",
    x1: 320.5,
    y1: 400.3,
    x2: 330.1,
    y2: 415.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g32",
    x1: 286.5,
    y1: 380.6,
    x2: 296.1,
    y2: 395.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g33",
    x1: 303.5,
    y1: 390.4,
    x2: 313.1,
    y2: 405.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g34",
    x1: 329.3,
    y1: 423.5,
    x2: 339,
    y2: 438.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g35",
    x1: 346.3,
    y1: 433.2,
    x2: 356.1,
    y2: 448.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g36",
    x1: 397.3,
    y1: 462.7,
    x2: 407.1,
    y2: 478.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g37",
    x1: 363.3,
    y1: 443.1,
    x2: 373.1,
    y2: 458.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g38",
    x1: 422.5,
    y1: 459.2,
    x2: 432.2,
    y2: 474.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g39",
    x1: 431.3,
    y1: 482.3,
    x2: 441.1,
    y2: 497.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g40",
    x1: 439.6,
    y1: 469,
    x2: 449.2,
    y2: 484.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g41",
    x1: 312.3,
    y1: 413.7,
    x2: 321.9,
    y2: 428.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g42",
    x1: 399.5,
    y1: 500.8,
    x2: 409,
    y2: 515.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g43",
    x1: 286.7,
    y1: 417,
    x2: 296.5,
    y2: 432.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g44",
    x1: 209.6,
    y1: 405.3,
    x2: 223.3,
    y2: 426.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g45",
    x1: 230.7,
    y1: 421.6,
    x2: 240.3,
    y2: 436.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g46",
    x1: 233.3,
    y1: 391.2,
    x2: 256.4,
    y2: 427.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g47",
    x1: 312.9,
    y1: 411.1,
    x2: 378.4,
    y2: 513.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g48",
    x1: 247.7,
    y1: 431.4,
    x2: 257.3,
    y2: 446.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g49",
    x1: 244.8,
    y1: 384.6,
    x2: 262.6,
    y2: 412.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g50",
    x1: 269.5,
    y1: 370.8,
    x2: 279.1,
    y2: 385.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g51",
    x1: 257.2,
    y1: 377.7,
    x2: 271,
    y2: 399.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g52",
    x1: 465.7,
    y1: 502.2,
    x2: 475.5,
    y2: 517.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g53",
    x1: 286.7,
    y1: 360.7,
    x2: 298.8,
    y2: 379.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g54",
    x1: 444.4,
    y1: 502.4,
    x2: 459.8,
    y2: 526.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g55",
    x1: 477.4,
    y1: 486.6,
    x2: 491.1,
    y2: 508.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g56",
    x1: 383.7,
    y1: 509.9,
    x2: 393.3,
    y2: 525,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g57",
    x1: 495.1,
    y1: 485.2,
    x2: 503,
    y2: 497.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g58",
    x1: 400.7,
    y1: 519.8,
    x2: 410.3,
    y2: 534.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g59",
    x1: 418.1,
    y1: 529.8,
    x2: 427.7,
    y2: 544.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g60",
    x1: 433.8,
    y1: 520.7,
    x2: 443.4,
    y2: 535.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g61",
    x1: 426.7,
    y1: 445.8,
    x2: 434.6,
    y2: 458.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g62",
    x1: 448.3,
    y1: 492.1,
    x2: 458.1,
    y2: 507.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g63",
    x1: 456.6,
    y1: 478.8,
    x2: 466.2,
    y2: 493.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g64",
    x1: 477.7,
    y1: 475.2,
    x2: 485.6,
    y2: 487.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g65",
    x1: 422.7,
    y1: 495.6,
    x2: 432.5,
    y2: 510.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g66",
    x1: 269.7,
    y1: 407.2,
    x2: 279.5,
    y2: 422.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g67",
    x1: 416.5,
    y1: 510.6,
    x2: 426,
    y2: 525.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g68",
    x1: 307.7,
    y1: 377.1,
    x2: 315.6,
    y2: 389.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g69",
    x1: 263.4,
    y1: 422.3,
    x2: 273,
    y2: 437.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g70",
    x1: 460.7,
    y1: 465.4,
    x2: 468.6,
    y2: 477.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g71",
    x1: 375.7,
    y1: 416.3,
    x2: 383.6,
    y2: 428.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g72",
    x1: 341.7,
    y1: 396.7,
    x2: 349.6,
    y2: 409.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g73",
    x1: 358.7,
    y1: 406.5,
    x2: 366.6,
    y2: 418.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g74",
    x1: 324.7,
    y1: 386.9,
    x2: 332.6,
    y2: 399.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g75",
    x1: 392.7,
    y1: 426.1,
    x2: 400.6,
    y2: 438.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g76",
    x1: 278.3,
    y1: 394.1,
    x2: 287.9,
    y2: 409.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g77",
    x1: 409.7,
    y1: 436,
    x2: 417.6,
    y2: 448.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g78",
    x1: 443.7,
    y1: 455.6,
    x2: 451.6,
    y2: 468,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#9f79b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#e6c6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#8969c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g79",
    x1: 414,
    y1: -188.2,
    x2: 817.6,
    y2: 167.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311b61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f001f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g80",
    x1: 267.6,
    y1: 652.5,
    x2: 21.9,
    y2: 271.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2a0c5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b4299a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g81",
    x1: 292,
    y1: 728.3,
    x2: 35.6,
    y2: 318.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#311b61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#8770b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#311b61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#200041"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g82",
    cx: 571.9,
    cy: 252.5,
    r: 42.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g83",
    cx: 575.2,
    cy: 245.5,
    r: 20.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#972a74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g84",
    x1: 108984.2,
    y1: 89864.5,
    x2: 128642.4,
    y2: 120715.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311b61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#200041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f001f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g85",
    x1: 503.3,
    y1: 474.5,
    x2: 225.3,
    y2: 80.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g86",
    x1: 451.1,
    y1: 511.3,
    x2: 173.1,
    y2: 117.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g87",
    x1: 566.2,
    y1: 453.3,
    x2: 273.9,
    y2: 39,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g88",
    x1: 467.6,
    y1: 513,
    x2: 175.3,
    y2: 98.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g89",
    x1: 555.9,
    y1: 511.4,
    x2: 224.2,
    y2: 41.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g90",
    cx: 436.2,
    cy: 272.2,
    r: 39.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g91",
    cx: 304.9,
    cy: 196.9,
    r: 39.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g92",
    cx: 375.4,
    cy: 113.7,
    r: 35.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g93",
    cx: 372.1,
    cy: 308.6,
    r: 35.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g94",
    cx: 373,
    cy: 179.3,
    r: 33,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g95",
    cx: 349.1,
    cy: 174.2,
    r: 311.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g96",
    cx: 392.5,
    cy: 192.2,
    r: 311.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g97",
    cx: 349.1,
    cy: 174.2,
    r: 311.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g98",
    cx: 349.1,
    cy: 174.2,
    r: 311.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g99",
    cx: 349.1,
    cy: 174.2,
    r: 311.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g100",
    cx: 349.1,
    cy: 174.2,
    r: 311.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g101",
    cx: 349.1,
    cy: 174.2,
    r: 311.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g102",
    cx: 349.1,
    cy: 174.2,
    r: 311.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g103",
    cx: 349.1,
    cy: 174.2,
    r: 311.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g104",
    cx: 349.1,
    cy: 174.2,
    r: 311.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g105",
    cx: 349.1,
    cy: 174.2,
    r: 311.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g106",
    cx: 349.1,
    cy: 174.2,
    r: 311.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g107",
    cx: 349.1,
    cy: 174.2,
    r: 311.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g108",
    cx: 349.1,
    cy: 174.2,
    r: 311.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g109",
    cx: 349.1,
    cy: 174.2,
    r: 311.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g110",
    cx: 349.1,
    cy: 174.2,
    r: 311.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g111",
    cx: 349.1,
    cy: 174.2,
    r: 311.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g112",
    cx: 349.1,
    cy: 174.2,
    r: 311.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g113",
    cx: 349.1,
    cy: 174.2,
    r: 311.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g114",
    cx: 349.1,
    cy: 174.2,
    r: 311.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g115",
    cx: 349.1,
    cy: 174.2,
    r: 311.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g116",
    cx: 349.1,
    cy: 174.2,
    r: 311.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g117",
    cx: 349.1,
    cy: 174.2,
    r: 311.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g118",
    cx: 349.1,
    cy: 174.2,
    r: 311.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g119",
    cx: 349.1,
    cy: 174.2,
    r: 311.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g120",
    cx: 349.1,
    cy: 174.2,
    r: 311.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g121",
    cx: 349.1,
    cy: 174.2,
    r: 311.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g122",
    cx: 349.1,
    cy: 174.2,
    r: 311.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g123",
    cx: 296.8,
    cy: 176.2,
    r: 165.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g124",
    cx: 296.8,
    cy: 176.2,
    r: 165.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g125",
    cx: 296.8,
    cy: 176.2,
    r: 165.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g126",
    cx: 296.8,
    cy: 176.2,
    r: 165.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g127",
    cx: 296.8,
    cy: 176.2,
    r: 165.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g128",
    cx: 296.8,
    cy: 176.2,
    r: 165.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g129",
    cx: 296.8,
    cy: 176.2,
    r: 165.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g130",
    cx: 234.8,
    cy: 109.5,
    r: 311.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g131",
    cx: 244.5,
    cy: 113.8,
    r: 311.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g132",
    cx: 234.8,
    cy: 109.5,
    r: 311.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g133",
    cx: 234.8,
    cy: 109.5,
    r: 311.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g134",
    cx: 234.8,
    cy: 109.5,
    r: 311.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g135",
    cx: 234.8,
    cy: 109.5,
    r: 311.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g136",
    cx: 234.8,
    cy: 109.5,
    r: 311.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g137",
    cx: 244.1,
    cy: 119.5,
    r: 311.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g138",
    cx: 234.8,
    cy: 109.5,
    r: 311.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g139",
    cx: 234.8,
    cy: 109.5,
    r: 311.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g140",
    cx: 234.8,
    cy: 109.5,
    r: 311.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g141",
    cx: 234.8,
    cy: 109.5,
    r: 311.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g142",
    cx: 234.8,
    cy: 109.5,
    r: 311.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g143",
    cx: 234.8,
    cy: 109.5,
    r: 311.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g144",
    cx: 348.8,
    cy: 163.8,
    r: 213.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g145",
    cx: 357.5,
    cy: 198.2,
    r: 213.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g146",
    cx: 348.5,
    cy: 168.5,
    r: 213.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g147",
    cx: 357.5,
    cy: 198.2,
    r: 213.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g148",
    cx: 357.5,
    cy: 198.2,
    r: 213.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g149",
    cx: 357.5,
    cy: 198.2,
    r: 213.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g150",
    cx: 357.5,
    cy: 198.2,
    r: 213.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g151",
    cx: 344,
    cy: 191.2,
    r: 307.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g152",
    cx: 329.7,
    cy: 148.9,
    r: 307.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g153",
    cx: 344,
    cy: 191.2,
    r: 307.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g154",
    cx: 344,
    cy: 191.2,
    r: 307.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g155",
    cx: 344,
    cy: 191.2,
    r: 307.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g156",
    cx: 344,
    cy: 191.2,
    r: 307.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g157",
    cx: 344,
    cy: 191.2,
    r: 307.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g158",
    cx: 344,
    cy: 191.2,
    r: 307.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g159",
    cx: 377.7,
    cy: 193.9,
    r: 307.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g160",
    cx: 344,
    cy: 191.2,
    r: 307.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g161",
    cx: 344,
    cy: 191.2,
    r: 307.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g162",
    cx: 344,
    cy: 191.2,
    r: 307.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g163",
    cx: 344,
    cy: 191.2,
    r: 307.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g164",
    cx: 344,
    cy: 191.2,
    r: 307.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g165",
    cx: 344,
    cy: 191.2,
    r: 307.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g166",
    cx: 344,
    cy: 191.2,
    r: 307.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g167",
    cx: 410,
    cy: 213.6,
    r: 307.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g168",
    cx: 387,
    cy: 219.2,
    r: 307.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g169",
    cx: 344,
    cy: 191.2,
    r: 307.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g170",
    cx: 344,
    cy: 191.2,
    r: 307.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g171",
    cx: 344,
    cy: 191.2,
    r: 307.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g172",
    x1: 393.4,
    y1: -122.3,
    x2: 569.2,
    y2: 213,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g173",
    x1: 391.6,
    y1: -120.3,
    x2: 566.4,
    y2: 213,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g174",
    x1: 389.9,
    y1: -118.3,
    x2: 563.6,
    y2: 213,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g175",
    x1: 388.2,
    y1: -116.3,
    x2: 560.9,
    y2: 213,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g176",
    x1: 386.5,
    y1: -114.3,
    x2: 558.1,
    y2: 213,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g177",
    x1: 384.8,
    y1: -112.4,
    x2: 555.4,
    y2: 213,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g178",
    x1: 383.2,
    y1: -110.5,
    x2: 552.8,
    y2: 212.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g179",
    x1: 381.6,
    y1: -108.6,
    x2: 550.2,
    y2: 212.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g180",
    x1: 380.1,
    y1: -106.7,
    x2: 547.7,
    y2: 212.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g181",
    x1: 378.6,
    y1: -105,
    x2: 545.3,
    y2: 212.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g182",
    x1: 377.3,
    y1: -103.3,
    x2: 543,
    y2: 212.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g183",
    x1: 376.2,
    y1: -101.7,
    x2: 541,
    y2: 212.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g184",
    x1: 42.1,
    y1: 591.7,
    x2: -220.9,
    y2: 77.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g185",
    cx: 247.2,
    cy: 187.3,
    r: 138.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#711f56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g186",
    x1: 255.3,
    y1: 201.9,
    x2: 264.1,
    y2: 201.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g187",
    x1: 246.9,
    y1: 233.2,
    x2: 261.4,
    y2: 233.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g188",
    x1: 244.4,
    y1: 205,
    x2: 260.6,
    y2: 205,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g189",
    x1: 243.6,
    y1: 222.1,
    x2: 251.8,
    y2: 222.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g190",
    x1: 217.7,
    y1: 216.6,
    x2: 231.1,
    y2: 216.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g191",
    x1: 256.2,
    y1: 229.3,
    x2: 261.9,
    y2: 229.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g192",
    x1: 251.1,
    y1: 217.7,
    x2: 258,
    y2: 217.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g193",
    x1: 268.4,
    y1: 209.5,
    x2: 272.2,
    y2: 209.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g194",
    x1: 232.9,
    y1: 207.3,
    x2: 246.8,
    y2: 207.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g195",
    x1: 265,
    y1: 216.7,
    x2: 279.6,
    y2: 216.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g196",
    x1: 221.9,
    y1: 209.9,
    x2: 239.4,
    y2: 209.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g197",
    x1: 226.1,
    y1: 185.2,
    x2: 239.8,
    y2: 185.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g198",
    x1: 244.1,
    y1: 195.4,
    x2: 251,
    y2: 195.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g199",
    x1: 235.5,
    y1: 226.6,
    x2: 242.7,
    y2: 226.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g200",
    x1: 275.8,
    y1: 240.8,
    x2: 294.4,
    y2: 240.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g201",
    x1: 206.9,
    y1: 210.4,
    x2: 213.4,
    y2: 210.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g202",
    x1: 193.4,
    y1: 167.1,
    x2: 222.7,
    y2: 167.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g203",
    x1: 280.1,
    y1: 234.3,
    x2: 287,
    y2: 234.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g204",
    x1: 283.9,
    y1: 227.6,
    x2: 303.3,
    y2: 227.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g205",
    x1: 262.3,
    y1: 224,
    x2: 275.9,
    y2: 224,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g206",
    x1: 276.5,
    y1: 214.1,
    x2: 291.9,
    y2: 214.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g207",
    x1: 206.9,
    y1: 201.4,
    x2: 217.6,
    y2: 201.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g208",
    x1: 266.2,
    y1: 235.2,
    x2: 271.6,
    y2: 235.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g209",
    x1: 206.9,
    y1: 192.5,
    x2: 228.6,
    y2: 192.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g210",
    x1: 265.4,
    y1: 252.5,
    x2: 277.1,
    y2: 252.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g211",
    x1: 206.9,
    y1: 183.5,
    x2: 240.1,
    y2: 183.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g212",
    x1: 255.3,
    y1: 334.4,
    x2: 264.1,
    y2: 334.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g213",
    x1: 246.9,
    y1: 365.7,
    x2: 261.4,
    y2: 365.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g214",
    x1: 244.4,
    y1: 337.6,
    x2: 260.6,
    y2: 337.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g215",
    x1: 243.6,
    y1: 354.6,
    x2: 251.8,
    y2: 354.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g216",
    x1: 217.7,
    y1: 349.2,
    x2: 231.1,
    y2: 349.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g217",
    x1: 256.2,
    y1: 361.9,
    x2: 261.9,
    y2: 361.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g218",
    x1: 251.1,
    y1: 350.3,
    x2: 258,
    y2: 350.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g219",
    x1: 268.4,
    y1: 342,
    x2: 272.2,
    y2: 342,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g220",
    x1: 232.9,
    y1: 339.9,
    x2: 246.8,
    y2: 339.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g221",
    x1: 265,
    y1: 349.2,
    x2: 279.6,
    y2: 349.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g222",
    x1: 221.9,
    y1: 342.4,
    x2: 239.4,
    y2: 342.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g223",
    x1: 226.1,
    y1: 317.7,
    x2: 239.8,
    y2: 317.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g224",
    x1: 244.1,
    y1: 328,
    x2: 251,
    y2: 328,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g225",
    x1: 235.5,
    y1: 359.2,
    x2: 242.7,
    y2: 359.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g226",
    x1: 275.8,
    y1: 373.3,
    x2: 294.4,
    y2: 373.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g227",
    x1: 206.9,
    y1: 342.9,
    x2: 213.4,
    y2: 342.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g228",
    x1: 193.4,
    y1: 299.6,
    x2: 222.7,
    y2: 299.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g229",
    x1: 280.1,
    y1: 366.9,
    x2: 287,
    y2: 366.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g230",
    x1: 283.9,
    y1: 360.2,
    x2: 303.3,
    y2: 360.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g231",
    x1: 262.3,
    y1: 356.6,
    x2: 275.9,
    y2: 356.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g232",
    x1: 276.5,
    y1: 346.7,
    x2: 291.9,
    y2: 346.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g233",
    x1: 206.9,
    y1: 334,
    x2: 217.6,
    y2: 334,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g234",
    x1: 266.2,
    y1: 367.8,
    x2: 271.6,
    y2: 367.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g235",
    x1: 206.9,
    y1: 325,
    x2: 228.6,
    y2: 325,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g236",
    x1: 206.9,
    y1: 316.1,
    x2: 240.1,
    y2: 316.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g237",
    x1: 246.9,
    y1: 268.7,
    x2: 261.4,
    y2: 268.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g238",
    x1: 244.4,
    y1: 240.6,
    x2: 260.6,
    y2: 240.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g239",
    x1: 243.6,
    y1: 257.7,
    x2: 251.8,
    y2: 257.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g240",
    x1: 217.7,
    y1: 252.2,
    x2: 231.1,
    y2: 252.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g241",
    x1: 256.2,
    y1: 264.9,
    x2: 261.9,
    y2: 264.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g242",
    x1: 251.1,
    y1: 253.3,
    x2: 258,
    y2: 253.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g243",
    x1: 232.9,
    y1: 242.9,
    x2: 246.8,
    y2: 242.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g244",
    x1: 221.9,
    y1: 245.5,
    x2: 239.4,
    y2: 245.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g245",
    x1: 235.5,
    y1: 262.2,
    x2: 242.7,
    y2: 262.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g246",
    x1: 275.8,
    y1: 276.4,
    x2: 294.4,
    y2: 276.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g247",
    x1: 206.9,
    y1: 246,
    x2: 213.4,
    y2: 246,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g248",
    x1: 280.1,
    y1: 269.9,
    x2: 287,
    y2: 269.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g249",
    x1: 262.3,
    y1: 259.6,
    x2: 275.9,
    y2: 259.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g250",
    x1: 206.9,
    y1: 237,
    x2: 217.6,
    y2: 237,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g251",
    x1: 266.2,
    y1: 270.8,
    x2: 271.6,
    y2: 270.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g252",
    x1: 206.9,
    y1: 228.1,
    x2: 228.6,
    y2: 228.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g253",
    x1: 241.3,
    y1: 274.2,
    x2: 248.1,
    y2: 274.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g254",
    x1: 223.1,
    y1: 263.8,
    x2: 237,
    y2: 263.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g255",
    x1: 270.2,
    y1: 290.8,
    x2: 277.1,
    y2: 290.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g256",
    x1: 252.4,
    y1: 280.5,
    x2: 266,
    y2: 280.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g257",
    x1: 197,
    y1: 249,
    x2: 218.8,
    y2: 249,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g258",
    x1: 206.9,
    y1: 219.1,
    x2: 240.1,
    y2: 219.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g259",
    x1: 246.9,
    y1: 312.8,
    x2: 261.4,
    y2: 312.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g260",
    x1: 244.4,
    y1: 284.7,
    x2: 260.6,
    y2: 284.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g261",
    x1: 243.6,
    y1: 301.8,
    x2: 251.8,
    y2: 301.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g262",
    x1: 217.7,
    y1: 296.3,
    x2: 231.1,
    y2: 296.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g263",
    x1: 256.2,
    y1: 309,
    x2: 261.9,
    y2: 309,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g264",
    x1: 251.1,
    y1: 297.4,
    x2: 258,
    y2: 297.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g265",
    x1: 232.9,
    y1: 287,
    x2: 246.8,
    y2: 287,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g266",
    x1: 221.9,
    y1: 289.6,
    x2: 239.4,
    y2: 289.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g267",
    x1: 235.5,
    y1: 306.3,
    x2: 242.7,
    y2: 306.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g268",
    x1: 275.8,
    y1: 320.5,
    x2: 294.4,
    y2: 320.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g269",
    x1: 206.9,
    y1: 290.1,
    x2: 213.4,
    y2: 290.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g270",
    x1: 280.1,
    y1: 314,
    x2: 287,
    y2: 314,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g271",
    x1: 262.3,
    y1: 303.7,
    x2: 275.9,
    y2: 303.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g272",
    x1: 206.9,
    y1: 281.1,
    x2: 217.6,
    y2: 281.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g273",
    x1: 266.2,
    y1: 314.9,
    x2: 271.6,
    y2: 314.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g274",
    x1: 206.9,
    y1: 272.2,
    x2: 228.6,
    y2: 272.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g275",
    x1: 241.3,
    y1: 318.3,
    x2: 248.1,
    y2: 318.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g276",
    x1: 223.1,
    y1: 307.9,
    x2: 237,
    y2: 307.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g277",
    x1: 270.2,
    y1: 334.9,
    x2: 277.1,
    y2: 334.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g278",
    x1: 252.4,
    y1: 324.6,
    x2: 266,
    y2: 324.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g279",
    x1: 206.3,
    y1: 298.3,
    x2: 218.8,
    y2: 298.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g280",
    x1: 206.9,
    y1: 263.2,
    x2: 240.1,
    y2: 263.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g281",
    x1: 428.3,
    y1: 587.6,
    x2: -189.6,
    y2: 887,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g282",
    x1: 255.3,
    y1: 529.1,
    x2: 264.1,
    y2: 539.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g283",
    x1: 246.9,
    y1: 488,
    x2: 261.4,
    y2: 504.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g284",
    x1: 244.4,
    y1: 513.3,
    x2: 260.6,
    y2: 532.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g285",
    x1: 243.6,
    y1: 495.3,
    x2: 251.8,
    y2: 504.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g286",
    x1: 217.7,
    y1: 470.7,
    x2: 231.1,
    y2: 486.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g287",
    x1: 256.2,
    y1: 502.6,
    x2: 261.9,
    y2: 509.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g288",
    x1: 251.1,
    y1: 508.4,
    x2: 258,
    y2: 516.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g289",
    x1: 268.4,
    y1: 536.7,
    x2: 272.2,
    y2: 541,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g290",
    x1: 232.9,
    y1: 497.7,
    x2: 246.8,
    y2: 513.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g291",
    x1: 265,
    y1: 525.4,
    x2: 279.6,
    y2: 542.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g292",
    x1: 221.9,
    y1: 482.3,
    x2: 239.4,
    y2: 502.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g293",
    x1: 226.1,
    y1: 511.9,
    x2: 239.8,
    y2: 527.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g294",
    x1: 244.1,
    y1: 522.5,
    x2: 251,
    y2: 530.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g295",
    x1: 235.5,
    y1: 481.3,
    x2: 242.7,
    y2: 489.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g296",
    x1: 275.8,
    y1: 513.9,
    x2: 294.4,
    y2: 535.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g297",
    x1: 206.9,
    y1: 464.3,
    x2: 213.4,
    y2: 472,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g298",
    x1: 193.4,
    y1: 492,
    x2: 222.7,
    y2: 526,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g299",
    x1: 280.1,
    y1: 525.4,
    x2: 287,
    y2: 533.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g300",
    x1: 283.9,
    y1: 536.5,
    x2: 303.3,
    y2: 559,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g301",
    x1: 262.3,
    y1: 515,
    x2: 275.9,
    y2: 530.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g302",
    x1: 276.5,
    y1: 541.4,
    x2: 291.9,
    y2: 559.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g303",
    x1: 206.9,
    y1: 473.3,
    x2: 217.6,
    y2: 485.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g304",
    x1: 266.2,
    y1: 508.3,
    x2: 271.6,
    y2: 514.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g305",
    x1: 206.9,
    y1: 482.2,
    x2: 228.6,
    y2: 507.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f27bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g306",
    x1: 206.9,
    y1: 491.2,
    x2: 240.1,
    y2: 529.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g307",
    x1: 522.8,
    y1: 97.7,
    x2: 687,
    y2: 410.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g308",
    x1: 520.3,
    y1: 101.8,
    x2: 682.5,
    y2: 411.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g309",
    x1: 517.8,
    y1: 105.8,
    x2: 678,
    y2: 411.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g310",
    x1: 515.3,
    y1: 109.8,
    x2: 673.6,
    y2: 411.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g311",
    x1: 512.9,
    y1: 113.9,
    x2: 669.1,
    y2: 411.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g312",
    x1: 510.4,
    y1: 117.9,
    x2: 664.7,
    y2: 412.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g313",
    x1: 507.9,
    y1: 121.9,
    x2: 660.2,
    y2: 412.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g314",
    x1: 505.5,
    y1: 125.9,
    x2: 655.8,
    y2: 412.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g315",
    x1: 503.1,
    y1: 129.9,
    x2: 651.4,
    y2: 412.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g316",
    x1: 500.6,
    y1: 133.9,
    x2: 646.9,
    y2: 412.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g317",
    x1: 498.2,
    y1: 137.9,
    x2: 642.5,
    y2: 413.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g318",
    x1: 495.8,
    y1: 141.9,
    x2: 638.1,
    y2: 413.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#5f27bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3d065f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g319",
    x1: 583.7,
    y1: 649.7,
    x2: 272.9,
    y2: 374.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138bbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g320",
    cx: 506.4,
    cy: 383.4,
    r: 241.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#711f56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g321",
    x1: 612.7,
    y1: 621.9,
    x2: 155.7,
    y2: 148.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g322",
    x1: 618.1,
    y1: 600.3,
    x2: 161.1,
    y2: 127,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g323",
    x1: 624.4,
    y1: 578,
    x2: 167.5,
    y2: 104.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g324",
    x1: 692.1,
    y1: 713.6,
    x2: -542,
    y2: -564.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g325",
    x1: 701.3,
    y1: 696,
    x2: -532.9,
    y2: -582.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g326",
    x1: 711.3,
    y1: 677.5,
    x2: -522.9,
    y2: -600.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g327",
    x1: 562.9,
    y1: 565.2,
    x2: 72.4,
    y2: 133.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g328",
    x1: 544.4,
    y1: 543.6,
    x2: 337.7,
    y2: 339.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g329",
    x1: 560.9,
    y1: 547.5,
    x2: 334.4,
    y2: 323.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g330",
    x1: 550.2,
    y1: 538.5,
    x2: 328.4,
    y2: 319,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g331",
    x1: 554.5,
    y1: 522.4,
    x2: 347.1,
    y2: 317.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g332",
    x1: 551.1,
    y1: 514.4,
    x2: 361.6,
    y2: 326.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g333",
    x1: 583.7,
    y1: 771.7,
    x2: 272.9,
    y2: 496.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138bbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g334",
    x1: 618.1,
    y1: 722.3,
    x2: 161.1,
    y2: 249,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#7c1dc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g335",
    x1: 550.2,
    y1: 456.3,
    x2: 328.4,
    y2: 418.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g336",
    x1: 554.5,
    y1: 477.4,
    x2: 347.1,
    y2: 442.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g337",
    cx: 615,
    cy: 217.2,
    r: 94.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g338",
    cx: 268.9,
    cy: 123.2,
    r: 203.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g339",
    cx: 268.9,
    cy: 123.2,
    r: 203.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g340",
    cx: 268.9,
    cy: 123.2,
    r: 203.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g341",
    cx: 268.9,
    cy: 123.2,
    r: 203.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g342",
    cx: 268.9,
    cy: 123.2,
    r: 203.7,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10054d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g343",
    x1: 1216081.5,
    y1: -654731.8,
    x2: 1221898.9,
    y2: -651421.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g344",
    x1: 176.3,
    y1: 120.6,
    x2: 176.2,
    y2: 120.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g345",
    cx: 498,
    cy: 226.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g346",
    cx: 498,
    cy: 226.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g347",
    cx: 498,
    cy: 226.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g348",
    cx: 498,
    cy: 226.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g349",
    cx: 498,
    cy: 226.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g350",
    cx: 498,
    cy: 226.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g351",
    cx: 498,
    cy: 226.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g352",
    cx: 498,
    cy: 226.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g353",
    cx: 498,
    cy: 226.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g354",
    cx: 498,
    cy: 226.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g355",
    cx: 498,
    cy: 226.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g356",
    cx: 498,
    cy: 226.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g357",
    cx: 498,
    cy: 226.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g358",
    cx: 498,
    cy: 228.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g359",
    cx: 498,
    cy: 228.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g360",
    cx: 498,
    cy: 228.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g361",
    cx: 498,
    cy: 228.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g362",
    cx: 498,
    cy: 228.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g363",
    cx: 498,
    cy: 228.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g364",
    cx: 498,
    cy: 228.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g365",
    cx: 498,
    cy: 228.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g366",
    cx: 498,
    cy: 228.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g367",
    cx: 498,
    cy: 228.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g368",
    cx: 498,
    cy: 228.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g369",
    cx: 498,
    cy: 228.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g370",
    cx: 498,
    cy: 228.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g371",
    cx: 498,
    cy: 230.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g372",
    cx: 498,
    cy: 230.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g373",
    cx: 498,
    cy: 230.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g374",
    cx: 498,
    cy: 230.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g375",
    cx: 498,
    cy: 230.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g376",
    cx: 498,
    cy: 230.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g377",
    cx: 498,
    cy: 230.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g378",
    cx: 498,
    cy: 230.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g379",
    cx: 498,
    cy: 230.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g380",
    cx: 498,
    cy: 230.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g381",
    cx: 498,
    cy: 230.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g382",
    cx: 498.1,
    cy: 230.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g383",
    cx: 498,
    cy: 230.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g384",
    cx: 498,
    cy: 232.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g385",
    cx: 498,
    cy: 232.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g386",
    cx: 498,
    cy: 232.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g387",
    cx: 498,
    cy: 232.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g388",
    cx: 498,
    cy: 232.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g389",
    cx: 498,
    cy: 232.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g390",
    cx: 498,
    cy: 232.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g391",
    cx: 498,
    cy: 232.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g392",
    cx: 498,
    cy: 232.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g393",
    cx: 498,
    cy: 232.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g394",
    cx: 498,
    cy: 232.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g395",
    cx: 498.1,
    cy: 232.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g396",
    cx: 498,
    cy: 232.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g397",
    cx: 498,
    cy: 234.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g398",
    cx: 498,
    cy: 234.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g399",
    cx: 498,
    cy: 234.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g400",
    cx: 498,
    cy: 234.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g401",
    cx: 498,
    cy: 234.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g402",
    cx: 498,
    cy: 234.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g403",
    cx: 498,
    cy: 234.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g404",
    cx: 498,
    cy: 234.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g405",
    cx: 498,
    cy: 234.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g406",
    cx: 498,
    cy: 234.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g407",
    cx: 498,
    cy: 234.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g408",
    cx: 498,
    cy: 234.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g409",
    cx: 498,
    cy: 234.8,
    r: 160.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b4299a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#10054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a0014"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g410",
    x1: 300.9,
    y1: 310.6,
    x2: 161.6,
    y2: 140.6,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g411",
    x1: 235.9,
    y1: 363.8,
    x2: 96.6,
    y2: 193.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g412",
    x1: 263.4,
    y1: 341.3,
    x2: 124.1,
    y2: 171.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{opacity:0}.b{opacity:.1}.c{opacity:.2}.d{opacity:.3}.e{opacity:.4}.f{opacity:.5}.g{opacity:.6}.h{opacity:.7}.i{opacity:.8}.j{opacity:.9}.k{fill:url(#g1)}.l{fill:url(#g2)}.m{opacity:.2;fill:url(#g3)}.n{fill:url(#g4)}.o{mix-blend-mode:screen;fill:url(#g5)}.p{mix-blend-mode:color-dodge;fill:url(#g6)}.q{fill:url(#g7)}.r{opacity:.3;mix-blend-mode:screen;fill:url(#g8)}.s{opacity:.3;mix-blend-mode:screen;fill:url(#g9)}.t{opacity:.3;mix-blend-mode:screen;fill:url(#g10)}.u{opacity:.3;mix-blend-mode:screen;fill:url(#g11)}.v{opacity:.3;mix-blend-mode:screen;fill:url(#g12)}.w{opacity:.3;mix-blend-mode:screen;fill:url(#g13)}.x{opacity:.3;mix-blend-mode:screen;fill:url(#g14)}.y{opacity:.3;mix-blend-mode:screen;fill:url(#g15)}.z{opacity:.3;mix-blend-mode:screen;fill:url(#g16)}.A{opacity:.3;mix-blend-mode:screen;fill:url(#g17)}.B{opacity:.3;mix-blend-mode:screen;fill:url(#g18)}.C{opacity:.3;mix-blend-mode:screen;fill:url(#g19)}.D{opacity:.3;mix-blend-mode:screen;fill:url(#g20)}.E{opacity:.3;mix-blend-mode:screen;fill:url(#g21)}.F{opacity:.3;mix-blend-mode:screen;fill:url(#g22)}.G{opacity:.3;mix-blend-mode:screen;fill:url(#g23)}.H{opacity:.3;mix-blend-mode:screen;fill:url(#g24)}.I{opacity:.3;mix-blend-mode:screen;fill:url(#g25)}.J{opacity:.3;mix-blend-mode:screen;fill:url(#g26)}.K{opacity:.3;mix-blend-mode:screen;fill:url(#g27)}.L{opacity:.3;mix-blend-mode:screen;fill:url(#g28)}.M{opacity:.3;mix-blend-mode:screen;fill:url(#g29)}.N{opacity:.3;mix-blend-mode:screen;fill:url(#g30)}.O{opacity:.3;mix-blend-mode:screen;fill:url(#g31)}.P{opacity:.3;mix-blend-mode:screen;fill:url(#g32)}.Q{opacity:.3;mix-blend-mode:screen;fill:url(#g33)}.R{opacity:.3;mix-blend-mode:screen;fill:url(#g34)}.S{opacity:.3;mix-blend-mode:screen;fill:url(#g35)}.T{opacity:.3;mix-blend-mode:screen;fill:url(#g36)}.U{opacity:.3;mix-blend-mode:screen;fill:url(#g37)}.V{opacity:.3;mix-blend-mode:screen;fill:url(#g38)}.W{opacity:.3;mix-blend-mode:screen;fill:url(#g39)}.X{opacity:.3;mix-blend-mode:screen;fill:url(#g40)}.Y{opacity:.3;mix-blend-mode:screen;fill:url(#g41)}.Z{opacity:.3;mix-blend-mode:screen;fill:url(#g42)}.a0{opacity:.3;mix-blend-mode:screen;fill:url(#g43)}.a1{opacity:.3;mix-blend-mode:screen;fill:url(#g44)}.a2{opacity:.3;mix-blend-mode:screen;fill:url(#g45)}.a3{opacity:.3;mix-blend-mode:screen;fill:url(#g46)}.a4{opacity:.3;mix-blend-mode:screen;fill:url(#g47)}.a5{opacity:.3;mix-blend-mode:screen;fill:url(#g48)}.a6{opacity:.3;mix-blend-mode:screen;fill:url(#g49)}.a7{opacity:.3;mix-blend-mode:screen;fill:url(#g50)}.a8{opacity:.3;mix-blend-mode:screen;fill:url(#g51)}.a9{opacity:.3;mix-blend-mode:screen;fill:url(#g52)}.aa{opacity:.3;mix-blend-mode:screen;fill:url(#g53)}.ab{opacity:.3;mix-blend-mode:screen;fill:url(#g54)}.ac{opacity:.3;mix-blend-mode:screen;fill:url(#g55)}.ad{opacity:.3;mix-blend-mode:screen;fill:url(#g56)}.ae{opacity:.3;mix-blend-mode:screen;fill:url(#g57)}.af{opacity:.3;mix-blend-mode:screen;fill:url(#g58)}.ag{opacity:.3;mix-blend-mode:screen;fill:url(#g59)}.ah{opacity:.3;mix-blend-mode:screen;fill:url(#g60)}.ai{opacity:.3;mix-blend-mode:screen;fill:url(#g61)}.aj{opacity:.3;mix-blend-mode:screen;fill:url(#g62)}.ak{opacity:.3;mix-blend-mode:screen;fill:url(#g63)}.al{opacity:.3;mix-blend-mode:screen;fill:url(#g64)}.am{opacity:.3;mix-blend-mode:screen;fill:url(#g65)}.an{opacity:.3;mix-blend-mode:screen;fill:url(#g66)}.ao{opacity:.3;mix-blend-mode:screen;fill:url(#g67)}.ap{opacity:.3;mix-blend-mode:screen;fill:url(#g68)}.aq{opacity:.3;mix-blend-mode:screen;fill:url(#g69)}.ar{opacity:.3;mix-blend-mode:screen;fill:url(#g70)}.as{opacity:.3;mix-blend-mode:screen;fill:url(#g71)}.at{opacity:.3;mix-blend-mode:screen;fill:url(#g72)}.au{opacity:.3;mix-blend-mode:screen;fill:url(#g73)}.av{opacity:.3;mix-blend-mode:screen;fill:url(#g74)}.aw{opacity:.3;mix-blend-mode:screen;fill:url(#g75)}.ax{opacity:.3;mix-blend-mode:screen;fill:url(#g76)}.ay{opacity:.3;mix-blend-mode:screen;fill:url(#g77)}.az{opacity:.3;mix-blend-mode:screen;fill:url(#g78)}.aA{fill:url(#g79)}.aB{fill:url(#g80)}.aC{mix-blend-mode:multiply;fill:#bcbec0}.aD{fill:url(#g81)}.aE{mix-blend-mode:screen;fill:url(#g82)}.aF{mix-blend-mode:color-dodge;fill:url(#g83)}.aG{fill:url(#g84)}.aH{opacity:.8;fill:url(#g85)}.aI{opacity:.8;fill:url(#g86)}.aJ{opacity:.8;fill:url(#g87)}.aK{opacity:.8;fill:url(#g88)}.aL{fill:#b086cc}.aM{opacity:.9;fill:url(#g89)}.aN{mix-blend-mode:screen;fill:url(#g90)}.aO{mix-blend-mode:screen;fill:url(#g91)}.aP{mix-blend-mode:screen;fill:url(#g92)}.aQ{mix-blend-mode:screen;fill:url(#g93)}.aR{mix-blend-mode:screen;fill:url(#g94)}.aS{fill:url(#g95)}.aT{fill:url(#g96)}.aU{fill:url(#g97)}.aV{fill:url(#g98)}.aW{fill:url(#g99)}.aX{fill:url(#g100)}.aY{fill:url(#g101)}.aZ{fill:url(#g102)}.b0{fill:url(#g103)}.b1{fill:url(#g104)}.b2{fill:url(#g105)}.b3{fill:url(#g106)}.b4{fill:url(#g107)}.b5{fill:url(#g108)}.b6{fill:url(#g109)}.b7{fill:url(#g110)}.b8{fill:url(#g111)}.b9{fill:url(#g112)}.ba{fill:url(#g113)}.bb{fill:url(#g114)}.bc{fill:url(#g115)}.bd{fill:url(#g116)}.be{fill:url(#g117)}.bf{fill:url(#g118)}.bg{fill:url(#g119)}.bh{fill:url(#g120)}.bi{fill:url(#g121)}.bj{fill:url(#g122)}.bk{fill:url(#g123)}.bl{fill:url(#g124)}.bm{fill:url(#g125)}.bn{fill:url(#g126)}.bo{fill:url(#g127)}.bp{fill:url(#g128)}.bq{fill:url(#g129)}.br{fill:url(#g130)}.bs{fill:url(#g131)}.bt{fill:url(#g132)}.bu{fill:url(#g133)}.bv{fill:url(#g134)}.bw{fill:url(#g135)}.bx{fill:url(#g136)}.by{fill:url(#g137)}.bz{fill:url(#g138)}.bA{fill:url(#g139)}.bB{fill:url(#g140)}.bC{fill:url(#g141)}.bD{fill:url(#g142)}.bE{fill:url(#g143)}.bF{fill:url(#g144)}.bG{fill:url(#g145)}.bH{fill:url(#g146)}.bI{fill:url(#g147)}.bJ{fill:url(#g148)}.bK{fill:url(#g149)}.bL{fill:url(#g150)}.bM{fill:url(#g151)}.bN{fill:url(#g152)}.bO{fill:url(#g153)}.bP{fill:url(#g154)}.bQ{fill:url(#g155)}.bR{fill:url(#g156)}.bS{fill:url(#g157)}.bT{fill:url(#g158)}.bU{fill:url(#g159)}.bV{fill:url(#g160)}.bW{fill:url(#g161)}.bX{fill:url(#g162)}.bY{fill:url(#g163)}.bZ{fill:url(#g164)}.c0{fill:url(#g165)}.c1{fill:url(#g166)}.c2{fill:url(#g167)}.c3{fill:url(#g168)}.c4{fill:url(#g169)}.c5{fill:url(#g170)}.c6{fill:url(#g171)}.c7{opacity:0;fill:url(#g172)}.c8{opacity:.1;fill:url(#g173)}.c9{opacity:.2;fill:url(#g174)}.ca{opacity:.3;fill:url(#g175)}.cb{opacity:.4;fill:url(#g176)}.cc{opacity:.5;fill:url(#g177)}.cd{opacity:.5;fill:url(#g178)}.ce{opacity:.6;fill:url(#g179)}.cf{opacity:.7;fill:url(#g180)}.cg{opacity:.8;fill:url(#g181)}.ch{opacity:.9;fill:url(#g182)}.ci{fill:url(#g183)}.cj{opacity:.8;fill:url(#g184)}.ck{mix-blend-mode:color-dodge;fill:url(#g185)}.cl{fill:url(#g186)}.cm{fill:url(#g187)}.cn{fill:url(#g188)}.co{fill:url(#g189)}.cp{fill:url(#g190)}.cq{fill:url(#g191)}.cr{fill:url(#g192)}.cs{fill:url(#g193)}.ct{fill:url(#g194)}.cu{fill:url(#g195)}.cv{fill:url(#g196)}.cw{fill:url(#g197)}.cx{fill:url(#g198)}.cy{fill:url(#g199)}.cz{fill:url(#g200)}.cA{fill:url(#g201)}.cB{fill:url(#g202)}.cC{fill:url(#g203)}.cD{fill:url(#g204)}.cE{fill:url(#g205)}.cF{fill:url(#g206)}.cG{fill:url(#g207)}.cH{fill:url(#g208)}.cI{fill:url(#g209)}.cJ{fill:url(#g210)}.cK{fill:url(#g211)}.cL{fill:url(#g212)}.cM{fill:url(#g213)}.cN{fill:url(#g214)}.cO{fill:url(#g215)}.cP{fill:url(#g216)}.cQ{fill:url(#g217)}.cR{fill:url(#g218)}.cS{fill:url(#g219)}.cT{fill:url(#g220)}.cU{fill:url(#g221)}.cV{fill:url(#g222)}.cW{fill:url(#g223)}.cX{fill:url(#g224)}.cY{fill:url(#g225)}.cZ{fill:url(#g226)}.d0{fill:url(#g227)}.d1{fill:url(#g228)}.d2{fill:url(#g229)}.d3{fill:url(#g230)}.d4{fill:url(#g231)}.d5{fill:url(#g232)}.d6{fill:url(#g233)}.d7{fill:url(#g234)}.d8{fill:url(#g235)}.d9{fill:url(#g236)}.da{fill:url(#g237)}.db{fill:url(#g238)}.dc{fill:url(#g239)}.dd{fill:url(#g240)}.de{fill:url(#g241)}.df{fill:url(#g242)}.dg{fill:url(#g243)}.dh{fill:url(#g244)}.di{fill:url(#g245)}.dj{fill:url(#g246)}.dk{fill:url(#g247)}.dl{fill:url(#g248)}.dm{fill:url(#g249)}.dn{fill:url(#g250)}.do{fill:url(#g251)}.dp{fill:url(#g252)}.dq{fill:url(#g253)}.dr{fill:url(#g254)}.ds{fill:url(#g255)}.dt{fill:url(#g256)}.du{fill:url(#g257)}.dv{fill:url(#g258)}.dw{fill:url(#g259)}.dx{fill:url(#g260)}.dy{fill:url(#g261)}.dz{fill:url(#g262)}.dA{fill:url(#g263)}.dB{fill:url(#g264)}.dC{fill:url(#g265)}.dD{fill:url(#g266)}.dE{fill:url(#g267)}.dF{fill:url(#g268)}.dG{fill:url(#g269)}.dH{fill:url(#g270)}.dI{fill:url(#g271)}.dJ{fill:url(#g272)}.dK{fill:url(#g273)}.dL{fill:url(#g274)}.dM{fill:url(#g275)}.dN{fill:url(#g276)}.dO{fill:url(#g277)}.dP{fill:url(#g278)}.dQ{fill:url(#g279)}.dR{fill:url(#g280)}.dS{opacity:.8;fill:url(#g281)}.dT{fill:url(#g282)}.dU{fill:url(#g283)}.dV{fill:url(#g284)}.dW{fill:url(#g285)}.dX{fill:url(#g286)}.dY{fill:url(#g287)}.dZ{fill:url(#g288)}.e0{fill:url(#g289)}.e1{fill:url(#g290)}.e2{fill:url(#g291)}.e3{fill:url(#g292)}.e4{fill:url(#g293)}.e5{fill:url(#g294)}.e6{fill:url(#g295)}.e7{fill:url(#g296)}.e8{fill:url(#g297)}.e9{fill:url(#g298)}.ea{fill:url(#g299)}.eb{fill:url(#g300)}.ec{fill:url(#g301)}.ed{fill:url(#g302)}.ee{fill:url(#g303)}.ef{fill:url(#g304)}.eg{fill:url(#g305)}.eh{fill:url(#g306)}.ei{opacity:.3;mix-blend-mode:color-dodge;fill:#7c1dc9}.ej{fill:#7c1dc9}.ek{opacity:.8;mix-blend-mode:color-dodge;fill:#7c1dc9}.el{opacity:.6;mix-blend-mode:color-dodge;fill:#7c1dc9}.em{opacity:.4;mix-blend-mode:color-dodge;fill:#7c1dc9}.en{opacity:.1;mix-blend-mode:color-dodge;fill:#7c1dc9}.eo{opacity:0;fill:url(#g307)}.ep{opacity:.1;fill:url(#g308)}.eq{opacity:.2;fill:url(#g309)}.er{opacity:.3;fill:url(#g310)}.es{opacity:.4;fill:url(#g311)}.et{opacity:.5;fill:url(#g312)}.eu{opacity:.5;fill:url(#g313)}.ev{opacity:.6;fill:url(#g314)}.ew{opacity:.7;fill:url(#g315)}.ex{opacity:.8;fill:url(#g316)}.ey{opacity:.9;fill:url(#g317)}.ez{fill:url(#g318)}.eA{opacity:.8;fill:url(#g319)}.eB{mix-blend-mode:color-dodge;fill:url(#g320)}.eC{opacity:.6;fill:url(#g321)}.eD{opacity:.6;fill:url(#g322)}.eE{opacity:.6;fill:url(#g323)}.eF{opacity:.6;fill:url(#g324)}.eG{opacity:.6;fill:url(#g325)}.eH{opacity:.6;fill:url(#g326)}.eI{opacity:.9;fill:url(#g327)}.eJ{fill:url(#g328)}.eK{fill:url(#g329)}.eL{fill:url(#g330)}.eM{fill:url(#g331)}.eN{fill:url(#g332)}.eO{opacity:.8;fill:url(#g333)}.eP{opacity:.6;fill:url(#g334)}.eQ{fill:url(#g335)}.eR{fill:url(#g336)}.eS{opacity:.5;mix-blend-mode:color-dodge;fill:#9f19ab}.eT{mix-blend-mode:color-dodge;fill:#7c1dc9}.eU{mix-blend-mode:color-dodge;fill:url(#g337)}.eV{fill:url(#g338)}.eW{fill:url(#g339)}.eX{fill:url(#g340)}.eY{fill:url(#g341)}.eZ{fill:url(#g342)}.f0{fill:url(#g343)}.f1{mix-blend-mode:screen;fill:url(#g344)}.f2{fill:url(#g345)}.f3{fill:url(#g346)}.f4{fill:url(#g347)}.f5{fill:url(#g348)}.f6{fill:url(#g349)}.f7{fill:url(#g350)}.f8{fill:url(#g351)}.f9{fill:url(#g352)}.fa{fill:url(#g353)}.fb{fill:url(#g354)}.fc{fill:url(#g355)}.fd{fill:url(#g356)}.fe{fill:url(#g357)}.ff{fill:url(#g358)}.fg{fill:url(#g359)}.fh{fill:url(#g360)}.fi{fill:url(#g361)}.fj{fill:url(#g362)}.fk{fill:url(#g363)}.fl{fill:url(#g364)}.fm{fill:url(#g365)}.fn{fill:url(#g366)}.fo{fill:url(#g367)}.fp{fill:url(#g368)}.fq{fill:url(#g369)}.fr{fill:url(#g370)}.fs{fill:url(#g371)}.ft{fill:url(#g372)}.fu{fill:url(#g373)}.fv{fill:url(#g374)}.fw{fill:url(#g375)}.fx{fill:url(#g376)}.fy{fill:url(#g377)}.fz{fill:url(#g378)}.fA{fill:url(#g379)}.fB{fill:url(#g380)}.fC{fill:url(#g381)}.fD{fill:url(#g382)}.fE{fill:url(#g383)}.fF{fill:url(#g384)}.fG{fill:url(#g385)}.fH{fill:url(#g386)}.fI{fill:url(#g387)}.fJ{fill:url(#g388)}.fK{fill:url(#g389)}.fL{fill:url(#g390)}.fM{fill:url(#g391)}.fN{fill:url(#g392)}.fO{fill:url(#g393)}.fP{fill:url(#g394)}.fQ{fill:url(#g395)}.fR{fill:url(#g396)}.fS{fill:url(#g397)}.fT{fill:url(#g398)}.fU{fill:url(#g399)}.fV{fill:url(#g400)}.fW{fill:url(#g401)}.fX{fill:url(#g402)}.fY{fill:url(#g403)}.fZ{fill:url(#g404)}.g0{fill:url(#g405)}.g1{fill:url(#g406)}.g2{fill:url(#g407)}.g3{fill:url(#g408)}.g4{fill:url(#g409)}.g5{opacity:.7;mix-blend-mode:color-dodge;fill:#7c1dc9}.g6{opacity:.5;mix-blend-mode:color-dodge;fill:#7c1dc9}.g7{fill:#fff}.g8{opacity:.9;fill:url(#g410)}.g9{opacity:.9;fill:url(#g411)}.ga{opacity:.9;fill:url(#g412)}")), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m380.7 639.7c-10 0-19-2.1-26.1-6.2l-275.5-159.1c-9.5-5.5-14.9-14.2-14.9-23.8 0-10.6 6.5-20.4 17.9-27l156.4-90.3c9-5.2 20.2-8 31.6-8 9.9 0 18.9 2.2 26 6.3l275.6 159c9.5 5.5 14.9 14.2 14.9 23.8 0 10.6-6.6 20.4-18 27l-156.4 90.3c-8.9 5.2-20.1 8-31.5 8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m239.2 334.5c9-5.2 20.2-7.9 31.5-7.8 4.6 0.1 8.9 0.6 12.9 1.6 4.4 1 9.4 3 12.9 5.1l274.5 158.4c9.4 5.5 14.3 14.1 13.8 23.5-0.2 2.6-0.8 5.1-1.7 7.6-2.4 6.7-9.2 13.8-16.9 18.3l-154.1 89c-2 1.1-4.6 2.4-6.7 3.3-7.5 3.1-15.9 4.8-24.4 4.8-9.8 0.1-18.7-2-25.7-6l-275.5-159.1c-9.5-5.5-14.4-14.2-13.8-23.5 0.2-2.3 0.7-4.5 1.3-6.6 2.3-7.1 9.3-14.7 17.4-19.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m239.9 335.7c8.9-5.2 20.3-7.8 31.4-7.6 4.5 0.1 8.8 0.8 12.8 1.8 3.9 1 9.6 3.4 12.7 5.3l273.5 157.8c9.4 5.4 13.8 14 12.6 23.2-0.3 2.5-1.1 4.8-2 7.2-2.3 6-10.1 13.6-17.1 17.6l-151.9 87.7c-1.8 1-4.7 2.5-6.6 3.3-7.3 3.1-15.6 4.9-24 4.9-9.6 0.1-18.4-1.9-25.3-5.8l-275.5-159.1c-9.5-5.5-13.8-14.1-12.6-23.3 0.3-2.1 1-4.2 1.7-6.2 2.2-6.4 10.3-14.4 17.6-18.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m240.6 336.9c8.9-5.1 20.3-7.7 31.3-7.4 4.5 0.2 8.8 1 12.7 2.1 3.5 0.9 9.8 3.7 12.6 5.4l272.4 157.2c9.4 5.4 13.3 14 11.5 22.9-0.4 2.3-1.4 4.6-2.4 6.9-2.2 5.2-11.1 13.2-17.3 16.8l-149.7 86.4c-1.6 0.9-4.8 2.6-6.5 3.3-7.1 3.1-15.3 4.9-23.5 5.1-9.5 0.1-18.3-1.8-25-5.7l-275.5-159.1c-9.5-5.4-13.3-14.1-11.4-23 0.4-2.1 1.2-4 2-6 2.2-5.5 11.5-14.1 18-17.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m241.3 338.1c8.9-5.1 20.3-7.6 31.2-7.1 4.5 0.2 8.7 1.1 12.6 2.2 3 0.8 10 4.1 12.5 5.6l271.3 156.6c9.3 5.4 12.8 13.9 10.4 22.6-0.6 2.2-1.8 4.3-2.8 6.5-2.1 4.5-12.1 13-17.5 16.1l-147.5 85.2c-1.4 0.7-4.8 2.6-6.3 3.2-7.1 3.1-15.1 5-23.2 5.2-9.3 0.2-18-1.7-24.6-5.5l-275.5-159.1c-9.4-5.4-12.8-14-10.2-22.8 0.5-1.9 1.5-3.7 2.4-5.6 2-4.8 12.5-13.8 18.2-17.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m242 339.3c8.8-5.1 20.3-7.6 31.1-6.9 4.5 0.3 8.7 1.3 12.5 2.4 2.6 0.8 10.2 4.5 12.3 5.7l270.3 156.1c9.3 5.4 12.3 13.8 9.3 22.3-0.8 2.1-2.1 4-3.2 6.2-2 3.8-13.1 12.6-17.7 15.3l-145.3 83.9c-1.2 0.6-4.9 2.7-6.2 3.2-6.9 3.1-14.8 5-22.8 5.3-9.1 0.2-17.7-1.6-24.2-5.3l-275.6-159.1c-9.3-5.4-12.2-14-9-22.5 0.7-1.8 1.9-3.5 2.8-5.3 1.9-4.1 13.7-13.6 18.5-16.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m242.7 340.5c8.8-5.1 20.3-7.5 31-6.7 4.5 0.3 8.6 1.5 12.4 2.7 2.1 0.6 10.4 4.8 12.2 5.8l269.2 155.5c9.2 5.3 11.8 13.7 8.2 22-0.9 1.9-2.1 3.9-3.6 5.8-1.1 3.4-14.1 12.4-17.9 14.6l-143.1 82.6c-0.9 0.5-5 2.8-6.1 3.2-6.7 3-14.5 5.1-22.3 5.4-9 0.3-17.5-1.4-23.9-5.1l-275.6-159.1c-9.3-5.4-11.7-13.9-7.8-22.2 0.8-1.8 1.8-3.5 3.1-5.1 1-3.6 14.8-13.2 18.9-15.6z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m243.3 341.7c8.9-5.1 20.5-7.4 31-6.5 4.5 0.4 8.5 1.7 12.3 2.9 1.7 0.6 10.6 5.2 12 6l268.2 154.9c9.2 5.3 11.4 13.7 7 21.7-1 1.8-2.2 3.7-3.9 5.4-0.9 2.7-15 12.1-18.1 13.9l-140.9 81.3c-0.7 0.4-5.1 2.9-6 3.2-6.6 3-14.2 5.2-21.9 5.5-8.8 0.4-17.3-1.3-23.5-4.9l-275.6-159.1c-9.3-5.4-11.3-13.9-6.6-22 0.9-1.6 2-3.2 3.5-4.7 0.8-2.9 15.9-13 19.1-14.8z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m244 342.9c8.8-5.1 20.5-7.3 30.9-6.3 4.5 0.5 8.5 1.9 12.2 3.2 1.2 0.4 10.9 5.5 11.9 6.1l267.2 154.3c9.1 5.3 10.8 13.6 5.8 21.3-1.1 1.8-2.5 3.5-4.3 5.2-0.7 2-16 11.7-18.3 13.1l-138.6 80c-0.6 0.3-5.3 2.9-5.9 3.2-6.5 3-14 5.2-21.6 5.6-8.7 0.4-17-1.1-23.2-4.7l-275.5-159.1c-9.3-5.4-10.9-13.9-5.4-21.7 1-1.5 2.3-3.1 3.8-4.5 0.6-2.1 17-12.6 19.5-14z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m244.7 344.1c8.8-5.1 20.5-7.2 30.8-6 4.5 0.5 8.4 2 12.1 3.3 0.8 0.3 11.1 5.9 11.8 6.3l266.1 153.7c9 5.2 10.4 13.6 4.7 21-1.3 1.7-2.8 3.3-4.7 4.8-0.5 1.4-17 11.5-18.5 12.4l-136.4 78.7c-0.4 0.3-5.4 3-5.8 3.2-6.3 3-13.7 5.3-21.1 5.7-8.6 0.5-16.8-1-22.9-4.5l-275.5-159.1c-9.3-5.3-10.5-13.9-4.3-21.5 1.2-1.4 2.6-2.8 4.3-4.1 0.4-1.4 18.1-12.3 19.7-13.3z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m245.4 345.3c8.8-5.1 20.5-7.1 30.7-5.8 4.4 0.5 8.3 2.2 12 3.5 0.4 0.2 11.3 6.3 11.6 6.5l265.1 153.1c9 5.2 10 13.6 3.6 20.7-1.4 1.6-3.1 3.1-5.2 4.4-0.2 0.7-17.9 11.2-18.6 11.7l-134.2 77.4c-0.2 0.2-5.5 3.2-5.7 3.3-6.2 2.9-13.4 5.3-20.7 5.7-8.4 0.5-16.6-0.9-22.5-4.3l-275.5-159.1c-9.3-5.3-10.1-13.9-3.1-21.2 1.3-1.3 2.8-2.6 4.6-3.8 0.2-0.8 19.2-12.1 20-12.6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m362.2 620.3l-275.5-159.1c-10.9-6.2-9.5-17.2 3-24.5l156.4-90.3c12.6-7.2 31.6-8 42.4-1.7l275.6 159.1c10.9 6.2 9.5 17.2-3.1 24.5l-156.3 90.3c-12.6 7.2-31.6 8-42.5 1.7z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m362.2 620.1l-275.5-159.1c-4.9-2.8-7.3-6.5-7.4-10.5 0-0.1 0-13.5 0-13.6 0.1-4.8 3.6 3.5 10.4-0.4l156.4-90.3c12.6-7.3 31.6-8 42.4-1.8l275.6 159.1c3.6 2.1 6.2-6.8 7.2-4 0.3 1 0.1 13.5 0.1 14.4 0.1 4.9-3.4 10.1-10.4 14.1l-156.3 90.3c-12.6 7.3-31.6 8-42.5 1.8z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "m362.2 606.7l-275.5-159.1c-10.9-6.3-9.5-17.3 3-24.5l156.4-90.3c12.6-7.3 31.6-8 42.4-1.8l275.6 159.1c10.9 6.3 9.5 17.3-3.1 24.5l-156.3 90.3c-12.6 7.3-31.6 8-42.5 1.8z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m571.4 518.1c0 4.8-3.5 9.9-10.4 13.9l-156.3 90.2c-12.6 7.3-31.6 8.1-42.5 1.8l-275.5-159.1c-5.3-3-7.7-7.2-7.3-11.4q-0.1 0.3-0.1 0.7c0 0.1 0 13.5 0 13.7 0.1 3.9 2.5 7.6 7.4 10.4l275.5 159.1c10.9 6.3 29.9 5.5 42.5-1.8l156.3-90.2c7-4.1 10.5-9.2 10.4-14.1 0-0.8 0.1-9.8 0-13.2z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m380.7 605.4c-6.3 0-11.8-1.2-15.7-3.5l-275.6-159.1c-1.7-1-4.6-3-4.6-5.9 0-2.9 2.9-6.3 7.7-9.1l156.4-90.2c5.7-3.4 13.5-5.3 21.2-5.3 6.2 0 11.8 1.2 15.7 3.5l275.5 159.1c1.7 1 4.6 3.1 4.6 5.9 0 2.9-2.8 6.3-7.6 9.1l-156.4 90.2c-5.8 3.4-13.5 5.3-21.2 5.3z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "m561 512.4l-156.3 90.2c-12.6 7.3-31.6 8.1-42.5 1.8l-275.5-159.1c-4.5-2.6-6.9-6-7.3-9.6-0.5 4.4 1.8 8.7 7.3 11.9l275.5 159.1c10.9 6.2 29.9 5.5 42.5-1.8l156.3-90.3c7.4-4.2 10.9-9.7 10.3-14.8-0.5 4.4-4 8.9-10.3 12.6z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m304.9 367.6c7.3 21.3-15.9 48.5-51.8 60.8-35.9 12.4-71 5.2-78.3-16-7.3-21.2 16-48.4 51.9-60.8 35.9-12.3 70.9-5.2 78.2 16z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "m411.2 548.1l-223.8-129.2c-4.4-2.6-3.9-7.1 1.3-10.1l84-48.5c5.2-3 13-3.3 17.5-0.7l223.7 129.2c4.5 2.5 3.9 7.1-1.2 10l-84 48.5c-5.2 3-13 3.4-17.5 0.8z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "r",
    d: "m277.6 365.9c1.8-1 4.7-1 6.6 0l14.3 8.3c1.8 1.1 1.8 2.8 0 3.8-1.8 1.1-4.7 1.1-6.6 0l-14.3-8.3c-1.8-1-1.8-2.7 0-3.8zm24.5 14.2c1.8-1 4.8-1 6.6 0l6.8 3.9c1.8 1.1 1.8 2.8 0 3.8-1.8 1.1-4.7 1.1-6.6 0l-6.8-3.9c-1.8-1-1.8-2.7 0-3.8zm17 9.8c1.8-1 4.8-1 6.6 0l6.8 4c1.8 1 1.8 2.7 0 3.8-1.8 1-4.7 1-6.6-0.1l-6.8-3.9c-1.8-1-1.8-2.7 0-3.8zm17 9.8c1.8-1 4.8-1 6.6 0.1l6.8 3.9c1.8 1 1.8 2.7 0 3.8-1.8 1-4.7 1-6.6 0l-6.8-4c-1.8-1-1.8-2.7 0-3.8zm17 9.9c1.8-1.1 4.8-1.1 6.6 0l6.8 3.9c1.8 1 1.8 2.7 0 3.8-1.8 1-4.7 1-6.6 0l-6.8-3.9c-1.8-1.1-1.8-2.8 0-3.8zm17 9.8c1.8-1.1 4.8-1.1 6.6 0l6.8 3.9c1.8 1.1 1.8 2.8 0 3.8-1.8 1.1-4.7 1-6.6 0l-6.8-3.9c-1.8-1.1-1.8-2.8 0-3.8zm17 9.8c1.8-1.1 4.8-1 6.6 0l6.8 3.9c1.8 1.1 1.8 2.8 0 3.8-1.8 1.1-4.7 1.1-6.6 0l-6.7-3.9c-1.9-1.1-1.9-2.8-0.1-3.8zm17 9.8c1.8-1 4.8-1 6.6 0l6.8 3.9c1.8 1.1 1.8 2.8 0 3.8-1.8 1.1-4.7 1.1-6.6 0l-6.7-3.9c-1.9-1-1.9-2.7-0.1-3.8zm17 9.8c1.8-1 4.8-1 6.6 0l6.8 4c1.8 1 1.8 2.7 0 3.8-1.8 1-4.7 1-6.6-0.1l-6.7-3.9c-1.9-1-1.9-2.7-0.1-3.8zm17 9.8c1.9-1 4.8-1 6.6 0.1l6.8 3.9c1.8 1 1.8 2.7 0 3.8-1.8 1-4.7 1-6.5 0l-6.8-4c-1.9-1-1.9-2.7-0.1-3.8zm17 9.9c1.9-1.1 4.8-1.1 6.6 0l6.8 3.9c1.8 1 1.8 2.7 0 3.8-1.8 1-4.7 1-6.5 0l-6.8-3.9c-1.9-1.1-1.9-2.8-0.1-3.8zm17 9.8c1.9-1.1 4.8-1.1 6.6 0l6.8 3.9c1.8 1.1 1.9 2.8 0 3.8-1.8 1.1-4.7 1-6.5 0l-6.8-3.9c-1.9-1.1-1.9-2.8-0.1-3.8zm17.4 10c1.8-1.1 4.8-1 6.6 0l6.8 3.9c1.8 1.1 1.8 2.8 0 3.8-1.8 1.1-4.8 1.1-6.6 0l-6.8-3.9c-1.8-1.1-1.8-2.8 0-3.8zm-227.2-113.5l5.8-3.4c2.1-1.2 5.4-1.2 7.5 0l5.9 3.4c2.1 1.2 2.1 3.1 0 4.3l-5.8 3.4c-2.1 1.2-5.4 1.2-7.5 0l-5.9-3.4c-2.1-1.2-2.1-3.1 0-4.3zm22.9 17.5l-5.9-3.4c-2.1-1.2-2.1-3.1 0-4.3l5.8-3.4c2.1-1.2 5.4-1.2 7.5 0l5.9 3.4c2.1 1.2 2.1 3.2 0 4.3l-5.8 3.4c-2.1 1.2-5.4 1.2-7.5 0zm11.1 2.1l5.8-3.4c2.1-1.2 5.4-1.2 7.5 0l5.9 3.4c2.1 1.2 2.1 3.2 0 4.4l-5.8 3.3c-2.1 1.2-5.4 1.2-7.5 0l-5.9-3.4c-2.1-1.2-2.1-3.1 0-4.3zm17 9.8l5.8-3.4c2.1-1.1 5.4-1.1 7.5 0.1l5.9 3.4c2.1 1.1 2.1 3.1 0 4.3l-5.8 3.3c-2.1 1.2-5.4 1.2-7.5 0l-5.9-3.4c-2.1-1.2-2.1-3.1 0-4.3zm36.2 14.2l-5.8 3.4c-2.1 1.2-5.4 1.2-7.5 0l-5.9-3.4c-2.1-1.2-2.1-3.2 0-4.4l5.8-3.3c2.1-1.2 5.4-1.2 7.5 0l5.9 3.4c2.1 1.2 2.1 3.1 0 4.3zm17 9.8l-5.8 3.4c-2.1 1.2-5.4 1.2-7.5 0l-5.9-3.4c-2.1-1.2-2.1-3.2 0-4.4l5.8-3.3c2.1-1.2 5.4-1.2 7.5 0l5.9 3.4c2.1 1.2 2.1 3.1 0 4.3zm17 9.8l-5.8 3.4c-2.1 1.2-5.4 1.2-7.5 0l-5.9-3.4c-2.1-1.2-2.1-3.1 0-4.3l5.8-3.4c2.1-1.2 5.4-1.2 7.5 0l5.9 3.4c2.1 1.2 2.1 3.1 0 4.3zm17 9.8l-5.8 3.4c-2.1 1.2-5.4 1.2-7.5 0l-5.9-3.4c-2.1-1.2-2.1-3.1 0-4.3l5.8-3.4c2.1-1.2 5.5-1.2 7.5 0l5.9 3.4c2.1 1.2 2.1 3.2 0 4.3zm17 9.9l-5.8 3.3c-2.1 1.2-5.4 1.2-7.5 0l-5.9-3.4c-2.1-1.2-2.1-3.1 0-4.3l5.8-3.4c2.1-1.2 5.5-1.2 7.5 0l5.9 3.4c2.1 1.2 2.1 3.2 0 4.4zm17 9.8l-5.8 3.3c-2.1 1.2-5.4 1.2-7.5 0l-5.9-3.4c-2.1-1.2-2.1-3.1 0-4.3l5.8-3.4c2.1-1.1 5.5-1.1 7.5 0.1l5.9 3.3c2.1 1.2 2.1 3.2 0 4.4zm-2.2 5.4l5.8-3.3c2.1-1.2 5.5-1.2 7.5 0l5.9 3.4c2.1 1.2 2.1 3.1 0 4.3l-5.8 3.4c-2.1 1.2-5.4 1.1-7.5 0l-5.9-3.4c-2.1-1.2-2.1-3.2 0-4.4zm36.2 14.2l-5.8 3.4c-2.1 1.2-5.4 1.2-7.5 0l-5.9-3.4c-2-1.2-2.1-3.2 0-4.4l5.8-3.3c2.1-1.2 5.5-1.2 7.5 0l5.9 3.4c2.1 1.2 2.1 3.1 0 4.3zm24.9 14.4l-5.8 3.4c-2.1 1.1-5.4 1.1-7.5-0.1l-13.4-7.7c-2.1-1.2-2.1-3.1 0-4.3l5.8-3.4c2.1-1.2 5.4-1.2 7.5 0l13.4 7.8c2.1 1.2 2.1 3.1 0 4.3zm-246.9-117.6l5.9-3.4c2-1.2 5.4-1.2 7.5 0l13.4 7.8c2.1 1.1 2.1 3.1 0 4.3l-5.8 3.3c-2.1 1.2-5.4 1.2-7.5 0l-13.5-7.7c-2-1.2-2-3.2 0-4.3zm24.6 14.1l5.8-3.3c2.1-1.2 5.4-1.2 7.5 0l5.9 3.4c2.1 1.2 2.1 3.1 0 4.3l-5.8 3.4c-2.1 1.2-5.4 1.1-7.5 0l-5.9-3.4c-2.1-1.2-2.1-3.2 0-4.4zm17 14.2c-2.1-1.2-2.1-3.2 0-4.4l5.8-3.3c2.1-1.2 5.4-1.2 7.5 0l5.9 3.4c2.1 1.2 2.1 3.1 0 4.3l-5.8 3.4c-2.1 1.2-5.4 1.2-7.5 0zm17 9.8c-2.1-1.2-2.1-3.1 0-4.3l5.8-3.4c2.1-1.2 5.4-1.2 7.5 0l5.9 3.4c2 1.2 2.1 3.1 0 4.3l-5.8 3.4c-2.1 1.2-5.5 1.2-7.5 0zm30.3 2.1l5.9 3.4c2 1.2 2 3.1 0 4.3l-5.9 3.4c-2 1.2-5.4 1.2-7.5 0l-5.8-3.4c-2.1-1.2-2.1-3.1-0.1-4.3l5.9-3.4c2-1.2 5.4-1.2 7.5 0zm16.6 9.6l6.6 3.8c1.9 1.1 1.9 2.9 0 3.9l-6.5 3.8c-1.9 1.1-4.9 1.1-6.8 0l-6.6-3.8c-1.9-1.1-1.9-2.8 0-3.9l6.5-3.8c1.9-1.1 4.9-1.1 6.8 0zm26.6 74.8l-5.7 3.2c-2.1 1.3-5.5 1.2-7.6 0l-107.8-62.2c-2.1-1.2-2.1-3.2 0-4.4l5.7-3.3c2.1-1.2 5.5-1.2 7.6 0l107.8 62.2c2.1 1.3 2.1 3.2 0 4.5zm7.4-55.1l6.6 3.8c1.9 1 1.9 2.8 0 3.9l-6.5 3.8c-1.9 1-4.9 1-6.8-0.1l-6.6-3.8c-1.9-1-1.9-2.8 0-3.9l6.6-3.8c1.8-1 4.8-1 6.7 0.1zm17 9.8l6.6 3.8c1.9 1.1 1.9 2.8 0.1 3.9l-6.6 3.8c-1.9 1.1-4.9 1-6.8 0l-6.6-3.8c-1.9-1.1-1.9-2.9 0-4l6.6-3.7c1.8-1.1 4.9-1.1 6.7 0zm17 9.8l6.6 3.8c1.9 1.1 1.9 2.8 0.1 3.9l-6.6 3.8c-1.9 1.1-4.9 1.1-6.8 0l-6.6-3.8c-1.9-1.1-1.9-2.9 0-3.9l6.6-3.8c1.8-1.1 4.9-1.1 6.7 0zm10.3 21.3l-6.6-3.8c-1.9-1.1-1.9-2.8 0-3.9l6.6-3.8c1.8-1.1 4.9-1.1 6.7 0l6.6 3.8c1.9 1.1 1.9 2.8 0.1 3.9l-6.6 3.8c-1.9 1.1-4.9 1.1-6.8 0zm17 9.8l-6.6-3.8c-1.9-1.1-1.9-2.8 0-3.9l6.6-3.8c1.8-1.1 4.9-1.1 6.7 0l6.6 3.8c1.9 1.1 1.9 2.9 0.1 3.9l-6.6 3.8c-1.9 1.1-4.9 1.1-6.8 0zm30.7 6.3l-6.5 3.7c-1.9 1.1-4.9 1.1-6.8 0l-6.6-3.8c-1.9-1.1-1.9-2.8 0-3.9l6.5-3.8c1.9-1.1 4.9-1 6.8 0l6.6 3.9c1.9 1 1.9 2.8 0 3.9zm-247.6-117.3l6.5-3.7c1.9-1.1 4.9-1.1 6.8 0l21.3 12.3c1.9 1.1 1.9 2.8 0 3.9l-6.5 3.8c-1.9 1.1-4.9 1-6.8 0l-21.3-12.3c-1.9-1.1-1.9-2.9 0-4zm31.7 18.4l6.6-3.8c1.8-1.1 4.9-1.1 6.7 0l6.6 3.8c1.9 1.1 1.9 2.8 0.1 3.9l-6.6 3.8c-1.9 1.1-4.9 1.1-6.8 0l-6.6-3.8c-1.9-1.1-1.9-2.9 0-3.9zm17 9.8l6.6-3.8c1.8-1.1 4.9-1.1 6.7 0l6.6 3.8c1.9 1.1 1.9 2.8 0.1 3.9l-6.6 3.8c-1.9 1.1-4.9 1.1-6.8 0l-6.6-3.8c-1.9-1.1-1.9-2.8 0-3.9zm17 9.8l6.6-3.8c1.8-1.1 4.9-1.1 6.7 0l6.6 3.8c1.9 1.1 1.9 2.9 0.1 3.9l-6.6 3.8c-1.9 1.1-4.9 1.1-6.8 0l-6.6-3.8c-1.9-1.1-1.9-2.8 0-3.9zm23.6 17.5l-6.6-3.8c-1.9-1.1-1.9-2.8 0-3.9l6.6-3.8c1.8-1.1 4.9-1 6.7 0l6.6 3.8c1.9 1.1 1.9 2.9 0.1 4l-6.6 3.7c-1.9 1.1-4.9 1.1-6.8 0zm17 9.8l-6.6-3.8c-1.8-1-1.9-2.8 0-3.9l6.6-3.8c1.8-1 4.9-1 6.7 0l6.6 3.9c1.9 1 1.9 2.8 0.1 3.9l-6.6 3.8c-1.9 1-4.9 1-6.8-0.1zm17 9.9l-6.6-3.8c-1.8-1.1-1.9-2.9 0-4l6.6-3.7c1.8-1.1 4.9-1.1 6.7 0l6.6 3.8c1.9 1.1 1.9 2.8 0.1 3.9l-6.6 3.8c-1.9 1.1-4.9 1-6.8 0zm17 9.8l-6.6-3.8c-1.8-1.1-1.9-2.9 0-3.9l6.6-3.8c1.8-1.1 4.9-1.1 6.7 0l6.6 3.8c1.9 1.1 1.9 2.8 0.1 3.9l-6.6 3.8c-1.9 1.1-4.9 1.1-6.8 0zm17 9.8l-6.6-3.8c-1.8-1.1-1.8-2.8 0-3.9l6.6-3.8c1.8-1.1 4.9-1.1 6.7 0l6.6 3.8c1.9 1.1 1.9 2.8 0.1 3.9l-6.6 3.8c-1.9 1.1-4.9 1.1-6.8 0zm17 9.8l-6.6-3.8c-1.8-1.1-1.8-2.8 0-3.9l6.6-3.8c1.8-1.1 4.9-1.1 6.7 0l6.7 3.8c1.8 1.1 1.8 2.9 0 3.9l-6.6 3.8c-1.9 1.1-4.9 1.1-6.8 0zm10.4 2.1l6.6-3.8c1.8-1.1 4.9-1.1 6.8 0l6.6 3.8c1.8 1.1 1.8 2.9 0 4l-6.6 3.7c-1.8 1.1-4.9 1.1-6.8 0l-6.6-3.8c-1.8-1.1-1.8-2.8 0-3.9zm47.2 19.7l-6.6 3.7c-1.9 1.1-4.9 1.1-6.8 0l-16.8-9.7c-1.8-1-1.8-2.8 0-3.9l6.6-3.8c1.8-1 4.9-1 6.8 0l16.7 9.7c1.9 1.1 1.9 2.9 0.1 4zm-247.6-117.3l5.7-3.3c2.1-1.2 5.5-1.2 7.6 0l30.3 17.5c2.1 1.2 2.1 3.2 0 4.4l-5.7 3.3c-2.1 1.2-5.5 1.2-7.6 0l-30.3-17.5c-2.1-1.2-2.1-3.2 0-4.4zm41.5 24l5.7-3.3c2.1-1.2 5.5-1.2 7.7 0l5.7 3.3c2.1 1.2 2.1 3.2 0 4.4l-5.7 3.3c-2.1 1.2-5.5 1.2-7.6 0l-5.8-3.3c-2.1-1.2-2.1-3.2 0-4.4zm17 9.8l5.7-3.3c2.1-1.2 5.5-1.2 7.7 0l5.7 3.3c2.1 1.3 2.1 3.2 0 4.4l-5.7 3.3c-2.1 1.2-5.5 1.2-7.6 0l-5.8-3.3c-2.1-1.2-2.1-3.2 0-4.4zm17 9.8l5.7-3.3c2.1-1.2 5.5-1.2 7.7 0l5.7 3.3c2.1 1.3 2.1 3.2 0 4.5l-5.7 3.2c-2.1 1.3-5.5 1.3-7.6 0l-5.8-3.3c-2.1-1.2-2.1-3.2 0-4.4zm17 9.8l5.7-3.3c2.1-1.2 5.5-1.2 7.7 0.1l5.7 3.3c2.1 1.2 2.1 3.2 0 4.4l-5.7 3.3c-2.1 1.2-5.5 1.2-7.6-0.1l-5.7-3.3c-2.2-1.2-2.2-3.2-0.1-4.4zm17 9.8l5.7-3.2c2.1-1.3 5.5-1.2 7.7 0l5.7 3.3c2.1 1.2 2.1 3.2 0 4.4l-5.7 3.3c-2.1 1.2-5.5 1.2-7.6 0l-5.7-3.3c-2.2-1.3-2.2-3.2-0.1-4.5zm17 9.9l5.7-3.3c2.1-1.2 5.6-1.2 7.7 0l5.7 3.3c2.1 1.2 2.1 3.2 0 4.4l-5.7 3.3c-2.1 1.2-5.5 1.2-7.6 0l-5.7-3.3c-2.2-1.2-2.2-3.2-0.1-4.4zm17 9.8l5.7-3.3c2.1-1.2 5.6-1.2 7.7 0l5.7 3.3c2.1 1.2 2.1 3.2 0 4.4l-5.7 3.3c-2.1 1.2-5.5 1.2-7.6 0l-5.7-3.3c-2.2-1.2-2.2-3.2-0.1-4.4zm17 9.8l5.7-3.3c2.1-1.2 5.6-1.2 7.7 0l5.7 3.3c2.1 1.3 2.1 3.2 0 4.4l-5.7 3.3c-2.1 1.2-5.5 1.2-7.6 0l-5.7-3.3c-2.2-1.2-2.2-3.2-0.1-4.4zm17 9.8l5.7-3.3c2.1-1.2 5.6-1.2 7.7 0l5.7 3.3c2.1 1.3 2.1 3.2 0 4.5l-5.7 3.2c-2.1 1.3-5.5 1.3-7.6 0l-5.7-3.3c-2.2-1.2-2.2-3.2-0.1-4.4zm17 9.8l5.7-3.3c2.1-1.2 5.6-1.2 7.7 0.1l5.7 3.3c2.1 1.2 2.1 3.2 0 4.4l-5.7 3.3c-2.1 1.2-5.5 1.2-7.6-0.1l-5.7-3.3c-2.2-1.2-2.2-3.2-0.1-4.4zm36.5 14.5l-5.7 3.3c-2.1 1.2-5.5 1.2-7.6 0l-5.8-3.3c-2.1-1.2-2.1-3.2 0-4.4l5.7-3.3c2.1-1.2 5.5-1.2 7.7 0l5.7 3.3c2.1 1.2 2.1 3.2 0 4.4zm-220.1-108.9l-5.7 3.3c-2.1 1.2-5.5 1.2-7.7 0l-13.2-7.7c-2.2-1.2-2.2-3.2-0.1-4.4l5.7-3.3c2.1-1.2 5.6-1.2 7.7 0l13.2 7.7c2.2 1.2 2.2 3.2 0.1 4.4zm17 9.8l-5.7 3.3c-2.1 1.2-5.5 1.2-7.7 0l-5.7-3.3c-2.1-1.2-2.1-3.2 0-4.4l5.7-3.3c2.1-1.2 5.5-1.2 7.6 0l5.8 3.3c2.1 1.2 2.1 3.2 0 4.4zm17 9.8l-5.7 3.3c-2.1 1.2-5.5 1.2-7.7 0l-5.7-3.3c-2.1-1.2-2.1-3.2 0-4.4l5.7-3.3c2.1-1.2 5.5-1.2 7.6 0l5.8 3.3c2.1 1.2 2.1 3.2 0 4.4zm109.4 3.8l6.6 3.8c1.9 1.1 1.9 2.9 0 4l-6.5 3.7c-1.9 1.1-4.9 1.1-6.8 0l-6.6-3.8c-1.9-1.1-1.9-2.8 0-3.9l6.6-3.8c1.8-1.1 4.8-1 6.7 0zm26.6 74.8l-5.7 3.3c-2.1 1.2-5.5 1.2-7.6-0.1l-5.8-3.3c-2.1-1.2-2.1-3.2 0-4.4l5.7-3.3c2.1-1.2 5.5-1.2 7.7 0l5.7 3.4c2.1 1.2 2.1 3.2 0 4.4zm17 9.8l-5.7 3.3c-2.1 1.2-5.5 1.2-7.6 0l-5.8-3.4c-2.1-1.2-2.1-3.2 0-4.4l5.7-3.2c2.1-1.3 5.5-1.3 7.7 0l5.7 3.3c2.1 1.2 2.1 3.2 0 4.4zm17.4 10l-5.7 3.3c-2.1 1.2-5.6 1.2-7.7 0l-5.7-3.3c-2.1-1.3-2.1-3.2 0-4.4l5.7-3.3c2.1-1.2 5.5-1.2 7.6 0l5.7 3.3c2.2 1.2 2.2 3.2 0.1 4.4z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "m290.3 450.2l5.7 3.3c2.1 1.3 5.6 1.3 7.7 0.1l5.6-3.3c1.4-0.8 1.9-1.9 1.5-2.8-0.2 0.5-0.7 1.1-1.5 1.5l-5.6 3.3c-2.1 1.2-5.6 1.2-7.7 0l-5.7-3.3c-0.8-0.5-1.3-1-1.5-1.6-0.3 1 0.2 2.1 1.5 2.8z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "m296.2 435l6.6 3.8c1.8 1.1 4.9 1.1 6.7 0l6.6-3.8c1.2-0.6 1.6-1.6 1.3-2.5-0.2 0.5-0.6 0.9-1.3 1.3l-6.6 3.8c-1.8 1.1-4.9 1.1-6.7 0l-6.6-3.8c-0.7-0.4-1.1-0.9-1.3-1.4-0.4 0.9 0 1.9 1.3 2.6z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "m307.3 460.1l5.7 3.3c2.1 1.2 5.6 1.2 7.7 0l5.7-3.3c1.3-0.8 1.8-1.8 1.4-2.8-0.2 0.5-0.7 1.1-1.4 1.5l-5.7 3.3c-2.1 1.2-5.6 1.2-7.7 0l-5.7-3.3c-0.8-0.4-1.3-1-1.5-1.6-0.3 1 0.2 2.1 1.5 2.9z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "m341.3 479.7l5.7 3.3c2.1 1.2 5.6 1.2 7.7 0l5.7-3.3c1.3-0.7 1.8-1.8 1.4-2.8-0.2 0.6-0.7 1.1-1.4 1.6l-5.7 3.3c-2.1 1.2-5.6 1.2-7.7-0.1l-5.7-3.3c-0.8-0.4-1.3-1-1.5-1.6-0.3 1 0.2 2.1 1.5 2.9z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "m324.3 469.9l5.7 3.3c2.1 1.2 5.6 1.2 7.7 0l5.7-3.3c1.3-0.8 1.8-1.8 1.4-2.8-0.2 0.6-0.7 1.1-1.4 1.6l-5.7 3.2c-2.1 1.3-5.6 1.2-7.7 0l-5.7-3.3c-0.8-0.4-1.3-1-1.5-1.6-0.3 1 0.2 2.1 1.5 2.9z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "m385.4 471.7c-0.2 0.5-0.6 1-1.3 1.4l-6.6 3.8c-1.8 1-4.8 1-6.7-0.1l-6.6-3.8c-0.7-0.4-1.1-0.8-1.3-1.3-0.4 0.9 0.1 1.9 1.3 2.6l6.6 3.8c1.9 1.1 4.9 1.1 6.7 0l6.6-3.8c1.2-0.7 1.6-1.7 1.3-2.6z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "m351.4 452.1c-0.2 0.5-0.6 1-1.3 1.3l-6.6 3.8c-1.8 1.1-4.9 1.1-6.7 0l-6.6-3.8c-0.7-0.4-1.1-0.9-1.3-1.3-0.4 0.9 0 1.8 1.3 2.5l6.6 3.9c1.8 1 4.9 1 6.7 0l6.6-3.8c1.2-0.7 1.6-1.7 1.3-2.6z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "m313.2 444.8l6.6 3.8c1.8 1.1 4.9 1.1 6.7 0.1l6.6-3.8c1.2-0.7 1.6-1.7 1.3-2.6-0.2 0.5-0.6 0.9-1.3 1.3l-6.6 3.8c-1.8 1.1-4.9 1.1-6.7 0l-6.6-3.8c-0.7-0.4-1.1-0.9-1.3-1.4-0.4 0.9 0 1.9 1.3 2.6z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "A",
    d: "m402.4 481.6c-0.2 0.4-0.6 0.9-1.3 1.3l-6.6 3.8c-1.8 1-4.8 1-6.7 0l-6.6-3.9c-0.7-0.3-1.1-0.8-1.3-1.3-0.4 0.9 0.1 1.9 1.3 2.6l6.6 3.8c1.9 1.1 4.9 1.1 6.7 0l6.6-3.8c1.2-0.7 1.6-1.6 1.3-2.5z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "B",
    d: "m388.7 502.6l5.7-3.2c1.3-0.8 1.8-1.9 1.4-2.9-0.2 0.6-0.7 1.2-1.4 1.6l-5.7 3.3c-2.1 1.2-5.6 1.2-7.7 0l-5.7-3.3c-0.8-0.5-1.3-1-1.5-1.6-0.3 1 0.2 2 1.5 2.8l5.7 3.3c2.1 1.2 5.6 1.3 7.7 0z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "C",
    d: "m273.3 440.4l5.7 3.3c2.1 1.2 5.6 1.3 7.7 0l5.6-3.2c1.4-0.8 1.9-1.9 1.5-2.9-0.2 0.6-0.7 1.2-1.5 1.6l-5.6 3.3c-2.1 1.2-5.6 1.2-7.7 0l-5.7-3.3c-0.8-0.5-1.3-1-1.5-1.6-0.3 1 0.1 2 1.5 2.8z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "D",
    d: "m419.4 491.4c-0.2 0.5-0.6 0.9-1.3 1.3l-6.5 3.8c-1.9 1.1-4.9 1.1-6.8 0l-6.6-3.8c-0.7-0.4-1.1-0.9-1.3-1.4-0.4 0.9 0.1 1.9 1.3 2.6l6.6 3.8c1.9 1.1 4.9 1.1 6.8 0l6.5-3.8c1.2-0.6 1.6-1.6 1.3-2.5z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "E",
    d: "m288.1 412.2l5.9 3.4c2.1 1.2 5.4 1.2 7.5 0l5.8-3.4c1.3-0.7 1.8-1.8 1.4-2.8-0.2 0.6-0.6 1.1-1.4 1.6l-5.8 3.3c-2.1 1.2-5.4 1.2-7.5 0l-5.9-3.4c-0.8-0.4-1.2-1-1.4-1.5-0.4 1 0.1 2 1.4 2.8z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "F",
    d: "m368.4 461.9c-0.2 0.5-0.6 1-1.3 1.3l-6.6 3.8c-1.8 1.1-4.9 1.1-6.7 0l-6.6-3.8c-0.7-0.4-1.1-0.8-1.3-1.3-0.4 0.9 0.1 1.9 1.3 2.6l6.6 3.8c1.8 1.1 4.9 1.1 6.7 0l6.6-3.8c1.2-0.7 1.6-1.7 1.3-2.6z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "G",
    d: "m358.3 489.5l5.7 3.3c2.1 1.2 5.6 1.2 7.7 0l5.7-3.3c1.3-0.7 1.8-1.8 1.4-2.8-0.2 0.6-0.7 1.1-1.4 1.6l-5.7 3.3c-2.1 1.2-5.6 1.2-7.7 0l-5.7-3.3c-0.8-0.5-1.3-1.1-1.5-1.6-0.3 1 0.2 2 1.5 2.8z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "H",
    d: "m427.9 478.1c-0.1 0.5-0.6 1-1.2 1.4l-6.6 3.8c-1.8 1-4.9 1-6.7-0.1l-6.6-3.8c-0.7-0.4-1.1-0.8-1.3-1.3-0.4 0.9 0 1.9 1.3 2.6l6.6 3.8c1.8 1.1 4.9 1.1 6.7 0l6.6-3.8c1.2-0.7 1.6-1.7 1.2-2.6z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "I",
    d: "m392.7 459.8l-6.6 3.8c-1.8 1.1-4.9 1.1-6.7 0l-6.6-3.8c-0.7-0.4-1.1-0.9-1.3-1.3-0.4 0.9 0 1.8 1.3 2.5l6.6 3.9c1.8 1 4.9 1 6.7 0l6.6-3.8c1.2-0.7 1.6-1.7 1.2-2.6-0.2 0.5-0.6 1-1.2 1.3z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "J",
    d: "m383.5 436.8l-5.8 3.3c-2.1 1.2-5.4 1.2-7.5 0l-5.9-3.4c-0.7-0.4-1.2-0.9-1.4-1.5-0.4 1 0.1 2 1.4 2.8l5.9 3.4c2.1 1.2 5.4 1.2 7.5 0l5.8-3.4c1.3-0.7 1.8-1.8 1.4-2.8-0.2 0.6-0.6 1.1-1.4 1.6z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "K",
    d: "m366.5 427l-5.8 3.3c-2.1 1.2-5.4 1.2-7.5 0l-5.9-3.4c-0.8-0.4-1.2-1-1.4-1.5-0.4 1 0.1 2 1.4 2.8l5.9 3.4c2.1 1.2 5.4 1.2 7.5 0l5.8-3.4c1.3-0.7 1.8-1.8 1.4-2.8-0.2 0.6-0.6 1.1-1.4 1.6z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "L",
    d: "m417.5 456.4l-5.8 3.4c-2.1 1.2-5.4 1.2-7.5 0l-5.9-3.4c-0.7-0.5-1.2-1-1.4-1.6-0.4 1 0.1 2.1 1.4 2.8l5.9 3.4c2.1 1.2 5.4 1.2 7.5 0l5.8-3.3c1.3-0.8 1.8-1.8 1.5-2.8-0.2 0.5-0.7 1.1-1.5 1.5z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "M",
    d: "m400.5 446.6l-5.8 3.4c-2.1 1.2-5.4 1.1-7.5 0l-5.9-3.4c-0.7-0.5-1.2-1-1.4-1.6-0.4 1 0.1 2 1.4 2.8l5.9 3.4c2.1 1.2 5.4 1.2 7.5 0l5.8-3.4c1.3-0.7 1.8-1.8 1.5-2.7-0.2 0.5-0.7 1.1-1.5 1.5z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "N",
    d: "m349.5 417.1l-5.8 3.4c-2.1 1.2-5.4 1.2-7.5 0l-5.9-3.4c-0.8-0.4-1.2-1-1.4-1.5-0.4 0.9 0.1 2 1.4 2.8l5.9 3.4c2.1 1.2 5.4 1.2 7.5 0l5.8-3.4c1.3-0.8 1.8-1.8 1.4-2.8-0.2 0.6-0.6 1.1-1.4 1.5z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "O",
    d: "m332.5 407.3l-5.8 3.4c-2.1 1.2-5.4 1.2-7.5 0l-5.9-3.4c-0.8-0.4-1.2-1-1.4-1.6-0.4 1 0.1 2.1 1.4 2.8l5.9 3.4c2.1 1.2 5.4 1.2 7.5 0l5.8-3.3c1.3-0.8 1.8-1.8 1.4-2.8-0.2 0.6-0.6 1.1-1.4 1.5z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "P",
    d: "m279.3 388.9l5.9 3.4c2.1 1.2 5.4 1.2 7.5 0l5.8-3.4c1.3-0.7 1.8-1.8 1.4-2.7-0.2 0.5-0.6 1.1-1.4 1.5l-5.8 3.4c-2.1 1.2-5.4 1.2-7.5 0l-5.9-3.4c-0.8-0.5-1.2-1-1.4-1.6-0.4 1 0.1 2 1.4 2.8z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "Q",
    d: "m315.5 397.5l-5.8 3.4c-2.1 1.2-5.4 1.2-7.5 0l-5.9-3.4c-0.8-0.5-1.2-1-1.4-1.6-0.4 1 0.1 2.1 1.4 2.8l5.9 3.4c2.1 1.2 5.4 1.2 7.5 0l5.8-3.3c1.3-0.8 1.8-1.8 1.4-2.8-0.2 0.5-0.6 1.1-1.4 1.5z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "R",
    d: "m341.3 430.6l-5.8 3.4c-2.1 1.2-5.4 1.1-7.5 0l-5.9-3.4c-0.8-0.5-1.2-1-1.4-1.6-0.4 1 0.1 2 1.4 2.8l5.9 3.4c2.1 1.2 5.4 1.2 7.5 0l5.8-3.4c1.3-0.7 1.8-1.8 1.4-2.7-0.2 0.5-0.6 1.1-1.4 1.5z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "S",
    d: "m358.7 440.2l-6.6 3.8c-1.8 1.1-4.9 1.1-6.7 0l-6.7-3.8c-0.6-0.4-1-0.9-1.2-1.4-0.4 0.9 0 1.9 1.2 2.6l6.7 3.8c1.8 1.1 4.9 1.1 6.7 0l6.6-3.7c1.2-0.7 1.6-1.7 1.2-2.6-0.2 0.5-0.6 0.9-1.2 1.3z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "T",
    d: "m409.7 469.6l-6.6 3.8c-1.8 1.1-4.9 1.1-6.7 0l-6.6-3.8c-0.7-0.4-1.1-0.8-1.3-1.3-0.4 0.9 0 1.9 1.3 2.6l6.6 3.8c1.8 1.1 4.9 1.1 6.7 0l6.6-3.8c1.2-0.7 1.6-1.7 1.2-2.6-0.1 0.5-0.6 1-1.2 1.3z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "U",
    d: "m375.7 450l-6.6 3.8c-1.8 1.1-4.9 1.1-6.7 0l-6.6-3.8c-0.7-0.4-1.1-0.9-1.3-1.4-0.4 0.9 0 1.9 1.3 2.6l6.6 3.8c1.8 1.1 4.9 1.1 6.7 0.1l6.6-3.8c1.2-0.7 1.6-1.7 1.2-2.6-0.2 0.5-0.6 0.9-1.2 1.3z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "V",
    d: "m434.5 466.2l-5.8 3.4c-2.1 1.2-5.4 1.2-7.5 0l-5.9-3.4c-0.7-0.5-1.2-1-1.4-1.6-0.4 1 0.1 2.1 1.4 2.8l5.9 3.4c2.1 1.2 5.4 1.2 7.5 0l5.8-3.3c1.3-0.8 1.8-1.8 1.5-2.8-0.2 0.6-0.7 1.1-1.5 1.5z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "W",
    d: "m445 488c-0.2 0.4-0.7 0.9-1.3 1.3l-6.6 3.8c-1.8 1-4.9 1-6.7 0l-6.6-3.9c-0.7-0.3-1.1-0.8-1.3-1.3-0.4 0.9 0 1.9 1.3 2.6l6.6 3.8c1.8 1.1 4.9 1.1 6.7 0l6.6-3.8c1.2-0.7 1.6-1.6 1.3-2.5z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "X",
    d: "m451.5 476l-5.8 3.4c-2.1 1.2-5.4 1.2-7.5 0l-5.9-3.4c-0.7-0.4-1.2-1-1.4-1.5-0.4 0.9 0.1 2 1.4 2.8l5.9 3.4c2.1 1.1 5.4 1.2 7.5 0l5.8-3.4c1.3-0.8 1.8-1.8 1.5-2.8-0.2 0.6-0.7 1.1-1.5 1.5z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "Y",
    d: "m305.1 422l5.9 3.4c2.1 1.2 5.4 1.2 7.5 0l5.8-3.4c1.3-0.7 1.8-1.8 1.4-2.8-0.2 0.6-0.6 1.1-1.4 1.6l-5.8 3.3c-2.1 1.2-5.4 1.2-7.5 0l-5.9-3.4c-0.8-0.4-1.2-0.9-1.4-1.5-0.4 1 0.1 2 1.4 2.8z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "Z",
    d: "m412.8 506.3c-0.2 0.6-0.7 1.2-1.4 1.6l-5.7 3.3c-2.1 1.2-5.6 1.2-7.7 0l-5.7-3.3c-0.8-0.5-1.3-1-1.5-1.6-0.3 1 0.2 2.1 1.5 2.8l5.7 3.3c2.1 1.3 5.6 1.3 7.7 0.1l5.7-3.3c1.3-0.8 1.8-1.9 1.4-2.9z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "a0",
    d: "m279.2 425.2l6.6 3.8c1.8 1.1 4.9 1.1 6.7 0l6.6-3.8c1.2-0.7 1.6-1.6 1.3-2.5-0.2 0.4-0.7 0.9-1.3 1.3l-6.6 3.8c-1.8 1-4.9 1-6.7 0l-6.6-3.9c-0.7-0.3-1.1-0.8-1.3-1.3-0.4 0.9 0 1.9 1.3 2.6z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "a1",
    d: "m227.1 417.3c-0.2 0.6-0.7 1.1-1.5 1.6l-5.7 3.2c-2.1 1.3-5.5 1.3-7.6 0l-13.3-7.6c-0.8-0.5-1.3-1-1.5-1.6-0.3 1 0.2 2 1.5 2.8l13.3 7.7c2.1 1.2 5.5 1.2 7.6 0l5.7-3.3c1.3-0.8 1.8-1.8 1.5-2.8z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "a2",
    d: "m244.1 427.1c-0.2 0.6-0.7 1.1-1.5 1.6l-5.7 3.3c-2.1 1.2-5.5 1.2-7.6-0.1l-5.7-3.3c-0.8-0.4-1.3-1-1.5-1.5-0.4 0.9 0.1 2 1.5 2.8l5.7 3.3c2.1 1.2 5.5 1.2 7.6 0l5.7-3.3c1.3-0.7 1.8-1.8 1.5-2.8z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "a3",
    d: "m214.8 406.6l30.2 17.5c2.1 1.2 5.5 1.2 7.7 0l5.6-3.3c1.4-0.7 1.8-1.8 1.5-2.8-0.2 0.6-0.7 1.1-1.5 1.6l-5.6 3.3c-2.2 1.2-5.6 1.2-7.7-0.1l-30.2-17.4c-0.8-0.5-1.3-1-1.5-1.6-0.4 1 0.1 2.1 1.5 2.8z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "a4",
    d: "m380.1 505.6c-0.2 0.6-0.7 1.2-1.5 1.6l-5.7 3.3c-2.1 1.2-5.5 1.2-7.6 0l-107.7-62.2c-0.8-0.5-1.3-1-1.5-1.6-0.4 1 0.1 2.1 1.5 2.8l107.7 62.2c2.1 1.3 5.5 1.3 7.6 0l5.7-3.2c1.4-0.8 1.8-1.9 1.5-2.9z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "a5",
    d: "m261.1 436.9c-0.2 0.6-0.7 1.1-1.5 1.6l-5.7 3.3c-2.1 1.2-5.5 1.2-7.6 0l-5.7-3.3c-0.8-0.5-1.3-1-1.5-1.6-0.4 1 0.1 2 1.5 2.8l5.7 3.3c2.1 1.2 5.5 1.2 7.6 0l5.7-3.3c1.3-0.7 1.8-1.8 1.5-2.8z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "a6",
    d: "m230.4 397.1l21.4 12.3c1.8 1.1 4.9 1.1 6.7 0l6.6-3.8c1.2-0.7 1.6-1.7 1.2-2.6-0.1 0.5-0.6 1-1.2 1.3l-6.6 3.8c-1.8 1.1-4.9 1.1-6.7 0l-21.4-12.3c-0.6-0.4-1-0.8-1.2-1.3-0.4 0.9 0 1.9 1.2 2.6z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "a7",
    d: "m262.3 379.1l5.9 3.4c2.1 1.2 5.4 1.2 7.5 0l5.8-3.4c1.3-0.7 1.8-1.8 1.4-2.8-0.2 0.6-0.6 1.1-1.4 1.6l-5.8 3.3c-2.1 1.2-5.4 1.2-7.5 0l-5.9-3.4c-0.8-0.4-1.2-0.9-1.4-1.5-0.4 1 0.1 2 1.4 2.8z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "a8",
    d: "m246.5 388.2l13.5 7.7c2.1 1.2 5.4 1.2 7.5 0l5.8-3.3c1.3-0.8 1.8-1.8 1.4-2.8-0.2 0.6-0.6 1.1-1.4 1.5l-5.8 3.4c-2.1 1.2-5.4 1.2-7.5 0l-13.5-7.8c-0.7-0.4-1.2-0.9-1.4-1.5-0.3 1 0.1 2 1.4 2.8z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "a9",
    d: "m478.1 509.1l-6.6 3.8c-1.9 1.1-4.9 1.1-6.8 0l-6.6-3.8c-0.6-0.4-1.1-0.9-1.3-1.4-0.3 0.9 0.1 1.9 1.3 2.6l6.6 3.8c1.9 1.1 4.9 1.1 6.8 0.1l6.6-3.8c1.2-0.7 1.6-1.7 1.2-2.6-0.2 0.5-0.6 0.9-1.2 1.3z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "m277.6 369.7l14.3 8.3c1.9 1.1 4.8 1.1 6.6 0 1.2-0.7 1.6-1.6 1.2-2.5-0.2 0.5-0.6 0.9-1.2 1.3-1.8 1-4.7 1-6.6 0l-14.3-8.3c-0.6-0.4-1-0.8-1.2-1.3-0.4 0.9 0 1.8 1.2 2.5z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "m462.3 518.2l-6.6 3.8c-1.8 1.1-4.8 1.1-6.7 0l-16.8-9.7c-0.7-0.4-1.1-0.9-1.3-1.3-0.4 0.9 0.1 1.8 1.3 2.5l16.8 9.7c1.9 1.1 4.9 1.1 6.7 0.1l6.6-3.8c1.2-0.7 1.6-1.7 1.3-2.6-0.2 0.5-0.6 0.9-1.3 1.3z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "m493.4 500.2l-5.8 3.4c-2.1 1.2-5.4 1.2-7.5 0l-13.4-7.8c-0.8-0.4-1.3-0.9-1.5-1.5-0.3 1 0.2 2 1.5 2.8l13.4 7.7c2.1 1.2 5.4 1.2 7.5 0.1l5.8-3.4c1.3-0.8 1.8-1.8 1.5-2.8-0.2 0.6-0.7 1.1-1.5 1.5z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "m397.1 515.5c-0.2 0.5-0.7 1.1-1.5 1.5l-5.6 3.3c-2.2 1.2-5.6 1.2-7.7 0l-5.7-3.3c-0.8-0.5-1.3-1-1.5-1.6-0.3 1 0.1 2.1 1.5 2.8l5.7 3.3c2.1 1.3 5.5 1.3 7.7 0.1l5.6-3.3c1.4-0.8 1.8-1.9 1.5-2.8z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "m502.9 494.8c-1.8 1-4.8 1-6.6 0l-6.8-4c-0.6-0.3-1-0.8-1.2-1.2-0.4 0.8 0 1.8 1.2 2.5l6.8 3.9c1.8 1.1 4.8 1.1 6.6 0 1.2-0.7 1.6-1.6 1.2-2.5-0.2 0.5-0.6 0.9-1.2 1.3z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "m414.1 525.3c-0.2 0.5-0.7 1.1-1.5 1.5l-5.6 3.3c-2.2 1.2-5.6 1.2-7.7 0l-5.7-3.3c-0.8-0.4-1.3-1-1.5-1.6-0.3 1 0.1 2.1 1.5 2.9l5.7 3.3c2.1 1.2 5.5 1.2 7.7 0l5.6-3.3c1.4-0.8 1.9-1.8 1.5-2.8z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "m430 536.9l-5.7 3.2c-2.1 1.3-5.5 1.3-7.6 0l-5.8-3.3c-0.7-0.4-1.2-1-1.4-1.6-0.4 1 0.1 2.1 1.4 2.9l5.8 3.3c2.1 1.2 5.5 1.2 7.6 0l5.7-3.3c1.3-0.7 1.8-1.8 1.5-2.8-0.2 0.6-0.7 1.1-1.5 1.6z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "m445.7 527.8l-5.6 3.3c-2.1 1.2-5.6 1.2-7.7-0.1l-5.7-3.3c-0.8-0.4-1.3-1-1.5-1.6-0.3 1 0.1 2.1 1.5 2.9l5.7 3.3c2.1 1.2 5.6 1.2 7.7 0l5.6-3.3c1.4-0.7 1.9-1.8 1.5-2.8-0.2 0.6-0.7 1.1-1.5 1.6z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "ai",
    d: "m421.2 452.6l6.7 3.9c1.9 1.1 4.8 1.1 6.6 0.1 1.2-0.7 1.6-1.7 1.2-2.6-0.1 0.5-0.5 0.9-1.2 1.3-1.8 1.1-4.7 1-6.6 0l-6.7-3.9c-0.7-0.4-1.1-0.8-1.3-1.3-0.3 0.9 0.1 1.8 1.3 2.5z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "aj",
    d: "m462 497.8c-0.2 0.5-0.6 0.9-1.3 1.3l-6.6 3.8c-1.8 1.1-4.9 1.1-6.7 0l-6.6-3.8c-0.7-0.4-1.1-0.9-1.3-1.4-0.4 0.9 0 1.9 1.3 2.6l6.6 3.8c1.8 1.1 4.9 1.1 6.7 0l6.6-3.8c1.2-0.6 1.6-1.6 1.3-2.5z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "m470 484.3c-0.2 0.6-0.7 1.1-1.5 1.6l-5.8 3.3c-2.1 1.2-5.4 1.2-7.5 0l-5.9-3.4c-0.7-0.4-1.2-1-1.4-1.5-0.4 1 0.1 2 1.4 2.8l5.9 3.4c2.1 1.2 5.4 1.2 7.5 0l5.8-3.4c1.3-0.7 1.8-1.8 1.5-2.8z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "m472.2 482.1l6.8 3.9c1.8 1 4.7 1.1 6.5 0 1.2-0.7 1.6-1.6 1.3-2.5-0.2 0.5-0.6 0.9-1.3 1.3-1.8 1-4.7 1-6.5-0.1l-6.8-3.9c-0.7-0.3-1.1-0.8-1.3-1.3-0.3 0.9 0.1 1.9 1.3 2.6z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "m436.4 501.2c-0.2 0.5-0.6 0.9-1.3 1.3l-6.5 3.8c-1.9 1.1-4.9 1.1-6.8 0l-6.6-3.8c-0.7-0.4-1.1-0.9-1.3-1.4-0.4 0.9 0.1 1.9 1.3 2.6l6.6 3.8c1.9 1.1 4.9 1.1 6.8 0.1l6.5-3.8c1.2-0.7 1.6-1.7 1.3-2.6z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "an",
    d: "m262.2 415.4l6.6 3.8c1.8 1.1 4.9 1.1 6.7 0l6.6-3.8c1.2-0.7 1.6-1.7 1.2-2.6-0.1 0.5-0.6 1-1.2 1.4l-6.6 3.8c-1.8 1-4.9 1-6.7-0.1l-6.6-3.8c-0.7-0.4-1.1-0.8-1.3-1.3-0.4 0.9 0 1.9 1.3 2.6z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "ao",
    d: "m429.8 516.2c-0.2 0.5-0.7 1.1-1.4 1.5l-5.7 3.3c-2.1 1.2-5.6 1.2-7.7 0l-5.7-3.3c-0.8-0.4-1.3-1-1.5-1.6-0.3 1 0.2 2.1 1.5 2.9l5.7 3.3c2.1 1.2 5.6 1.2 7.7 0l5.7-3.3c1.3-0.8 1.8-1.8 1.4-2.8z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "ap",
    d: "m302.1 383.9l6.8 3.9c1.9 1.1 4.8 1.1 6.6 0 1.2-0.6 1.6-1.6 1.2-2.5-0.2 0.5-0.6 0.9-1.2 1.3-1.8 1-4.7 1-6.6 0l-6.8-3.9c-0.6-0.4-1-0.9-1.2-1.3-0.4 0.9 0 1.8 1.2 2.5z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "aq",
    d: "m256.3 430.6l5.7 3.3c2.1 1.2 5.6 1.2 7.7 0l5.6-3.3c1.4-0.7 1.9-1.8 1.5-2.8-0.2 0.6-0.7 1.1-1.5 1.6l-5.6 3.3c-2.1 1.2-5.6 1.2-7.7 0l-5.7-3.3c-0.8-0.5-1.3-1.1-1.5-1.6-0.3 1 0.1 2 1.5 2.8z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "ar",
    d: "m455.2 472.3l6.8 3.9c1.8 1 4.7 1 6.5 0 1.2-0.7 1.6-1.6 1.2-2.5-0.1 0.4-0.5 0.9-1.2 1.2-1.8 1.1-4.7 1.1-6.5 0l-6.8-3.9c-0.7-0.4-1.1-0.8-1.3-1.3-0.3 0.9 0.1 1.9 1.3 2.6z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "as",
    d: "m370.1 423.2l6.8 3.9c1.9 1 4.8 1.1 6.6 0 1.2-0.7 1.6-1.6 1.2-2.5-0.2 0.5-0.6 0.9-1.2 1.3-1.8 1-4.7 1-6.6-0.1l-6.8-3.9c-0.6-0.3-1-0.8-1.2-1.3-0.3 0.9 0.1 1.9 1.2 2.6z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "at",
    d: "m336.1 403.5l6.8 4c1.9 1 4.8 1 6.6 0 1.2-0.7 1.6-1.7 1.2-2.5-0.2 0.4-0.6 0.9-1.2 1.2-1.8 1.1-4.7 1.1-6.6 0l-6.8-3.9c-0.6-0.4-1-0.8-1.2-1.3-0.3 0.9 0.1 1.9 1.2 2.5z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "m353.1 413.4l6.8 3.9c1.9 1 4.8 1 6.6 0 1.2-0.7 1.6-1.6 1.2-2.5-0.2 0.4-0.6 0.9-1.2 1.2-1.8 1.1-4.7 1.1-6.6 0l-6.8-3.9c-0.6-0.4-1-0.8-1.2-1.3-0.3 0.9 0.1 1.9 1.2 2.6z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "av",
    d: "m319.1 393.7l6.8 3.9c1.9 1.1 4.8 1.1 6.6 0.1 1.2-0.7 1.6-1.7 1.2-2.6-0.2 0.5-0.6 0.9-1.2 1.3-1.8 1.1-4.7 1-6.6 0l-6.8-3.9c-0.6-0.4-1-0.8-1.2-1.3-0.4 0.9 0 1.8 1.2 2.5z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "aw",
    d: "m387.2 433l6.7 3.9c1.9 1.1 4.8 1.1 6.6 0 1.2-0.7 1.6-1.6 1.2-2.5-0.2 0.5-0.5 0.9-1.2 1.3-1.8 1-4.7 1-6.6 0l-6.7-4c-0.7-0.3-1.1-0.8-1.3-1.2-0.3 0.8 0.1 1.8 1.3 2.5z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "m271.1 402.4l5.9 3.4c2.1 1.2 5.4 1.2 7.5 0l5.8-3.4c1.3-0.8 1.8-1.8 1.4-2.8-0.2 0.6-0.6 1.1-1.4 1.5l-5.8 3.4c-2.1 1.2-5.4 1.2-7.5 0l-5.9-3.4c-0.8-0.4-1.2-1-1.4-1.5-0.4 0.9 0.1 2 1.4 2.8z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "m404.2 442.8l6.7 3.9c1.9 1.1 4.8 1.1 6.6 0 1.2-0.6 1.6-1.6 1.2-2.5-0.2 0.5-0.5 0.9-1.2 1.3-1.8 1-4.7 1-6.6 0l-6.7-3.9c-0.7-0.4-1.1-0.9-1.3-1.3-0.3 0.9 0.1 1.8 1.3 2.5z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "az",
    d: "m438.2 462.4l6.8 4c1.8 1 4.7 1 6.5 0 1.2-0.7 1.6-1.7 1.2-2.5-0.1 0.4-0.5 0.9-1.2 1.2-1.8 1.1-4.7 1.1-6.5 0l-6.8-3.9c-0.7-0.4-1.1-0.8-1.3-1.3-0.3 0.9 0.1 1.9 1.3 2.5z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "aA",
    d: "m559.7 488l-265.5-153.4c-10.2-5.9-18.6-21.8-18.6-35.5v-208.3c0-13.7 8.4-20 18.6-14l265.5 153.3c10.3 6 18.6 21.9 18.6 35.6v208.2c0 13.7-8.3 20-18.6 14.1z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "aB",
    d: "m562.1 477.3l-262.6-151.7c-8.3-5.3-13.4-15.8-13.4-26.5v-209.3c0-2.5 2.8-4.1 4.9-2.8q0.4 0.2 0.6 0.3l262.9 151.9c9.8 5.6 13.4 15.7 13.4 26.5v208.8c0 2.7-3 4.4-5.4 3q-0.2-0.1-0.4-0.2z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "aC",
    d: "m567.9 265.7v208.8c0 2.7-3 4.4-5.4 3q-0.2-0.1-0.4-0.2l-262.6-151.7c-8.3-5.3-13.4-15.8-13.4-26.5v-209.3c0-2.5 2.8-4.1 4.9-2.8q0.4 0.2 0.6 0.3l262.9 151.9c9.8 5.6 13.4 15.7 13.4 26.5zm-2.1 0c0-8-2.2-18.8-12.4-24.7l-263.4-152.2q-0.3-0.2-0.6-0.2c-0.6 0-1.2 0.5-1.2 1.2v209.3c0 10.2 4.8 19.9 12.3 24.7l263.1 151.9q0.3 0.2 0.7 0.2c0.7 0 1.5-0.5 1.5-1.4z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "aD",
    d: "m565 227.3l-265.5-153.3c-4.1-2.4-7.8-2.8-10.9-1.6-0.4 0.1-5.6 2.9-5.9 3.1q0 0 0 0c3.1-1.6 7.2-1.3 11.5 1.3l265.5 153.3c10.3 6 18.6 21.9 18.6 35.6v208.2c0 8.6-3.2 14.3-8.2 15.9 0.4 0 0.9-0.2 1.7-0.6 0.2-0.1 5.8-3.3 6.1-3.5 3.5-2.4 5.7-7.5 5.7-14.6v-208.2c0-13.7-8.3-29.7-18.6-35.6z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "aE",
    d: "m560.6 229.7l-265.5-153.4c-4.2-2.4-8.1-2.8-11.2-1.4 2.7-0.4 5.7 0.2 9 2.1l265.5 153.3c10.3 6 18.6 21.9 18.6 35.6v208.3c0 8-2.9 13.5-7.4 15.5 5.7-1 9.6-6.8 9.6-16.2v-208.3c0-13.7-8.3-29.6-18.6-35.5z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "aF",
    d: "m582.9 264c-6.8 2.8-15.8-3.2-20-13.4-4.2-10.3-2.1-20.9 4.7-23.6 6.8-2.8 15.7 3.2 19.9 13.4 4.3 10.3 2.2 20.9-4.6 23.6z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      mixBlendMode: "multiply"
    }
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "aG",
    d: "m378.6 511.1l-5.7 3.3c-2.1 1.2-5.5 1.2-7.6 0l-107.7-62.2c-1.7-1-2-2.4-1.1-3.6q0.4 0.5 1.1 0.9l107.7 62.2c2.1 1.3 5.5 1.3 7.6 0l5.7-3.2q0.7-0.4 1.1-0.9c0.9 1.2 0.6 2.6-1.1 3.5zm-83.2-76.7q0.3 0.3 0.8 0.6l6.6 3.8c1.8 1.1 4.9 1.1 6.7 0l6.6-3.8q0.5-0.2 0.8-0.6c1 1.1 0.7 2.4-0.8 3.3l-6.6 3.8c-1.8 1.1-4.9 1.1-6.7 0l-6.6-3.8c-1.6-0.9-1.8-2.3-0.8-3.3zm27.8 34.6q0.4 0.5 1.1 0.9l5.7 3.3c2.1 1.2 5.6 1.2 7.7 0l5.7-3.3q0.6-0.4 1-0.9c0.9 1.2 0.6 2.6-1 3.6l-5.7 3.3c-2.1 1.2-5.6 1.2-7.7-0.1l-5.7-3.3c-1.7-0.9-2-2.4-1.1-3.5zm-17-9.8q0.4 0.5 1.1 0.9l5.7 3.3c2.1 1.2 5.6 1.2 7.7 0l5.7-3.3q0.6-0.4 1-0.9c0.9 1.2 0.6 2.6-1 3.6l-5.7 3.2c-2.1 1.3-5.6 1.2-7.7 0l-5.7-3.3c-1.7-0.9-2-2.4-1.1-3.5zm23.2-5.2q0.3 0.4 0.8 0.6l6.6 3.9c1.8 1 4.9 1 6.7 0l6.6-3.8q0.5-0.3 0.8-0.6c1 1 0.7 2.4-0.8 3.2l-6.6 3.8c-1.8 1.1-4.9 1.1-6.7 0l-6.6-3.8c-1.6-0.9-1.8-2.2-0.8-3.3zm34 19.6q0.3 0.4 0.8 0.7l6.6 3.8c1.9 1.1 4.9 1.1 6.7 0l6.6-3.8q0.5-0.3 0.8-0.6c1 1.1 0.7 2.4-0.8 3.3l-6.6 3.8c-1.8 1-4.8 1-6.7 0l-6.6-3.9c-1.6-0.9-1.8-2.2-0.8-3.3zm-51-29.4q0.3 0.3 0.8 0.6l6.6 3.8c1.8 1.1 4.9 1.1 6.7 0.1l6.6-3.8q0.5-0.3 0.8-0.6c1 1 0.7 2.3-0.8 3.2l-6.6 3.8c-1.8 1.1-4.9 1.1-6.7 0l-6.6-3.8c-1.6-0.9-1.8-2.3-0.8-3.3zm124.7 52.8c-1.8 1.1-4.9 1.1-6.7 0l-6.6-3.8c-1.6-0.9-1.8-2.3-0.8-3.3q0.3 0.3 0.8 0.6l6.6 3.8c1.8 1.1 4.9 1.1 6.7 0l6.6-3.8q0.5-0.2 0.8-0.6c1 1.1 0.7 2.4-0.8 3.3zm-164.9-57.5q0.4 0.5 1 0.9l5.8 3.3c2.1 1.3 5.5 1.3 7.6 0.1l5.7-3.3q0.7-0.4 1-0.9c1 1.2 0.7 2.6-1 3.5l-5.7 3.3c-2.1 1.2-5.5 1.2-7.6 0l-5.8-3.3c-1.6-1-2-2.4-1-3.6zm26.9-11.6l-6.6 3.8c-1.9 1.1-4.9 1.1-6.8 0l-6.6-3.8c-1.5-0.9-1.8-2.3-0.8-3.3q0.3 0.3 0.8 0.6l6.6 3.8c1.9 1.1 4.9 1.1 6.8 0l6.6-3.8q0.4-0.2 0.7-0.6c1 1.1 0.8 2.4-0.7 3.3zm75.1 70.5q0.4 0.5 1.1 0.9l5.7 3.3c2.1 1.3 5.5 1.3 7.6 0.1l5.7-3.3q0.7-0.4 1.1-0.9c0.9 1.2 0.6 2.6-1.1 3.5l-5.7 3.3c-2.1 1.2-5.5 1.2-7.6 0l-5.7-3.3c-1.7-1-2-2.4-1.1-3.6zm-17-9.8q0.4 0.5 1.1 0.9l5.7 3.3c2.1 1.2 5.5 1.2 7.6 0l5.7-3.2q0.7-0.4 1.1-0.9c0.9 1.1 0.6 2.6-1.1 3.5l-5.7 3.3c-2.1 1.2-5.5 1.2-7.6 0l-5.7-3.3c-1.7-1-2-2.4-1.1-3.6zm40.1 4.7q0.4 0.3 0.8 0.6l6.6 3.8c1.9 1.1 4.9 1.1 6.8 0l6.6-3.7q0.4-0.3 0.7-0.7c1.1 1.1 0.8 2.4-0.7 3.3l-6.6 3.8c-1.9 1.1-4.9 1.1-6.8 0l-6.6-3.8c-1.5-0.9-1.8-2.3-0.8-3.3zm-51-29.5q0.3 0.4 0.8 0.7l6.6 3.8c1.9 1.1 4.9 1.1 6.8 0l6.6-3.8q0.4-0.3 0.7-0.6c1 1 0.8 2.4-0.7 3.3l-6.6 3.8c-1.9 1-4.9 1-6.8 0l-6.6-3.9c-1.5-0.9-1.8-2.2-0.8-3.3zm34 19.7q0.4 0.3 0.8 0.6l6.6 3.8c1.9 1.1 4.9 1.1 6.8 0l6.6-3.8q0.4-0.2 0.7-0.6c1.1 1.1 0.8 2.4-0.7 3.3l-6.6 3.8c-1.9 1.1-4.9 1.1-6.8 0l-6.6-3.8c-1.5-0.9-1.8-2.3-0.8-3.3zm39.8 3.7c-1.9 1.1-4.9 1.1-6.8 0l-6.6-3.8c-1.5-0.9-1.8-2.3-0.8-3.3q0.3 0.3 0.8 0.6l6.6 3.8c1.9 1.1 4.9 1.1 6.8 0l6.6-3.8q0.4-0.3 0.7-0.6c1 1.1 0.8 2.4-0.7 3.3zm-111.9-75.8c1 1.2 0.7 2.6-1 3.5l-5.8 3.4c-2.1 1.2-5.4 1.2-7.5 0l-5.9-3.4c-1.6-1-1.9-2.4-1-3.5q0.4 0.4 1 0.8l5.9 3.4c2.1 1.2 5.4 1.2 7.5 0l5.8-3.4q0.7-0.3 1-0.8zm102.2 58.9c1 1.1 0.8 2.4-0.8 3.3l-6.5 3.8c-1.9 1.1-4.9 1-6.8 0l-6.6-3.8c-1.6-0.9-1.8-2.3-0.8-3.3q0.3 0.3 0.8 0.6l6.6 3.8c1.9 1.1 4.9 1.1 6.8 0l6.5-3.8q0.5-0.3 0.8-0.6zm-43-42.9c1 1.2 0.7 2.6-1 3.5l-5.8 3.4c-2.1 1.2-5.4 1.2-7.5 0l-5.9-3.4c-1.6-1-1.9-2.4-1-3.5q0.4 0.4 1 0.8l5.9 3.4c2.1 1.2 5.4 1.2 7.5 0l5.8-3.4q0.7-0.3 1-0.8zm17 9.8c1 1.2 0.7 2.6-0.9 3.5l-5.9 3.4c-2.1 1.2-5.4 1.2-7.5 0l-5.9-3.4c-1.6-1-1.9-2.4-1-3.5q0.4 0.4 1 0.8l5.9 3.4c2.1 1.2 5.4 1.2 7.5 0l5.9-3.4q0.6-0.3 0.9-0.8zm17 9.8c1 1.2 0.7 2.6-0.9 3.5l-5.9 3.4c-2.1 1.2-5.4 1.2-7.5 0l-5.9-3.4c-1.6-1-1.9-2.4-1-3.5q0.4 0.4 1 0.8l5.9 3.4c2.1 1.2 5.4 1.2 7.5 0l5.9-3.3q0.6-0.4 0.9-0.9zm-68-39.2c1 1.1 0.7 2.5-1 3.5l-5.8 3.3c-2.1 1.2-5.4 1.2-7.5 0l-5.9-3.4c-1.6-0.9-1.9-2.3-1-3.5q0.4 0.5 1 0.9l5.9 3.4c2.1 1.2 5.4 1.2 7.5 0l5.8-3.4q0.7-0.4 1-0.8zm-34-19.7c1 1.2 0.7 2.6-1 3.5l-5.8 3.4c-2.1 1.2-5.4 1.2-7.5 0l-5.9-3.4c-1.6-1-1.9-2.4-1-3.5q0.4 0.4 1 0.8l5.9 3.4c2.1 1.2 5.4 1.2 7.5 0l5.8-3.3q0.7-0.4 1-0.9zm17 9.9c1 1.1 0.7 2.5-1 3.4l-5.8 3.4c-2.1 1.2-5.4 1.2-7.5 0l-5.9-3.4c-1.6-0.9-1.9-2.4-1-3.5q0.4 0.5 1 0.8l5.9 3.4c2.1 1.2 5.4 1.2 7.5 0.1l5.8-3.4q0.7-0.4 1-0.8zm102 58.9c1 1.1 0.7 2.5-0.9 3.4l-5.9 3.4c-2 1.2-5.4 1.2-7.5 0l-5.9-3.4c-1.6-0.9-1.9-2.4-1-3.5q0.4 0.5 1 0.8l5.9 3.4c2.1 1.2 5.5 1.2 7.5 0.1l5.9-3.4q0.6-0.4 0.9-0.8zm-68-39.3c1 1.1 0.7 2.5-1 3.5l-5.8 3.4c-2.1 1.1-5.4 1.1-7.5-0.1l-5.9-3.4c-1.6-0.9-1.9-2.3-1-3.5q0.4 0.5 1 0.9l5.9 3.4c2.1 1.2 5.4 1.2 7.5 0l5.8-3.4q0.7-0.4 1-0.8zm-8.2 13.4c1 1.2 0.7 2.6-1 3.5l-5.8 3.4c-2.1 1.2-5.4 1.2-7.5 0l-5.9-3.4c-1.6-1-1.9-2.4-1-3.5q0.4 0.4 1 0.8l5.9 3.4c2.1 1.2 5.4 1.2 7.5 0l5.8-3.3q0.7-0.4 1-0.9zm93.2 35.7c1 1.1 0.7 2.5-0.9 3.5l-5.9 3.3c-2 1.2-5.4 1.2-7.5 0l-5.9-3.4c-1.6-0.9-1.9-2.3-1-3.5q0.4 0.5 1 0.9l5.9 3.4c2.1 1.2 5.5 1.2 7.5 0l5.9-3.4q0.6-0.4 0.9-0.8zm-59-16c1 1 0.7 2.4-0.8 3.3l-6.6 3.7c-1.8 1.1-4.8 1.1-6.7 0l-6.6-3.8c-1.6-0.9-1.8-2.2-0.8-3.3q0.3 0.4 0.8 0.7l6.6 3.8c1.9 1 4.9 1.1 6.7 0l6.6-3.8q0.5-0.3 0.8-0.6zm17 9.8c1 1 0.7 2.4-0.8 3.3l-6.6 3.8c-1.8 1-4.8 1-6.7-0.1l-6.6-3.8c-1.6-0.9-1.8-2.2-0.8-3.3q0.3 0.4 0.8 0.7l6.6 3.8c1.9 1.1 4.9 1.1 6.7 0l6.6-3.8q0.5-0.3 0.8-0.6zm-34-19.6c1 1 0.7 2.4-0.8 3.2l-6.6 3.8c-1.8 1.1-4.9 1.1-6.7 0l-6.6-3.8c-1.6-0.9-1.8-2.2-0.8-3.3q0.3 0.3 0.8 0.6l6.6 3.8c1.8 1.1 4.9 1.1 6.7 0.1l6.6-3.8q0.5-0.3 0.8-0.6zm93 35.6c1 1.1 0.7 2.5-0.9 3.5l-5.9 3.4c-2 1.1-5.4 1.1-7.5-0.1l-5.9-3.4c-1.6-0.9-1.9-2.3-1-3.5q0.4 0.5 1 0.9l5.9 3.4c2.1 1.2 5.5 1.2 7.5 0l5.9-3.4q0.6-0.4 0.9-0.8zm-127.2-55.3c1 1.2 0.7 2.6-1 3.5l-5.8 3.4c-2.1 1.2-5.4 1.2-7.5 0l-5.9-3.4c-1.6-1-1.9-2.4-1-3.5q0.4 0.4 1 0.8l5.9 3.4c2.1 1.2 5.4 1.2 7.5 0l5.8-3.4q0.7-0.3 1-0.8zm66 87.1q0.4 0.5 1 0.9l5.8 3.3c2.1 1.2 5.5 1.2 7.6 0l5.7-3.3q0.6-0.4 1-0.9c1 1.2 0.6 2.6-1 3.6l-5.7 3.2c-2.1 1.3-5.5 1.3-7.6 0l-5.8-3.3c-1.6-0.9-2-2.4-1-3.5zm-102-58.9q0.3 0.5 1 0.9l5.7 3.3c2.2 1.2 5.6 1.2 7.7 0l5.7-3.3q0.6-0.4 1-0.9c1 1.2 0.6 2.6-1 3.6l-5.7 3.2c-2.1 1.3-5.5 1.3-7.7 0l-5.7-3.3c-1.7-0.9-2-2.4-1-3.5zm-75.6-43.6q0.4 0.5 1.1 0.9l30.2 17.4c2.1 1.2 5.6 1.2 7.7 0l5.7-3.3q0.6-0.3 1-0.8c0.9 1.1 0.6 2.6-1 3.5l-5.7 3.3c-2.1 1.2-5.6 1.2-7.7 0l-30.2-17.5c-1.7-0.9-2-2.4-1.1-3.5zm28.9 26.8l-5.6 3.3c-2.2 1.2-5.6 1.2-7.7 0l-5.7-3.3c-1.7-1-2-2.4-1.1-3.6q0.4 0.5 1.1 0.9l5.7 3.3c2.1 1.2 5.5 1.3 7.7 0l5.6-3.2q0.7-0.4 1.1-0.9c0.9 1.1 0.6 2.6-1.1 3.5zm-17-9.8l-5.7 3.3c-2.1 1.2-5.5 1.2-7.6 0l-13.3-7.7c-1.6-1-2-2.4-1-3.5q0.4 0.4 1 0.8l13.3 7.7c2.1 1.2 5.5 1.2 7.6 0l5.7-3.3q0.7-0.4 1.1-0.8c0.9 1.1 0.6 2.5-1.1 3.5zm114.7 56q0.3 0.5 1 0.9l5.7 3.3c2.2 1.2 5.6 1.2 7.7 0l5.7-3.3q0.6-0.3 1-0.8c1 1.1 0.6 2.6-1 3.5l-5.7 3.3c-2.1 1.2-5.5 1.2-7.7 0l-5.7-3.3c-1.6-1-2-2.4-1-3.6zm-80.7-36.4l-5.6 3.3c-2.2 1.2-5.6 1.2-7.7 0l-5.7-3.3c-1.7-1-2-2.4-1.1-3.5q0.4 0.4 1.1 0.8l5.7 3.3c2.1 1.3 5.5 1.3 7.7 0.1l5.6-3.3q0.7-0.4 1.1-0.9c0.9 1.2 0.6 2.6-1.1 3.5zm1.7-64.1q0.4 0.4 1 0.8l5.9 3.4c2.1 1.2 5.4 1.2 7.5 0l5.8-3.4q0.7-0.3 1-0.8c1 1.2 0.7 2.6-1 3.5l-5.8 3.4c-2.1 1.2-5.4 1.2-7.5 0l-5.9-3.4c-1.6-1-2-2.4-1-3.5zm-31.6 18.2q0.3 0.3 0.8 0.6l21.3 12.3c1.9 1.1 4.9 1.1 6.8 0l6.5-3.8q0.5-0.3 0.8-0.6c1 1.1 0.7 2.4-0.8 3.3l-6.5 3.8c-1.9 1.1-4.9 1-6.8 0l-21.3-12.3c-1.6-0.9-1.8-2.3-0.8-3.3zm15.9-9.1q0.3 0.4 1 0.8l13.4 7.8c2.1 1.2 5.4 1.2 7.5 0l5.8-3.4q0.7-0.4 1-0.8c1 1.1 0.7 2.5-1 3.5l-5.8 3.3c-2.1 1.2-5.4 1.2-7.5 0l-13.4-7.7c-1.7-1-2-2.4-1-3.5zm167.1 143.4l-5.7 3.3c-2.1 1.2-5.6 1.2-7.7 0l-5.7-3.4c-1.7-0.9-2-2.3-1-3.5q0.3 0.5 1 0.9l5.7 3.3c2.1 1.2 5.6 1.2 7.7 0l5.7-3.3q0.6-0.4 1-0.8c0.9 1.1 0.6 2.5-1 3.5zm-17-9.8l-5.7 3.3c-2.1 1.2-5.6 1.2-7.7-0.1l-5.7-3.3c-1.7-0.9-2-2.4-1.1-3.5q0.4 0.5 1.1 0.9l5.7 3.3c2.1 1.2 5.6 1.2 7.7 0l5.7-3.3q0.6-0.4 1-0.9c0.9 1.2 0.6 2.6-1 3.6zm83.2-11.2c1 1 0.7 2.4-0.8 3.3l-6.6 3.7c-1.8 1.1-4.9 1.1-6.8 0l-6.6-3.8c-1.5-0.9-1.8-2.2-0.8-3.3q0.4 0.4 0.8 0.7l6.6 3.8c1.9 1.1 5 1.1 6.8 0l6.6-3.8q0.4-0.3 0.8-0.6zm-15.8 9.1c1 1 0.8 2.4-0.8 3.3l-6.5 3.7c-1.9 1.1-4.9 1.1-6.8 0l-16.8-9.7c-1.5-0.9-1.8-2.2-0.8-3.3q0.3 0.4 0.8 0.7l16.8 9.7c1.9 1 4.9 1 6.8 0l6.5-3.8q0.5-0.3 0.8-0.6zm39.8-20.2c-1.8 1.1-4.7 1.1-6.6 0l-6.8-3.9c-1.5-0.9-1.7-2.2-0.7-3.3q0.3 0.4 0.7 0.6l6.8 3.9c1.9 1.1 4.8 1.1 6.6 0.1q0.5-0.3 0.7-0.6c1.1 1 0.8 2.3-0.7 3.2zm-8.4 2c0.9 1.1 0.6 2.5-1 3.5l-5.9 3.3c-2 1.2-5.4 1.2-7.5 0l-13.4-7.7c-1.6-1-2-2.4-1-3.5q0.4 0.4 1 0.8l13.4 7.8c2.1 1.2 5.5 1.2 7.5 0l5.9-3.4q0.6-0.4 1-0.8zm-47.7 27.5c1 1.1 0.6 2.6-1 3.5l-5.7 3.3c-2.1 1.2-5.5 1.2-7.7 0l-5.7-3.3c-1.7-1-2-2.4-1-3.6q0.3 0.5 1 0.9l5.7 3.3c2.2 1.2 5.6 1.2 7.7 0l5.7-3.3q0.6-0.3 1-0.8zm-169.9-159q0.3 0.3 0.7 0.6l14.4 8.2c1.8 1.1 4.7 1.1 6.5 0q0.5-0.2 0.8-0.5c1 1 0.7 2.3-0.8 3.2-1.8 1.1-4.7 1.1-6.5 0l-14.4-8.3c-1.5-0.9-1.8-2.2-0.7-3.2zm154.2 168.1c0.9 1.1 0.6 2.6-1.1 3.5l-5.7 3.3c-2.1 1.2-5.5 1.2-7.6 0l-5.7-3.3c-1.7-1-2-2.4-1.1-3.6q0.4 0.5 1.1 0.9l5.7 3.3c2.1 1.2 5.5 1.2 7.6 0l5.7-3.3q0.7-0.4 1.1-0.8zm-10.7-85.2q0.3 0.3 0.8 0.5l6.8 4c1.8 1 4.7 1 6.6 0q0.4-0.3 0.7-0.6c1 1.1 0.8 2.4-0.7 3.2-1.9 1.1-4.8 1.1-6.6 0l-6.8-3.9c-1.5-0.9-1.8-2.2-0.8-3.2zm42.3 41.1c-2 1.2-5.4 1.2-7.5 0l-5.8-3.4c-1.7-1-2-2.4-1.1-3.5q0.4 0.4 1.1 0.8l5.8 3.4c2.1 1.2 5.5 1.2 7.5 0l5.9-3.4q0.6-0.3 1-0.8c0.9 1.2 0.6 2.6-1 3.5zm-8.3-21.5q0.3 0.3 0.7 0.6l6.8 3.9c1.8 1.1 4.8 1.1 6.6 0q0.4-0.2 0.7-0.5c1 1 0.8 2.3-0.7 3.2-1.8 1.1-4.8 1-6.6 0l-6.8-3.9c-1.5-0.9-1.7-2.2-0.7-3.3zm17 9.8q0.3 0.4 0.7 0.6l6.8 3.9c1.8 1.1 4.8 1.1 6.6 0.1q0.4-0.3 0.7-0.6c1 1 0.8 2.4-0.7 3.2-1.8 1.1-4.8 1.1-6.6 0l-6.8-3.9c-1.5-0.9-1.7-2.2-0.7-3.3zm-36.3 25l-6.6 3.8c-1.8 1-4.9 1-6.7 0l-6.7-3.9c-1.5-0.9-1.8-2.2-0.7-3.3q0.3 0.4 0.7 0.7l6.7 3.8c1.8 1.1 4.9 1.1 6.7 0l6.6-3.8q0.5-0.3 0.8-0.6c1 1.1 0.7 2.4-0.8 3.3zm-133.7-123.1q0.3 0.3 0.7 0.6l6.8 3.9c1.8 1 4.8 1 6.6 0q0.4-0.3 0.7-0.6c1 1.1 0.8 2.4-0.7 3.3-1.8 1-4.8 1-6.6-0.1l-6.8-3.9c-1.5-0.9-1.8-2.2-0.7-3.2zm-32.7 35.8c1.9 1.1 4.9 1.1 6.8 0.1l6.6-3.8q0.4-0.3 0.7-0.6c1 1 0.8 2.3-0.7 3.2l-6.6 3.8c-1.9 1.1-4.9 1.1-6.8 0l-6.6-3.8c-1.5-0.9-1.8-2.3-0.8-3.3q0.3 0.3 0.8 0.6zm-12.5 11.4l5.8 3.3c2.1 1.3 5.5 1.3 7.6 0.1l5.7-3.3q0.7-0.4 1-0.9c1 1.2 0.7 2.6-1 3.5l-5.7 3.3c-2.1 1.2-5.5 1.2-7.6 0l-5.8-3.3c-1.6-1-2-2.4-1-3.5q0.4 0.4 1 0.8zm152 87.5q0.4 0.5 1.1 0.9l5.7 3.3c2.1 1.2 5.5 1.2 7.6 0l5.7-3.3q0.7-0.4 1.1-0.8c0.9 1.1 0.6 2.5-1.1 3.5l-5.7 3.3c-2.1 1.2-5.5 1.2-7.6 0l-5.7-3.3c-1.7-1-2-2.4-1.1-3.6zm31.7-18.4q0.3 0.4 0.8 0.7l6.6 3.8c1.9 1 4.9 1.1 6.8 0l6.6-3.8q0.4-0.3 0.7-0.6c1 1 0.8 2.4-0.7 3.3l-6.6 3.7c-1.9 1.1-4.9 1.1-6.8 0l-6.6-3.8c-1.5-0.9-1.8-2.2-0.8-3.3zm-87.5-86.9q0.3 0.3 0.7 0.6l6.8 3.9c1.8 1.1 4.8 1.1 6.6 0q0.4-0.2 0.7-0.5c1 1 0.8 2.3-0.7 3.2-1.8 1-4.8 1-6.6 0l-6.8-3.9c-1.5-0.9-1.8-2.3-0.7-3.3zm-17-9.8q0.3 0.3 0.7 0.6l6.8 3.9c1.8 1.1 4.8 1.1 6.6 0q0.4-0.2 0.7-0.5c1 1 0.8 2.3-0.7 3.2-1.8 1-4.8 1-6.6 0l-6.8-4c-1.5-0.8-1.8-2.2-0.7-3.2zm102 58.9q0.3 0.3 0.7 0.6l6.8 3.9c1.8 1.1 4.8 1.1 6.6 0q0.4-0.2 0.7-0.5c1 1 0.8 2.3-0.7 3.2-1.8 1-4.8 1-6.6 0l-6.8-4c-1.5-0.8-1.7-2.2-0.7-3.2zm-68-39.3q0.3 0.3 0.7 0.6l6.8 3.9c1.8 1.1 4.8 1.1 6.6 0q0.4-0.2 0.7-0.5c1 1 0.8 2.3-0.7 3.2-1.8 1.1-4.8 1.1-6.6 0l-6.8-3.9c-1.5-0.9-1.8-2.2-0.7-3.3zm-51-29.4q0.3 0.3 0.7 0.6l6.8 3.9c1.8 1 4.8 1 6.6 0q0.4-0.3 0.7-0.6c1 1.1 0.8 2.4-0.7 3.3-1.8 1-4.8 1-6.6 0l-6.8-4c-1.5-0.9-1.8-2.2-0.7-3.2zm68 39.3q0.3 0.3 0.7 0.5l6.8 4c1.8 1 4.8 1 6.6 0q0.4-0.3 0.7-0.6c1 1 0.8 2.4-0.7 3.2-1.8 1.1-4.8 1.1-6.6 0l-6.8-3.9c-1.5-0.9-1.7-2.2-0.7-3.2zm-95.1-30.9c0.9 1.2 0.6 2.6-1 3.5l-5.9 3.4c-2 1.2-5.4 1.2-7.5 0l-5.8-3.4c-1.7-1-2-2.4-1-3.5q0.3 0.4 1 0.8l5.8 3.4c2.1 1.2 5.5 1.2 7.5 0l5.9-3.4q0.6-0.3 1-0.8zm112.1 40.7q0.3 0.3 0.7 0.5l6.8 4c1.8 1 4.8 1 6.6 0q0.4-0.3 0.7-0.6c1 1 0.8 2.4-0.7 3.2-1.8 1.1-4.8 1.1-6.6 0l-6.8-3.9c-1.5-0.9-1.7-2.2-0.7-3.2z"
  }))), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "aH",
    d: "m473.9 313.9l-75.4-43.5v-40l75.4 43.5z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "aI",
    d: "m342.6 238.6l-75.4-43.5v-39.9l75.4 43.5z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "aJ",
    d: "m405.5 144.9l-62.1-35.8c-5.3-3.1-9.6-11.3-9.6-18.3 0-7.1 4.3-10.3 9.6-7.3l62.1 35.9c5.3 3 9.6 11.2 9.6 18.3 0 7-4.3 10.3-9.6 7.2z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "aK",
    d: "m402.2 339.8l-62-35.8c-5.3-3.1-9.6-11.3-9.6-18.4 0-7 4.3-10.3 9.6-7.2l62 35.8c5.3 3.1 9.6 11.3 9.6 18.4 0 7-4.3 10.3-9.6 7.2z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "aL",
    d: "m440.5 242.6v-21l-30.5-17.1-1 1.8 29.5 16.5v18.6l-4.4-2.5 4.9 12.5 4.9-6.9z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "aL",
    d: "m373.3 151.2l4.8-6.9-3.8-2.2v-11.7l-2-0.6v11.2l-3.9-2.3z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "aL",
    d: "m309.5 177.5l4.8-6.8-3.5-2.1v-19.1l22.5 13 1-1.7-25.5-14.7v21.4l-4.2-2.5z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "aL",
    d: "m433.5 304l-128-73.7v-12l-2-0.6v13.8l68.8 39.8v14.9l-3.9-2.2 4.9 12.5 4.8-6.9-3.8-2.2v-15l59.7 34.2 1.5 0.9v-14.7l-2-0.6z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "aM",
    d: "m373 215.3l-38.1-53.5 38.1-9.4 38.2 53.4z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "aN",
    d: "m398.5 230.4v1.6l74.4 42.9v38.4l1 0.6v-40z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "aO",
    d: "m267.2 155.2v1.5l74.4 43v38.4l1 0.5v-39.9z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "aP",
    d: "m405.5 119.4l-62.1-35.9c-3.2-1.8-6-1.4-7.8 0.8 1.8-1.3 4.2-1.3 6.8 0.2l62.1 35.9c5.3 3 9.6 11.2 9.6 18.3 0 2.8-0.7 5-1.9 6.4 1.8-1.3 2.9-3.9 2.9-7.4 0-7.1-4.3-15.3-9.6-18.3z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "aQ",
    d: "m402.2 314.2l-62-35.8c-3.2-1.9-6.1-1.4-7.8 0.8 1.7-1.3 4.1-1.3 6.8 0.2l62 35.8c5.3 3.1 9.6 11.3 9.6 18.4 0 2.8-0.6 4.9-1.8 6.4 1.8-1.3 2.8-3.9 2.8-7.4 0-7.1-4.3-15.3-9.6-18.4z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "aR",
    d: "m372 153.4l37.7 52.8 1.5-0.4-38.2-53.4-38.1 9.4 0.5 0.7z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7,
      mixBlendMode: "color-dodge"
    }
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "aS",
    d: "m508.3 245.7q-1.2-2.2-1.2-4.8v-11.7q0-2.6 1.2-3.4 1.2-0.8 3.4 0.5 2.2 1.3 3.4 3.5 1.2 2.1 1.2 4.7v11.7q0 2.6-1.2 3.4-1.2 0.8-3.4-0.5-2.2-1.3-3.4-3.4zm5-1v-12.1q0-2.2-1.6-3.1-1.6-0.9-1.6 1.3v12q0 2.2 1.6 3.1 1.6 0.9 1.6-1.2z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "aT",
    d: "m511.6 262l-3.2-1.8v-2.5q1.3 0.8 2.1 1 0.8 0.2 1.2-0.2 0.5-0.3 0.9-1.2l2 1.2v22.1l-3-1.7z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "aU",
    d: "m508.3 306.1q-1.2-2.2-1.2-4.8v-11.7q0-2.6 1.2-3.4 1.2-0.8 3.4 0.5 2.2 1.3 3.4 3.4 1.2 2.2 1.2 4.8v11.7q0 2.6-1.2 3.4-1.2 0.8-3.4-0.5-2.2-1.3-3.4-3.4zm5-1.1v-12q0-2.2-1.6-3.1-1.6-0.9-1.6 1.3v12q0 2.2 1.6 3.1 1.6 0.9 1.6-1.3z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "aV",
    d: "m508.3 336.3q-1.2-2.2-1.2-4.8v-11.7q0-2.6 1.2-3.4 1.2-0.8 3.4 0.5 2.2 1.3 3.4 3.4 1.2 2.2 1.2 4.8v11.7q0 2.6-1.2 3.4-1.2 0.8-3.4-0.5-2.2-1.3-3.4-3.4zm5-1.1v-12q0-2.2-1.6-3.1-1.6-0.9-1.6 1.3v12q0 2.2 1.6 3.1 1.6 0.9 1.6-1.3z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "aW",
    d: "m511.6 352.6l-3.2-1.8v-2.5q1.3 0.8 2.1 1 0.8 0.2 1.2-0.2 0.5-0.3 0.9-1.2l2 1.2v22.1l-3-1.7z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "aX",
    d: "m508.3 396.7q-1.2-2.2-1.2-4.8v-11.7q0-2.6 1.2-3.4 1.2-0.8 3.4 0.5 2.2 1.3 3.4 3.4 1.2 2.2 1.2 4.8v11.7q0 2.6-1.2 3.4-1.2 0.8-3.4-0.5-2.2-1.3-3.4-3.4zm5-1.1v-12q0-2.2-1.6-3.1-1.6-0.9-1.6 1.3v12q0 2.2 1.6 3.1 1.6 0.9 1.6-1.3z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "aY",
    d: "m511.6 413l-3.2-1.8v-2.5q1.3 0.8 2.1 1 0.8 0.2 1.2-0.2 0.5-0.3 0.9-1.2l2 1.2v22.1l-3-1.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7,
      mixBlendMode: "color-dodge"
    }
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "aZ",
    d: "m525.5 239.9l-3.1-1.9v-2.4q1.2 0.7 2 0.9 0.8 0.2 1.3-0.1 0.5-0.3 0.8-1.2l2.1 1.2v22.1l-3.1-1.8z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "b0",
    d: "m522.2 283.9q-1.1-2.1-1.1-4.8v-11.6q0-2.7 1.1-3.4 1.2-0.8 3.5 0.5 2.2 1.3 3.4 3.4 1.2 2.1 1.2 4.8v11.6q0 2.7-1.2 3.5-1.2 0.7-3.4-0.6-2.3-1.3-3.5-3.4zm5-1v-12.1q0-2.2-1.5-3.1-1.6-0.9-1.6 1.3v12.1q0 2.2 1.6 3.1 1.5 0.9 1.5-1.3z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "b1",
    d: "m525.5 300.3l-3.1-1.9v-2.4q1.2 0.7 2 0.9 0.8 0.2 1.3-0.1 0.5-0.3 0.8-1.2l2.1 1.2v22.1l-3.1-1.8z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "b2",
    d: "m522.2 344.3q-1.1-2.1-1.1-4.8v-11.6q0-2.7 1.1-3.4 1.2-0.8 3.5 0.5 2.2 1.3 3.4 3.4 1.2 2.1 1.2 4.8v11.6q0 2.7-1.2 3.5-1.2 0.7-3.4-0.6-2.3-1.3-3.5-3.4zm5-1v-12.1q0-2.2-1.5-3.1-1.6-0.9-1.6 1.3v12.1q0 2.2 1.6 3.1 1.5 0.9 1.5-1.3z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "b3",
    d: "m522.2 374.5q-1.1-2.1-1.1-4.8v-11.6q0-2.7 1.1-3.4 1.2-0.8 3.5 0.5 2.2 1.3 3.4 3.4 1.2 2.1 1.2 4.8v11.6q0 2.7-1.2 3.5-1.2 0.7-3.4-0.6-2.3-1.3-3.5-3.4zm5-1v-12.1q0-2.2-1.5-3.1-1.6-0.9-1.6 1.3v12.1q0 2.2 1.6 3.1 1.5 0.9 1.5-1.3z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "b4",
    d: "m525.5 390.9l-3.1-1.9v-2.4q1.2 0.7 2 0.9 0.8 0.2 1.3-0.1 0.5-0.3 0.8-1.2l2.1 1.2v22.1l-3.1-1.8z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "b5",
    d: "m522.2 434.9q-1.1-2.1-1.1-4.8v-11.6q0-2.7 1.1-3.5 1.2-0.7 3.5 0.6 2.2 1.3 3.4 3.4 1.2 2.1 1.2 4.8v11.6q0 2.7-1.2 3.4-1.2 0.8-3.4-0.5-2.3-1.3-3.5-3.4zm5-1v-12.1q0-2.2-1.5-3.1-1.6-0.9-1.6 1.3v12.1q0 2.2 1.6 3.1 1.5 0.9 1.5-1.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7,
      mixBlendMode: "color-dodge"
    }
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "b6",
    d: "m536.2 261.8q-1.2-2.2-1.2-4.8v-11.7q0-2.6 1.2-3.4 1.2-0.8 3.4 0.5 2.2 1.3 3.4 3.5 1.2 2.1 1.2 4.7v11.7q0 2.6-1.2 3.4-1.2 0.8-3.4-0.5-2.2-1.3-3.4-3.4zm5-1v-12.1q0-2.2-1.6-3.1-1.6-0.9-1.6 1.3v12q0 2.2 1.6 3.1 1.6 0.9 1.6-1.2z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "b7",
    d: "m536.2 292q-1.2-2.2-1.2-4.8v-11.7q0-2.6 1.2-3.4 1.2-0.8 3.4 0.5 2.2 1.3 3.4 3.5 1.2 2.1 1.2 4.7v11.7q0 2.6-1.2 3.4-1.2 0.8-3.4-0.5-2.2-1.3-3.4-3.4zm5-1v-12.1q0-2.2-1.6-3.1-1.6-0.9-1.6 1.3v12q0 2.2 1.6 3.1 1.6 0.9 1.6-1.2z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "b8",
    d: "m536.2 322.2q-1.2-2.2-1.2-4.8v-11.7q0-2.6 1.2-3.4 1.2-0.8 3.4 0.5 2.2 1.3 3.4 3.5 1.2 2.1 1.2 4.7v11.7q0 2.6-1.2 3.4-1.2 0.8-3.4-0.5-2.2-1.3-3.4-3.4zm5-1v-12.1q0-2.2-1.6-3.1-1.6-0.9-1.6 1.3v12q0 2.2 1.6 3.1 1.6 0.9 1.6-1.2z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    className: "b9",
    d: "m539.5 338.5l-3.2-1.8v-2.5q1.3 0.8 2.1 1 0.8 0.2 1.2-0.2 0.5-0.3 0.9-1.2l2 1.2v22.1l-3-1.7z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    className: "ba",
    d: "m539.5 368.7l-3.2-1.8v-2.5q1.3 0.8 2.1 1 0.8 0.2 1.2-0.2 0.5-0.3 0.9-1.2l2 1.2v22.1l-3-1.7z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    className: "bb",
    d: "m539.5 398.9l-3.2-1.8v-2.5q1.3 0.8 2.1 1 0.8 0.2 1.2-0.2 0.5-0.3 0.9-1.2l2 1.2v22.1l-3-1.7z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bc",
    d: "m536.2 443q-1.2-2.2-1.2-4.8v-11.7q0-2.6 1.2-3.4 1.2-0.8 3.4 0.5 2.2 1.3 3.4 3.4 1.2 2.2 1.2 4.8v11.7q0 2.6-1.2 3.4-1.2 0.8-3.4-0.5-2.2-1.3-3.4-3.4zm5-1.1v-12q0-2.2-1.6-3.1-1.6-0.9-1.6 1.3v12q0 2.2 1.6 3.1 1.6 0.9 1.6-1.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7,
      mixBlendMode: "color-dodge"
    }
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    className: "bd",
    d: "m553.4 256l-3.2-1.9v-2.4q1.3 0.7 2.1 0.9 0.8 0.2 1.3-0.1 0.4-0.3 0.8-1.2l2 1.2v22.1l-3-1.8z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    className: "be",
    d: "m553.4 286.2l-3.2-1.9v-2.4q1.3 0.7 2.1 0.9 0.8 0.2 1.3-0.1 0.4-0.3 0.8-1.2l2 1.2v22.1l-3-1.8z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    className: "bf",
    d: "m553.4 316.4l-3.2-1.9v-2.4q1.3 0.7 2.1 0.9 0.8 0.2 1.3-0.1 0.4-0.3 0.8-1.2l2 1.2v22.1l-3-1.8z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bg",
    d: "m550.1 360.4q-1.1-2.1-1.1-4.8v-11.6q0-2.7 1.1-3.4 1.2-0.8 3.5 0.5 2.2 1.3 3.4 3.4 1.2 2.1 1.2 4.8v11.6q0 2.7-1.2 3.5-1.2 0.7-3.4-0.6-2.3-1.2-3.5-3.4zm5-1v-12.1q0-2.2-1.5-3.1-1.6-0.9-1.6 1.3v12.1q0 2.2 1.6 3.1 1.5 0.9 1.5-1.3z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bh",
    d: "m550.1 390.6q-1.1-2.1-1.1-4.8v-11.6q0-2.7 1.1-3.4 1.2-0.8 3.5 0.5 2.2 1.3 3.4 3.4 1.2 2.1 1.2 4.8v11.6q0 2.7-1.2 3.5-1.2 0.7-3.4-0.6-2.3-1.2-3.5-3.4zm5-1v-12.1q0-2.2-1.5-3.1-1.6-0.9-1.6 1.3v12.1q0 2.2 1.6 3.1 1.5 0.9 1.5-1.3z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bi",
    d: "m550.1 420.8q-1.1-2.1-1.1-4.8v-11.6q0-2.7 1.1-3.4 1.2-0.8 3.5 0.5 2.2 1.3 3.4 3.4 1.2 2.1 1.2 4.8v11.6q0 2.7-1.2 3.5-1.2 0.7-3.4-0.6-2.3-1.3-3.5-3.4zm5-1v-12.1q0-2.2-1.5-3.1-1.6-0.9-1.6 1.3v12.1q0 2.2 1.6 3.1 1.5 0.9 1.5-1.3z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    className: "bj",
    d: "m553.4 437.2l-3.2-1.9v-2.4q1.3 0.7 2.1 0.9 0.8 0.2 1.3-0.1 0.4-0.3 0.8-1.2l2 1.2v22.1l-3-1.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7,
      mixBlendMode: "color-dodge"
    }
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    className: "bk",
    d: "m411.2 175.2l-3.2-1.8v-2.5q1.3 0.7 2.1 0.9 0.8 0.2 1.3-0.1 0.4-0.3 0.8-1.2l2 1.2v22.1l-3-1.7z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bl",
    d: "m407.9 219.2q-1.2-2.1-1.2-4.7v-11.7q0-2.6 1.2-3.4 1.2-0.8 3.4 0.5 2.3 1.3 3.4 3.4 1.2 2.2 1.2 4.8v11.7q0 2.6-1.2 3.4-1.1 0.8-3.4-0.5-2.2-1.3-3.4-3.5zm5-1v-12q0-2.2-1.6-3.1-1.5-0.9-1.5 1.2v12.1q0 2.2 1.5 3.1 1.6 0.9 1.6-1.3z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    className: "bm",
    d: "m411.2 235.6l-3.2-1.8v-2.5q1.3 0.7 2.1 0.9 0.8 0.2 1.3-0.1 0.4-0.3 0.8-1.2l2 1.2v22.1l-3-1.7z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bn",
    d: "m407.9 279.6q-1.2-2.1-1.2-4.8v-11.6q0-2.6 1.2-3.4 1.2-0.8 3.4 0.5 2.3 1.3 3.4 3.4 1.2 2.2 1.2 4.8v11.7q0 2.6-1.2 3.4-1.1 0.8-3.4-0.5-2.2-1.3-3.4-3.5zm5-1v-12q0-2.2-1.6-3.1-1.5-0.9-1.5 1.2v12.1q0 2.2 1.5 3.1 1.6 0.9 1.6-1.3z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bo",
    d: "m407.9 309.8q-1.2-2.1-1.2-4.8v-11.6q0-2.6 1.2-3.4 1.2-0.8 3.4 0.5 2.3 1.3 3.4 3.4 1.2 2.2 1.2 4.8v11.7q0 2.6-1.2 3.4-1.1 0.8-3.4-0.5-2.2-1.3-3.4-3.5zm5-1v-12q0-2.2-1.6-3.1-1.5-0.9-1.5 1.2v12.1q0 2.2 1.5 3.1 1.6 0.9 1.6-1.3z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    className: "bp",
    d: "m411.2 326.2l-3.2-1.8v-2.5q1.3 0.7 2.1 0.9 0.8 0.2 1.3-0.1 0.4-0.3 0.8-1.2l2 1.2v22.1l-3-1.7z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bq",
    d: "m407.9 370.2q-1.2-2.1-1.2-4.8v-11.6q0-2.6 1.2-3.4 1.2-0.8 3.4 0.5 2.3 1.3 3.4 3.4 1.2 2.2 1.2 4.8v11.7q0 2.6-1.2 3.4-1.1 0.8-3.4-0.5-2.2-1.3-3.4-3.5zm5-1v-12q0-2.2-1.6-3.1-1.5-0.9-1.5 1.2v12.1q0 2.2 1.5 3.1 1.6 0.9 1.6-1.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7,
      mixBlendMode: "color-dodge"
    }
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "br",
    d: "m421.9 197.1q-1.2-2.1-1.2-4.8v-11.6q0-2.7 1.2-3.5 1.1-0.7 3.4 0.6 2.2 1.3 3.4 3.4 1.2 2.1 1.2 4.8v11.6q0 2.7-1.2 3.4-1.2 0.8-3.4-0.5-2.3-1.3-3.4-3.4zm4.9-1v-12.1q0-2.2-1.5-3.1-1.6-0.9-1.6 1.3v12.1q0 2.2 1.6 3.1 1.5 0.9 1.5-1.3z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bs",
    d: "m421.9 227.3q-1.2-2.1-1.2-4.8v-11.6q0-2.7 1.2-3.5 1.1-0.7 3.4 0.6 2.2 1.2 3.4 3.4 1.2 2.1 1.2 4.8v11.6q0 2.7-1.2 3.4-1.2 0.8-3.4-0.5-2.3-1.3-3.4-3.4zm4.9-1v-12.1q0-2.2-1.5-3.1-1.6-0.9-1.6 1.3v12.1q0 2.2 1.6 3.1 1.5 0.9 1.5-1.3z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bt",
    d: "m421.9 257.5q-1.2-2.1-1.2-4.8v-11.6q0-2.7 1.2-3.5 1.1-0.7 3.4 0.6 2.2 1.2 3.4 3.4 1.2 2.1 1.2 4.8v11.6q0 2.7-1.2 3.4-1.2 0.8-3.4-0.5-2.3-1.3-3.4-3.4zm4.9-1v-12.1q0-2.2-1.5-3.1-1.6-0.9-1.6 1.3v12.1q0 2.2 1.6 3.1 1.5 0.9 1.5-1.3z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    className: "bu",
    d: "m425.1 273.8l-3.1-1.8v-2.5q1.3 0.8 2 1 0.8 0.2 1.3-0.1 0.5-0.3 0.8-1.2l2.1 1.1v22.2l-3.1-1.8z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    className: "bv",
    d: "m425.1 304l-3.1-1.8v-2.5q1.3 0.8 2 1 0.8 0.2 1.3-0.1 0.5-0.3 0.8-1.2l2.1 1.1v22.2l-3.1-1.8z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    className: "bw",
    d: "m425.1 334.2l-3.1-1.8v-2.5q1.3 0.8 2 1 0.8 0.2 1.3-0.1 0.5-0.3 0.8-1.2l2.1 1.1v22.2l-3.1-1.8z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bx",
    d: "m421.9 378.3q-1.2-2.1-1.2-4.8v-11.6q0-2.7 1.2-3.5 1.1-0.7 3.4 0.6 2.2 1.2 3.4 3.4 1.2 2.1 1.2 4.8v11.6q0 2.7-1.2 3.4-1.2 0.8-3.4-0.5-2.3-1.3-3.4-3.4zm4.9-1v-12.1q0-2.2-1.5-3.1-1.6-0.9-1.6 1.3v12.1q0 2.1 1.6 3.1 1.5 0.9 1.5-1.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7,
      mixBlendMode: "color-dodge"
    }
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    className: "by",
    d: "m439.1 191.3l-3.2-1.8v-2.5q1.3 0.8 2.1 1 0.8 0.2 1.2-0.2 0.5-0.3 0.9-1.2l2 1.2v22.1l-3-1.7z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    className: "bz",
    d: "m439.1 221.5l-3.2-1.8v-2.5q1.3 0.8 2.1 1 0.8 0.2 1.2-0.2 0.5-0.3 0.9-1.2l2 1.2v22.1l-3-1.7z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    className: "bA",
    d: "m439.1 251.7l-3.2-1.8v-2.5q1.3 0.7 2.1 0.9 0.8 0.2 1.2-0.1 0.5-0.3 0.9-1.2l2 1.2v22.1l-3-1.7z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bB",
    d: "m435.8 295.7q-1.2-2.1-1.2-4.7v-11.7q0-2.6 1.2-3.4 1.2-0.8 3.4 0.5 2.3 1.3 3.4 3.4 1.2 2.2 1.2 4.8v11.7q0 2.6-1.2 3.4-1.1 0.8-3.4-0.5-2.2-1.3-3.4-3.5zm5-1v-12q0-2.2-1.6-3.1-1.5-0.9-1.5 1.2v12.1q0 2.2 1.5 3.1 1.6 0.9 1.6-1.3z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bC",
    d: "m435.8 325.9q-1.2-2.1-1.2-4.7v-11.7q0-2.6 1.2-3.4 1.2-0.8 3.4 0.5 2.3 1.3 3.4 3.4 1.2 2.2 1.2 4.8v11.7q0 2.6-1.2 3.4-1.1 0.8-3.4-0.5-2.2-1.3-3.4-3.5zm5-1v-12q0-2.2-1.6-3.1-1.5-0.9-1.5 1.2v12.1q0 2.2 1.5 3.1 1.6 0.9 1.6-1.3z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bD",
    d: "m435.8 356.1q-1.2-2.1-1.2-4.7v-11.7q0-2.6 1.2-3.4 1.2-0.8 3.4 0.5 2.3 1.3 3.4 3.4 1.2 2.2 1.2 4.8v11.7q0 2.6-1.2 3.4-1.1 0.8-3.4-0.5-2.2-1.3-3.4-3.5zm5-1v-12q0-2.2-1.6-3.1-1.5-0.9-1.5 1.2v12.1q0 2.2 1.5 3.1 1.6 0.9 1.6-1.3z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    className: "bE",
    d: "m439.1 372.5l-3.2-1.8v-2.5q1.3 0.7 2.1 0.9 0.8 0.2 1.2-0.1 0.5-0.3 0.9-1.2l2 1.2v22.1l-3-1.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7,
      mixBlendMode: "color-dodge"
    }
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bF",
    d: "m450.7 213.8q-1.2-2.1-1.2-4.8v-11.6q0-2.7 1.2-3.5 1.2-0.7 3.4 0.6 2.2 1.3 3.4 3.4 1.2 2.1 1.2 4.8v11.6q0 2.7-1.2 3.4-1.2 0.8-3.4-0.5-2.2-1.3-3.4-3.4zm5-1v-12.1q0-2.2-1.6-3.1-1.6-0.9-1.6 1.3v12.1q0 2.2 1.6 3.1 1.6 0.9 1.6-1.3z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    className: "bG",
    d: "m453.9 230.1l-3.1-1.8v-2.4q1.3 0.7 2.1 0.9 0.7 0.2 1.2-0.1 0.5-0.3 0.8-1.2l2.1 1.1v22.2l-3.1-1.8z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bH",
    d: "m450.7 274.2q-1.2-2.1-1.2-4.8v-11.6q0-2.7 1.2-3.5 1.2-0.7 3.4 0.6 2.2 1.3 3.4 3.4 1.2 2.1 1.2 4.8v11.6q0 2.7-1.2 3.4-1.2 0.8-3.4-0.5-2.2-1.3-3.4-3.4zm5-1v-12.1q0-2.2-1.6-3.1-1.6-0.9-1.6 1.3v12.1q0 2.2 1.6 3.1 1.6 0.9 1.6-1.3z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bI",
    d: "m450.7 304.4q-1.2-2.1-1.2-4.8v-11.6q0-2.7 1.2-3.5 1.2-0.7 3.4 0.6 2.2 1.2 3.4 3.4 1.2 2.1 1.2 4.8v11.6q0 2.7-1.2 3.4-1.2 0.8-3.4-0.5-2.2-1.3-3.4-3.4zm5-1v-12.1q0-2.2-1.6-3.1-1.6-0.9-1.6 1.3v12.1q0 2.2 1.6 3.1 1.6 0.9 1.6-1.3z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    className: "bJ",
    d: "m453.9 320.7l-3.1-1.8v-2.5q1.3 0.8 2.1 1 0.7 0.2 1.2-0.1 0.5-0.3 0.8-1.2l2.1 1.1v22.2l-3.1-1.8z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bK",
    d: "m450.7 364.8q-1.2-2.1-1.2-4.8v-11.6q0-2.7 1.2-3.5 1.2-0.7 3.4 0.6 2.2 1.2 3.4 3.4 1.2 2.1 1.2 4.8v11.6q0 2.7-1.2 3.4-1.2 0.8-3.4-0.5-2.2-1.3-3.4-3.4zm5-1v-12.1q0-2.2-1.6-3.1-1.6-0.9-1.6 1.3v12.1q0 2.2 1.6 3.1 1.6 0.9 1.6-1.3z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    className: "bL",
    d: "m453.9 381.1l-3.1-1.8v-2.5q1.3 0.8 2.1 1 0.7 0.2 1.2-0.1 0.5-0.3 0.8-1.2l2.1 1.1v22.2l-3.1-1.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7,
      mixBlendMode: "color-dodge"
    }
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    className: "bM",
    d: "m467.9 208l-3.2-1.8v-2.5q1.3 0.8 2.1 1 0.8 0.2 1.3-0.2 0.4-0.3 0.8-1.2l2 1.2v22.1l-3-1.7z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bN",
    d: "m464.6 252.1q-1.2-2.2-1.2-4.8v-11.7q0-2.6 1.2-3.4 1.2-0.8 3.4 0.5 2.3 1.3 3.4 3.4 1.2 2.2 1.2 4.8v11.7q0 2.6-1.2 3.4-1.1 0.8-3.4-0.5-2.2-1.3-3.4-3.4zm5-1.1v-12q0-2.2-1.6-3.1-1.5-0.9-1.5 1.3v12q0 2.2 1.5 3.1 1.6 0.9 1.6-1.3z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    className: "bO",
    d: "m467.9 268.4l-3.2-1.8v-2.5q1.3 0.8 2.1 1 0.8 0.2 1.3-0.2 0.4-0.3 0.8-1.2l2 1.2v22.1l-3-1.7z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bP",
    d: "m464.6 312.5q-1.2-2.2-1.2-4.8v-11.7q0-2.6 1.2-3.4 1.2-0.8 3.4 0.5 2.3 1.3 3.4 3.4 1.2 2.2 1.2 4.8v11.7q0 2.6-1.2 3.4-1.1 0.8-3.4-0.5-2.2-1.3-3.4-3.4zm5-1.1v-12q0-2.2-1.6-3.1-1.5-0.9-1.5 1.2v12.1q0 2.2 1.5 3.1 1.6 0.9 1.6-1.3z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bQ",
    d: "m464.6 342.6q-1.2-2.1-1.2-4.7v-11.7q0-2.6 1.2-3.4 1.2-0.8 3.4 0.5 2.3 1.3 3.4 3.4 1.2 2.2 1.2 4.8v11.7q0 2.6-1.2 3.4-1.1 0.8-3.4-0.5-2.2-1.3-3.4-3.5zm5-1v-12q0-2.2-1.6-3.1-1.5-0.9-1.5 1.2v12.1q0 2.2 1.5 3.1 1.6 0.9 1.6-1.3z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    className: "bR",
    d: "m467.9 359l-3.2-1.8v-2.5q1.3 0.7 2.1 0.9 0.8 0.2 1.3-0.1 0.4-0.3 0.8-1.2l2 1.2v22.1l-3-1.7z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bS",
    d: "m464.6 403q-1.2-2.1-1.2-4.7v-11.7q0-2.6 1.2-3.4 1.2-0.8 3.4 0.5 2.3 1.3 3.4 3.4 1.2 2.2 1.2 4.8v11.7q0 2.6-1.2 3.4-1.1 0.8-3.4-0.5-2.2-1.3-3.4-3.5zm5-1v-12q0-2.2-1.6-3.1-1.5-0.9-1.5 1.2v12.1q0 2.2 1.5 3.1 1.6 0.9 1.6-1.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7,
      mixBlendMode: "color-dodge"
    }
  }, _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bT",
    d: "m478.6 229.9q-1.2-2.1-1.2-4.8v-11.6q0-2.7 1.2-3.4 1.1-0.8 3.4 0.5 2.2 1.3 3.4 3.4 1.2 2.1 1.2 4.8v11.6q0 2.7-1.2 3.5-1.2 0.7-3.4-0.6-2.3-1.3-3.4-3.4zm5-1v-12.1q0-2.2-1.6-3.1-1.6-0.9-1.6 1.3v12.1q0 2.2 1.6 3.1 1.6 0.9 1.6-1.3z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bU",
    d: "m478.6 260.1q-1.2-2.1-1.2-4.8v-11.6q0-2.7 1.2-3.4 1.1-0.8 3.4 0.5 2.2 1.3 3.4 3.4 1.2 2.1 1.2 4.8v11.6q0 2.7-1.2 3.5-1.2 0.7-3.4-0.6-2.3-1.3-3.4-3.4zm5-1v-12.1q0-2.2-1.6-3.1-1.6-0.9-1.6 1.3v12.1q0 2.2 1.6 3.1 1.6 0.9 1.6-1.3z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bV",
    d: "m478.6 290.3q-1.2-2.1-1.2-4.8v-11.6q0-2.7 1.2-3.5 1.1-0.7 3.4 0.6 2.2 1.3 3.4 3.4 1.2 2.1 1.2 4.8v11.6q0 2.7-1.2 3.4-1.2 0.8-3.4-0.5-2.3-1.3-3.4-3.4zm5-1v-12.1q0-2.2-1.6-3.1-1.6-0.9-1.6 1.3v12.1q0 2.2 1.6 3.1 1.6 0.9 1.6-1.3z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    className: "bW",
    d: "m481.8 306.7l-3.1-1.9v-2.4q1.3 0.7 2.1 0.9 0.7 0.2 1.2-0.1 0.5-0.3 0.8-1.2l2.1 1.2v22.1l-3.1-1.8z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    className: "bX",
    d: "m481.8 336.8l-3.1-1.8v-2.4q1.3 0.7 2.1 0.9 0.7 0.2 1.2-0.1 0.5-0.3 0.8-1.2l2.1 1.2v22.1l-3.1-1.8z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    className: "bY",
    d: "m481.8 367l-3.1-1.8v-2.4q1.3 0.7 2.1 0.9 0.7 0.2 1.2-0.1 0.5-0.3 0.8-1.2l2.1 1.2v22.1l-3.1-1.8z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "bZ",
    d: "m478.6 411.1q-1.2-2.1-1.2-4.8v-11.6q0-2.7 1.2-3.5 1.1-0.7 3.4 0.6 2.2 1.3 3.4 3.4 1.2 2.1 1.2 4.8v11.6q0 2.7-1.2 3.4-1.2 0.8-3.4-0.5-2.3-1.3-3.4-3.4zm5-1v-12.1q0-2.2-1.6-3.1-1.6-0.9-1.6 1.3v12.1q0 2.2 1.6 3.1 1.6 0.9 1.6-1.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7,
      mixBlendMode: "color-dodge"
    }
  }, _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    className: "c0",
    d: "m495.8 224.1l-3.2-1.8v-2.5q1.3 0.8 2.1 1 0.8 0.2 1.3-0.2 0.4-0.3 0.8-1.2l2 1.2v22.1l-3-1.7z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    className: "c1",
    d: "m495.8 254.3l-3.2-1.8v-2.5q1.3 0.8 2.1 1 0.8 0.2 1.3-0.2 0.4-0.3 0.8-1.2l2 1.2v22.1l-3-1.7z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    className: "c2",
    d: "m495.8 284.5l-3.2-1.8v-2.5q1.3 0.8 2.1 1 0.8 0.2 1.3-0.2 0.4-0.3 0.8-1.2l2 1.2v22.1l-3-1.7z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "c3",
    d: "m492.5 328.6q-1.2-2.2-1.2-4.8v-11.7q0-2.6 1.2-3.4 1.2-0.8 3.4 0.5 2.3 1.3 3.4 3.4 1.2 2.2 1.2 4.8v11.7q0 2.6-1.2 3.4-1.1 0.8-3.4-0.5-2.2-1.3-3.4-3.4zm5-1.1v-12q0-2.2-1.6-3.1-1.5-0.9-1.5 1.3v12q0 2.2 1.5 3.1 1.6 0.9 1.6-1.3z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "c4",
    d: "m492.5 358.8q-1.2-2.2-1.2-4.8v-11.7q0-2.6 1.2-3.4 1.2-0.8 3.4 0.5 2.3 1.3 3.4 3.4 1.2 2.2 1.2 4.8v11.7q0 2.6-1.2 3.4-1.1 0.8-3.4-0.5-2.2-1.3-3.4-3.4zm5-1.1v-12q0-2.2-1.6-3.1-1.5-0.9-1.5 1.3v12q0 2.2 1.5 3.1 1.6 0.9 1.6-1.3z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "c5",
    d: "m492.5 389q-1.2-2.2-1.2-4.8v-11.7q0-2.6 1.2-3.4 1.2-0.8 3.4 0.5 2.3 1.3 3.4 3.4 1.2 2.2 1.2 4.8v11.7q0 2.6-1.2 3.4-1.1 0.8-3.4-0.5-2.2-1.3-3.4-3.4zm5-1.1v-12q0-2.2-1.6-3.1-1.5-0.9-1.5 1.3v12q0 2.2 1.5 3.1 1.6 0.9 1.6-1.3z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    className: "c6",
    d: "m495.8 405.3l-3.2-1.8v-2.5q1.3 0.8 2.1 1 0.8 0.2 1.3-0.2 0.4-0.3 0.8-1.2l2 1.2v22.1l-3-1.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      mixBlendMode: "multiply"
    }
  }, _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    className: "c7",
    d: "m215.2 136.3c-12.4-7.1-22.5-1.4-22.5 12.9v176.8c0 14.2 10.1 31.6 22.5 38.8l96.6 58.4c12.4 7.1 49.9-28.4 49.9-42.7v-136.3c0-14.2-15-30.8-27.5-38z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    className: "c8",
    d: "m213.5 137.3c-12.3-7.1-22.3-1.5-22.3 12.7v175.3c0 14.1 10 31.3 22.3 38.4l97.9 58.9c12.4 7.1 47.3-25.7 47.3-39.8v-138.5c0-14.1-14.5-30.6-26.9-37.7z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    className: "c9",
    d: "m211.8 138.2c-12.1-7.1-22-1.4-22 12.6v173.8c0 14 9.9 31 22 38l99.3 59.5c12.2 7 44.5-23 44.5-37v-140.7c0-14-14-30.3-26.1-37.4z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    className: "ca",
    d: "m210.2 139.1c-12.1-7-21.8-1.4-21.8 12.4v172.4c0 13.8 9.7 30.7 21.8 37.6l100.6 60c12 7 41.7-20.3 41.7-34.1v-142.9c0-13.8-13.4-30.1-25.4-37.1z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    className: "cb",
    d: "m208.5 140c-11.9-6.9-21.6-1.4-21.6 12.3v170.9c0 13.7 9.7 30.4 21.6 37.2l101.9 60.6c11.9 6.9 39.1-17.6 39.1-31.3v-145.1c0-13.7-12.9-29.8-24.8-36.7z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    className: "cc",
    d: "m206.8 140.9c-11.8-6.8-21.3-1.3-21.3 12.2v169.4c0 13.5 9.5 30 21.3 36.9l103.3 61.1c11.8 6.8 36.3-14.9 36.3-28.5v-147.3c0-13.5-12.3-29.6-24.1-36.4z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    className: "cd",
    d: "m205.2 141.8c-11.7-6.7-21.2-1.3-21.2 12.1v167.9c0 13.4 9.5 29.7 21.2 36.5l104.5 61.6c11.7 6.8 33.6-12.2 33.6-25.6v-149.5c0-13.4-11.7-29.3-23.4-36.1z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    className: "ce",
    d: "m203.5 142.8c-11.5-6.7-20.9-1.4-20.9 11.9v166.4c0 13.3 9.4 29.4 20.9 36.1l105.9 62.2c11.5 6.7 30.9-9.5 30.9-22.8v-151.7c0-13.2-11.2-29.1-22.7-35.8z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    className: "cf",
    d: "m201.8 143.7c-11.4-6.6-20.6-1.3-20.6 11.8v164.9c0 13.1 9.2 29.1 20.6 35.7l107.2 62.7c11.5 6.6 28.2-6.8 28.2-19.9v-153.9c0-13.1-10.6-28.9-22-35.4z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    className: "cg",
    d: "m200.2 144.6c-11.3-6.5-20.5-1.3-20.5 11.7v163.4c0 13 9.2 28.8 20.5 35.3l108.5 63.3c11.3 6.5 25.5-4.1 25.5-17.1v-156.1c0-12.9-10.1-28.6-21.4-35.1z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    className: "ch",
    d: "m198.5 145.5c-11.2-6.4-20.2-1.3-20.2 11.5v162c0 12.8 9 28.5 20.2 34.9l109.9 63.9c11.1 6.4 22.7-1.5 22.7-14.3v-158.3c0-12.8-9.5-28.4-20.7-34.8z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    className: "ci",
    d: "m196.8 146.4c-11-6.4-20-1.3-20 11.4v160.5c0 12.7 9 28.2 20 34.5l111.2 64.4c11.1 6.4 20 1.3 20-11.4v-160.5c0-12.7-8.9-28.1-20-34.5z"
  }))), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    className: "cj",
    d: "m193.5 139c-11.2-6.5-20.4-1.3-20.4 11.6v177.7c0 12.9 9.2 28.6 20.4 35.1l107.4 62.3c11.2 6.5 20.3 1.3 20.3-11.6v-177.7c0-12.9-9.1-28.6-20.3-35.1z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    className: "ck",
    d: "m300.9 201.3l-107.4-62.3c-11.2-6.5-20.4-1.3-20.4 11.6v1.9c0-12.9 9.2-18.1 20.4-11.6l107.4 62.3c11.2 6.5 20.3 22.2 20.3 35.1v-1.9c0-12.9-9.1-28.6-20.3-35.1z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      mixBlendMode: "color-dodge"
    }
  }, _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    className: "cl",
    d: "m255.3 206.2l8.8 5.1v-4.3l-8.8-5.1z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    className: "cm",
    d: "m261.4 241.5l-14.5-8.3v4.3l14.5 8.4z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    className: "cn",
    d: "m260.6 218.5v-4.3l-16.2-9.2v4.3z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    className: "co",
    d: "m243.6 222.1v4.3l8.2 4.7v-4.3z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    className: "cp",
    d: "m231.1 228.5v-4.3l-13.4-7.6v4.3z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    className: "cq",
    d: "m261.9 232.7l-5.7-3.4v4.3l5.7 3.4z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    className: "cr",
    d: "m251.1 217.7v4.3l6.9 3.9v-4.3z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    className: "cs",
    d: "m268.4 209.5v4.3l3.8 2.1v-4.3z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    className: "ct",
    d: "m246.8 219.6v-4.4l-13.9-7.9v4.3z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    className: "cu",
    d: "m265 216.7v4.3l14.6 8.5v-4.3z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    className: "cv",
    d: "m239.4 223.9v-4.3l-17.5-9.7v4.3z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    className: "cw",
    d: "m226.1 185.2v4.3l13.7 7.8v-4.3z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    className: "cx",
    d: "m251 199.4l-6.9-4v4.4l6.9 3.9z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    className: "cy",
    d: "m242.7 230.7l-7.2-4.1v4.3l7.2 4.1z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    className: "cz",
    d: "m275.8 245.1l18.6 10.8v-4.3l-18.6-10.8z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    className: "cA",
    d: "m213.4 214.2l-6.5-3.8v4.3l6.5 3.8z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    className: "cB",
    d: "m193.4 167.1v4.3l29.3 16.6v-4.3z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    className: "cC",
    d: "m280.1 238.6l6.9 4v-4.3l-6.9-4z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    className: "cD",
    d: "m283.9 232l19.4 11.3v-4.4l-19.4-11.3z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    className: "cE",
    d: "m262.3 228.4l13.6 7.8v-4.3l-13.6-7.9z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    className: "cF",
    d: "m276.5 214.1v4.3l15.4 8.8v-4.3z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    className: "cG",
    d: "m217.6 207.5l-10.7-6.1v4.3l10.7 6.1z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    className: "cH",
    d: "m271.6 238.3l-5.4-3.1v4.3l5.4 3.1z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    className: "cI",
    d: "m228.6 204.9l-21.7-12.4v4.3l21.7 12.4z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    className: "cJ",
    d: "m265.4 256.8l11.7 6.7v-4.3l-11.7-6.7z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    className: "cK",
    d: "m240.1 202.6l-33.2-19.1v4.3l33.2 19.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      mixBlendMode: "color-dodge"
    }
  }, _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    className: "cL",
    d: "m255.3 338.7l8.8 5.2v-4.3l-8.8-5.2z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    className: "cM",
    d: "m261.4 374.1l-14.5-8.4v4.3l14.5 8.4z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    className: "cN",
    d: "m260.6 351.1v-4.3l-16.2-9.2v4.3z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    className: "cO",
    d: "m243.6 354.6v4.3l8.2 4.8v-4.3z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    className: "cP",
    d: "m231.1 361.1v-4.4l-13.4-7.5v4.3z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    className: "cQ",
    d: "m261.9 365.3l-5.7-3.4v4.3l5.7 3.4z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    className: "cR",
    d: "m251.1 350.3v4.3l6.9 3.8v-4.3z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    className: "cS",
    d: "m268.4 342v4.3l3.8 2.2v-4.3z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    className: "cT",
    d: "m246.8 352.1v-4.3l-13.9-7.9v4.3z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    className: "cU",
    d: "m265 349.2v4.4l14.6 8.4v-4.3z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    className: "cV",
    d: "m239.4 356.5v-4.3l-17.5-9.8v4.3z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    className: "cW",
    d: "m226.1 317.7v4.3l13.7 7.8v-4.3z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    className: "cX",
    d: "m251 332l-6.9-4v4.3l6.9 4z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    className: "cY",
    d: "m242.7 363.3l-7.2-4.1v4.3l7.2 4.1z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    className: "cZ",
    d: "m275.8 377.6l18.6 10.9v-4.3l-18.6-10.9z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    className: "d0",
    d: "m213.4 346.7l-6.5-3.8v4.4l6.5 3.7z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    className: "d1",
    d: "m193.4 299.6v4.3l29.3 16.7v-4.3z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    className: "d2",
    d: "m280.1 371.2l6.9 4v-4.3l-6.9-4z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    className: "d3",
    d: "m283.9 364.5l19.4 11.3v-4.3l-19.4-11.3z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    className: "d4",
    d: "m262.3 360.9l13.6 7.8v-4.3l-13.6-7.8z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    className: "d5",
    d: "m276.5 346.7v4.3l15.4 8.8v-4.3z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    className: "d6",
    d: "m217.6 340l-10.7-6v4.3l10.7 6z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    className: "d7",
    d: "m271.6 370.9l-5.4-3.1v4.3l5.4 3.1z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    className: "d8",
    d: "m228.6 337.4l-21.7-12.4v4.3l21.7 12.4z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    className: "d9",
    d: "m240.1 335.1l-33.2-19v4.3l33.2 19z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      mixBlendMode: "color-dodge"
    }
  }, _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    className: "da",
    d: "m261.4 277.1l-14.5-8.4v4.4l14.5 8.3z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    className: "db",
    d: "m260.6 254.1v-4.3l-16.2-9.2v4.3z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    className: "dc",
    d: "m243.6 257.7v4.3l8.2 4.7v-4.3z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    className: "dd",
    d: "m231.1 264.1v-4.3l-13.4-7.6v4.3z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    className: "de",
    d: "m261.9 268.3l-5.7-3.4v4.3l5.7 3.4z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    className: "df",
    d: "m251.1 253.3v4.3l6.9 3.9v-4.3z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    className: "dg",
    d: "m246.8 255.2v-4.4l-13.9-7.9v4.3z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    className: "dh",
    d: "m239.4 259.5v-4.3l-17.5-9.7v4.3z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    className: "di",
    d: "m242.7 266.3l-7.2-4.1v4.3l7.2 4.1z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    className: "dj",
    d: "m275.8 280.7l18.6 10.8v-4.3l-18.6-10.8z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    className: "dk",
    d: "m213.4 249.8l-6.5-3.8v4.3l6.5 3.8z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    className: "dl",
    d: "m280.1 274.2l6.9 4v-4.3l-6.9-4z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    className: "dm",
    d: "m262.3 263.9l13.6 7.9v-4.4l-13.6-7.8z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    className: "dn",
    d: "m217.6 243.1l-10.7-6.1v4.3l10.7 6.1z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    className: "do",
    d: "m271.6 273.9l-5.4-3.1v4.3l5.4 3.1z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    className: "dp",
    d: "m228.6 240.5l-21.7-12.4v4.3l21.7 12.4z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    className: "dq",
    d: "m241.3 274.2v4.3l6.8 3.9v-4.3z"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    className: "dr",
    d: "m237 276v-4.3l-13.9-7.9v4.3z"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    className: "ds",
    d: "m270.2 295.1l6.9 4v-4.3l-6.9-4z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    className: "dt",
    d: "m252.4 284.8l13.6 7.8v-4.3l-13.6-7.8z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    className: "du",
    d: "m218.8 261.4l-21.8-12.4v4.3l21.8 12.4z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    className: "dv",
    d: "m240.1 238.2l-33.2-19.1v4.3l33.2 19.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      mixBlendMode: "color-dodge"
    }
  }, _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    className: "dw",
    d: "m261.4 321.2l-14.5-8.4v4.4l14.5 8.3z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    className: "dx",
    d: "m260.6 298.2v-4.3l-16.2-9.2v4.3z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    className: "dy",
    d: "m243.6 301.8v4.3l8.2 4.7v-4.3z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    className: "dz",
    d: "m231.1 308.2v-4.3l-13.4-7.6v4.3z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    className: "dA",
    d: "m261.9 312.4l-5.7-3.4v4.3l5.7 3.4z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    className: "dB",
    d: "m251.1 297.4v4.3l6.9 3.9v-4.3z"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    className: "dC",
    d: "m246.8 299.3v-4.4l-13.9-7.9v4.3z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    className: "dD",
    d: "m239.4 303.6v-4.3l-17.5-9.7v4.3z"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    className: "dE",
    d: "m242.7 310.4l-7.2-4.1v4.3l7.2 4.1z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    className: "dF",
    d: "m275.8 324.8l18.6 10.8v-4.3l-18.6-10.8z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    className: "dG",
    d: "m213.4 293.9l-6.5-3.8v4.3l6.5 3.8z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    className: "dH",
    d: "m280.1 318.3l6.9 4v-4.3l-6.9-4z"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    className: "dI",
    d: "m262.3 308l13.6 7.9v-4.4l-13.6-7.8z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    className: "dJ",
    d: "m217.6 287.2l-10.7-6.1v4.3l10.7 6.1z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    className: "dK",
    d: "m271.6 318l-5.4-3.1v4.3l5.4 3.1z"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    className: "dL",
    d: "m228.6 284.6l-21.7-12.4v4.3l21.7 12.4z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    className: "dM",
    d: "m241.3 318.3v4.3l6.8 3.9v-4.3z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    className: "dN",
    d: "m237 320.1v-4.3l-13.9-7.9v4.3z"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    className: "dO",
    d: "m270.2 339.2l6.9 4v-4.3l-6.9-4z"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    className: "dP",
    d: "m252.4 328.9l13.6 7.8v-4.3l-13.6-7.8z"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    className: "dQ",
    d: "m218.8 305.5l-12.5-7.2v4.3l12.5 7.2z"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    className: "dR",
    d: "m240.1 282.3l-33.2-19.1v4.3l33.2 19.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7
    }
  }, _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    className: "dS",
    d: "m193.5 433c-11.2-6.5-20.4-1.3-20.4 11.6v73c0 12.8 9.2 28.6 20.4 35.1l107.4 62.3c11.2 6.5 20.3 1.3 20.3-11.6v-73c0-12.9-9.1-28.6-20.3-35.1z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9,
      mixBlendMode: "color-dodge"
    }
  }, _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    className: "dT",
    d: "m255.3 524.8l8.8 5.1v4.3l-8.8-5.1z"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    className: "dU",
    d: "m261.4 496.5l-14.5-8.5v-4.3l14.5 8.5z"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    className: "dV",
    d: "m260.6 518.6v4.3l-16.2-9.6v-4.3z"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    className: "dW",
    d: "m243.6 495.3v-4.3l8.2 4.8v4.3z"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    className: "dX",
    d: "m231.1 474.4v4.3l-13.4-8v-4.3z"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    className: "dY",
    d: "m261.9 505.8l-5.7-3.2v-4.3l5.7 3.2z"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    className: "dZ",
    d: "m251.1 508.4v-4.3l6.9 4v4.3z"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    className: "e0",
    d: "m268.4 536.7v-4.3l3.8 2.2v4.3z"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    className: "e1",
    d: "m246.8 501.5v4.4l-13.9-8.2v-4.4z"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    className: "e2",
    d: "m265 525.4v-4.3l14.6 8.6v4.3z"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    className: "e3",
    d: "m239.4 488.5v4.3l-17.5-10.5v-4.3z"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    className: "e4",
    d: "m226.1 511.9v-4.3l13.7 8v4.3z"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    className: "e5",
    d: "m251 526.5l-6.9-4v-4.3l6.9 4z"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    className: "e6",
    d: "m242.7 485.6l-7.2-4.3v-4.3l7.2 4.2z"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    className: "e7",
    d: "m275.8 509.6l18.6 10.8v4.3l-18.6-10.8z"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    className: "e8",
    d: "m213.4 468.2l-6.5-3.9v-4.3l6.5 3.9z"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    className: "e9",
    d: "m193.4 492v-4.3l29.3 17.3v4.3z"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    className: "ea",
    d: "m280.1 521.1l6.9 4v4.3l-6.9-4z"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    className: "eb",
    d: "m283.9 532.2l19.4 11.2v4.3l-19.4-11.2z"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    className: "ec",
    d: "m262.3 510.7l13.6 7.9v4.3l-13.6-7.9z"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    className: "ed",
    d: "m276.5 541.4v-4.3l15.4 9.1v4.3z"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    className: "ee",
    d: "m217.6 479.8l-10.7-6.5v-4.3l10.7 6.4z"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    className: "ef",
    d: "m271.6 511.5l-5.4-3.2v-4.3l5.4 3.2z"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    className: "eg",
    d: "m228.6 495.1l-21.7-12.9v-4.3l21.7 12.9z"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    className: "eh",
    d: "m240.1 510.8l-33.2-19.6v-4.3l33.2 19.5z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8,
      mixBlendMode: "color-dodge"
    }
  }, _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    className: "ei",
    d: "m84.9 175.4q-3.9-3.5-5.6-7.2-1.6-3.7-1.6-7.6v-4.7q0-2.3-0.9-4-0.8-1.8-2.6-2.8v-4.7q1.8 1.1 2.6 0.3 0.9-0.7 0.9-3v-4.7q0-3.9 1.6-5.7 1.7-1.8 5.6-0.8l1.1 4.2q-1.7-0.2-2.4 1.2-0.7 1.4-0.7 4.1v4.7q0 2.4-0.9 3.7-0.9 1.3-2.7 1.3 1.8 2.2 2.7 4.5 0.9 2.4 0.9 4.7v4.7q0 2.7 0.7 4.9 0.7 2.3 2.4 3.9z"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    className: "ej",
    d: "m186.9 226.5q1.7 0.2 2.4-1.2 0.7-1.4 0.7-4.1v-4.7q0-2.4 1-3.7 0.9-1.3 2.8-1.2-1.9-2.1-2.8-4.5-1-2.4-1-4.8v-4.7q0-2.7-0.7-4.9-0.7-2.2-2.4-3.9l1.2-3q3.8 3.5 5.5 7.2 1.7 3.7 1.7 7.6v4.7q0 2.3 0.8 4.1 0.9 1.7 2.7 2.8v4.6q-1.8-1.1-2.7-0.3-0.8 0.8-0.8 3v4.7q0 3.9-1.7 5.7-1.7 1.8-5.5 0.8z"
  }))), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    className: "ek",
    d: "m168.5 209.9v-24.6l13.3 20z"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    className: "el",
    d: "m150.4 199.6v-24.6l13.3 19.9z"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    className: "em",
    d: "m132.3 189.2v-24.6l13.3 20z"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    className: "ei",
    d: "m114.3 178.9v-24.6l13.2 20z"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    className: "en",
    d: "m96.2 168.6v-24.6l13.3 19.9z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      mixBlendMode: "multiply"
    }
  }, _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    className: "eo",
    d: "m437.7 303.9c-17.7-10.2-32.1-2-32.1 18.3v32.1c0 20.3 14.4 45.1 32.1 55.3l183.7 106.4c17.7 10.3 39.1 1 39.1-19.3v-32.2c0-20.3-21.4-43.9-39.1-54.1z"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    className: "ep",
    d: "m436.7 305.4c-17.6-10.2-31.9-2.1-31.9 18.1v29.9c0 20.2 14.3 44.8 31.9 55l182.7 105.9c17.6 10.1 38.3 1 38.3-19.2v-29.9c0-20.2-20.7-43.8-38.3-54z"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    className: "eq",
    d: "m435.8 306.8c-17.6-10.1-31.8-2-31.8 18.1v27.6c0 20.1 14.2 44.6 31.8 54.7l181.5 105.3c17.6 10.1 37.6 1.1 37.6-19v-27.7c0-20.1-20-43.7-37.6-53.8z"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    className: "er",
    d: "m434.8 308.2c-17.4-10.1-31.6-2-31.6 18v25.4c0 20 14.2 44.4 31.6 54.5l180.5 104.6c17.5 10 36.8 1.2 36.8-18.8v-25.4c0-20-19.3-43.6-36.8-53.7z"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    className: "es",
    d: "m433.9 309.6c-17.4-10-31.5-2-31.5 18v23.1c0 19.9 14.1 44.1 31.5 54.2l179.4 104c17.4 10 36 1.3 36-18.6v-23.2c0-19.9-18.6-43.4-36-53.4z"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    className: "et",
    d: "m432.9 311.1c-17.3-10-31.3-2-31.3 17.8v20.9c0 19.8 14 43.9 31.3 53.9l178.4 103.4c17.3 10 35.2 1.4 35.2-18.4v-20.9c0-19.8-17.9-43.3-35.2-53.3z"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    className: "eu",
    d: "m432 312.5c-17.2-9.9-31.1-2-31.1 17.7v18.6c0 19.8 13.9 43.8 31.1 53.7l177.3 102.8c17.2 9.9 34.4 1.5 34.4-18.2v-18.6c0-19.8-17.2-43.3-34.4-53.2z"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    className: "ev",
    d: "m431 313.9c-17.1-9.8-30.9-1.9-30.9 17.7v16.3c0 19.6 13.8 43.6 30.9 53.4l176.3 102.2c17.1 9.9 33.6 1.6 33.6-18v-16.4c0-19.6-16.5-43.1-33.6-53z"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    className: "ew",
    d: "m430.1 315.4c-17-9.9-30.8-2-30.8 17.5v14.1c0 19.5 13.8 43.3 30.8 53.1l175.2 101.6c17 9.8 32.8 1.7 32.8-17.8v-14.1c0-19.6-15.8-43-32.8-52.9z"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    className: "ex",
    d: "m429.1 316.8c-16.9-9.8-30.6-2-30.6 17.5v11.8c0 19.4 13.7 43.1 30.6 52.9l174.2 100.9c16.9 9.8 32 1.8 32-17.6v-11.9c0-19.4-15.1-42.9-32-52.6z"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    className: "ey",
    d: "m428.2 318.2c-16.9-9.7-30.5-1.9-30.5 17.4v9.6c0 19.3 13.6 42.9 30.5 52.6l173.1 100.3c16.9 9.8 31.2 1.9 31.2-17.4v-9.6c0-19.4-14.3-42.8-31.2-52.5z"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    className: "ez",
    d: "m427.2 319.6c-16.7-9.6-30.3-1.9-30.3 17.3v7.4c0 19.2 13.6 42.6 30.3 52.3l172.1 99.8c16.8 9.6 30.3 1.9 30.3-17.3v-7.4c0-19.2-13.5-42.6-30.3-52.3z"
  }))), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    className: "eA",
    d: "m619.6 514.6l-201.3-116.6c-14.5-8.4-26.3-31-26.3-50.3v-13.7c0-19.3 11.8-28.3 26.3-19.9l201.3 116.6c14.5 8.4 26.4 31 26.4 50.3v13.7c0 19.3-11.9 28.3-26.4 19.9z"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    className: "eB",
    d: "m619.6 430.7l-201.3-116.6c-14.5-8.4-26.3 0.6-26.3 19.9v2.9c0-19.3 11.8-28.2 26.3-19.9l201.3 116.7c14.5 8.3 26.4 30.9 26.4 50.2v-2.9c0-19.3-11.9-41.9-26.4-50.3z"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    className: "eC",
    d: "m481.1 394.8c0 16.7-11.7 23.4-26.3 15-14.5-8.3-26.2-28.6-26.2-45.3 0-16.6 11.7-23.3 26.2-15 14.6 8.4 26.3 28.7 26.3 45.3z"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    className: "eD",
    d: "m542.6 431.5c0 16.6-11.7 23.3-26.2 14.9-14.5-8.3-26.3-28.6-26.3-45.3 0-16.6 11.8-23.3 26.3-14.9 14.5 8.3 26.2 28.6 26.2 45.3z"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    className: "eE",
    d: "m604.6 466.8c0 16.7-11.7 23.4-26.2 15-14.5-8.4-26.3-28.7-26.3-45.3 0-16.7 11.8-23.4 26.3-15 14.5 8.4 26.2 28.7 26.2 45.3z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "multiply"
    }
  }, _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    className: "eF",
    d: "m456.2 409.2c-14.5-8.4-26.3-28.7-26.3-45.4 0-8.1 2.9-13.9 7.5-16.7-5.4 2.4-8.8 8.5-8.8 17.4 0 16.7 11.7 37 26.2 45.3 7.4 4.3 14.1 4.6 18.8 1.8-4.6 2-10.7 1.4-17.4-2.4z"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    className: "eG",
    d: "m517.7 445.8c-14.5-8.4-26.3-28.7-26.3-45.3 0-8.2 2.9-14 7.5-16.8-5.4 2.4-8.8 8.5-8.8 17.4 0 16.7 11.8 37 26.3 45.3 7.3 4.3 14 4.7 18.7 1.8-4.6 2.1-10.7 1.5-17.4-2.4z"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    className: "eH",
    d: "m579.7 481.1c-14.5-8.4-26.3-28.6-26.3-45.3 0-8.2 2.9-14 7.5-16.7-5.4 2.4-8.8 8.4-8.8 17.4 0 16.6 11.8 36.9 26.3 45.3 7.3 4.2 14 4.6 18.7 1.7-4.6 2.1-10.7 1.5-17.4-2.4z"
  }))), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    className: "eI",
    d: "m614.7 458.6v26.9l14.5-5.1zm-196-87.2v-26.9l-14.6 5z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    className: "eJ",
    d: "m440.4 387q-1.8-3.3-1.8-7.4v-19q0-4.1 1.8-5.4 1.9-1.2 5.3 0.8 3.5 2 5.3 5.4 1.9 3.3 1.9 7.4v3.8l-4.6-2.7v-4.1q0-3.3-2.4-4.6-2.5-1.4-2.5 1.8v19.8q0 3.2 2.5 4.6 2.4 1.4 2.4-1.8v-5.4l4.6 2.6v5q0 4.1-1.9 5.4-1.8 1.2-5.3-0.8-3.4-2-5.3-5.4z"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "eK",
    d: "m456.8 388.2l-2.1-1.3 0.3-3.7 2.2 1.2 0.8-8.7-2.2-1.3 0.4-3.7 2.2 1.2 0.7-7.6 3.8 2.2-0.7 7.7 3.1 1.8 0.8-7.7 3.8 2.2-0.8 7.7 2.3 1.3-0.4 3.7-2.2-1.3-0.9 8.8 2.3 1.3-0.4 3.7-2.2-1.3-0.9 9.6-3.9-2.3 1-9.5-3.2-1.8-0.9 9.5-3.8-2.2zm7.3 0.3l0.8-8.7-3.1-1.8-0.8 8.7z"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    className: "eL",
    d: "m504.7 427.6v-5q0.7 0.6 1.6 1.1 1.4 0.8 2.1 0.4 0.7-0.4 0.7-2.1v-27.1l4.9 2.7v27q0 4.3-1.8 5.5-1.7 1.1-5.3-1-1.3-0.7-2.2-1.5z"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    className: "eM",
    d: "m518.4 433.8q-1.8-3.4-1.8-7.7v-2l4.6 2.7v2.4q0 3.4 2.5 4.9 1.2 0.7 1.8 0.2 0.7-0.5 0.7-2.3 0-2.3-0.9-4.5-0.9-2.2-3.3-5.9-2.9-4.8-4.1-7.9-1.2-3.1-1.2-6.2 0-4.2 1.8-5.4 1.9-1.2 5.4 0.8 3.5 2 5.3 5.3 1.7 3.3 1.7 7.6v1.5l-4.5-2.6v-1.9q0-1.8-0.7-3-0.6-1.2-1.8-1.8-2.4-1.4-2.4 1.9 0 2 0.9 4.1 0.9 2.2 3.3 6 3 4.8 4.2 7.9 1.1 3.1 1.1 6.5 0 4.3-1.8 5.5-1.9 1.3-5.5-0.8-3.5-2-5.3-5.3z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "eN",
    d: "m571.2 429.1l7.5 4.3q3.9 2.2 5.7 5.4 1.8 3.1 1.8 7.4v2.3q0 5.7-3.4 5.4v0.1q1.9 1.7 2.6 4 0.8 2.4 0.8 5.7v6.5q0 1.6 0.1 2.6 0.1 1 0.5 2.2l-5.2-3q-0.3-1-0.4-1.9-0.1-0.8-0.1-2.9v-6.7q0-2.6-0.7-4-0.7-1.4-2.4-2.4l-1.8-1v15.8l-5-2.9zm6.9 19.8q1.5 0.9 2.2 0.4 0.8-0.4 0.8-2.5v-2.9q0-2-0.6-3.2-0.6-1.3-2-2.1l-2.3-1.3v10.6z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    className: "eO",
    d: "m619.6 636.6l-201.3-116.6c-14.5-8.4-26.3-31-26.3-50.3v-13.7c0-19.3 11.8-28.3 26.3-19.9l201.3 116.6c14.5 8.4 26.4 31 26.4 50.3v13.7c0 19.3-11.9 28.3-26.4 19.9z"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    className: "eP",
    d: "m542.6 553.5c0 16.6-11.7 23.3-26.2 14.9-14.5-8.3-26.3-28.6-26.3-45.3 0-16.6 11.8-23.3 26.3-14.9 14.5 8.3 26.2 28.6 26.2 45.3z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    className: "eQ",
    d: "m506.9 515.5q3.6 2 5.3 5.2 1.8 3.1 1.8 7.4v27l-4.9-2.8v-27.1q0-1.7-0.7-3-0.7-1.2-2.1-2.1-0.9-0.5-1.6-0.7v-5q0.9 0.3 2.2 1.1z"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    className: "eR",
    d: "m523.7 524.9q3.6 2.1 5.5 5.5 1.8 3.4 1.8 7.8 0 3.3-1.1 5.1-1.2 1.8-4.2 3.1-2.4 1-3.3 2.1-0.9 1.2-0.9 3.1 0 3.4 2.4 4.8 1.2 0.7 1.8 0.2 0.7-0.5 0.7-2.3v-1.8l4.5 2.6v1.5q0 4.3-1.7 5.6-1.8 1.2-5.3-0.8-3.5-2.1-5.4-5.4-1.8-3.4-1.8-7.6 0-3.1 1.2-4.8 1.2-1.8 4.1-3.1 2.4-1 3.3-2.1 0.9-1.2 0.9-3.4 0-1.9-0.7-3.1-0.6-1.2-1.8-1.9-2.5-1.5-2.5 1.9v2.5l-4.6-2.7v-2q0-4.3 1.8-5.6 1.8-1.2 5.3 0.8z"
  })))), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "eS",
    d: "m175 276.5l3.8 4.9q-0.6 2.2-1.7 3.8l-4.4-3.7q-1.1 1.1-2.7 1.5l1.1 5.6q-2 0.2-4.2-0.4l-2.3-5.7q-0.9-0.4-1.9-1-1-0.5-1.9-1.2l-2.4 3q-2.2-2-4.1-4.4l1-4.4q-1.5-2.2-2.7-4.6l-4.3-1.4q-1.2-2.8-1.8-5.7l3.8-0.5q-0.1-1.2-0.1-2.3 0-1.1 0.1-2.1l-3.8-4.9q0.6-2.2 1.8-3.7l4.3 3.7q1.2-1.2 2.7-1.6l-1-5.6q1.9-0.2 4.1 0.4l2.4 5.8q0.9 0.3 1.9 0.9 1 0.6 1.9 1.3l2.3-3q2.2 1.9 4.2 4.3l-1.1 4.4q1.6 2.2 2.7 4.7l4.4 1.3q1.1 2.9 1.7 5.8l-3.8 0.4q0.2 1.2 0.2 2.3 0 1.1-0.2 2.1zm-7.3-6.4c0-3.2-2.3-7-5-8.6-2.8-1.6-5-0.4-5 2.8 0 3.2 2.2 7.1 5 8.7 2.7 1.6 5 0.3 5-2.9z"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "el",
    d: "m132.5 372.5l-1-1.9c-0.8-1.3-0.8-2.8 0-3.2l6.2-3.6c0.7-0.4 1.7 0.1 2.4 1.1l1.9-1.1c-2.8-5.7-2.5-11.5 0.8-13.4 3.6-2.1 9.5 1.3 13.1 7.5 3.6 6.3 3.6 13 0 15.1-3.3 1.9-8.5-0.8-12.1-6.1l-1.9 1.1c0.5 1.1 0.4 2.2-0.3 2.6l-6.2 3.5c-0.8 0.5-2.1-0.3-2.9-1.6zm21.2-3.4c2.3-1.3 2.3-5.8 0-9.9-2.4-4.1-6.3-6.3-8.7-5-2.4 1.4-2.4 5.8 0 9.9 2.4 4.1 6.3 6.4 8.7 5z"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "eT",
    d: "m615.6 307.2l-0.3 3.1c-0.9 10.9-5.5 15.3-13 18.2l-0.1-0.1c-7.5-11.5-12.1-21.3-13-33.2l-0.3-3.3 0.2 0.1c4.7 2.7 9.3 3.7 13.1 2.9h0.1c3.8 5.3 8.4 9.6 13.1 12.2zm-6.5 1.9h-0.1c-2.4-1.4-4.7-3.6-6.7-6.3-2 0.4-4.4-0.1-6.8-1.5v-0.1l0.1 1.8c0.4 6 2.8 11 6.6 16.9l0.1 0.1c3.8-1.5 6.2-3.8 6.7-9.3z"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    className: "eU",
    d: "m573.7 218.1l-18.3-10.6v4.2l18.3 10.5zm-1.7 8.5l-15.3-8.8v4.1l15.3 8.9zm14.2-1.4l-9.6-5.5v4.1l9.6 5.6zm-11.4-12l4.4 2.5v-4.1l-4.4-2.5zm15.1-10.3l19.9 11.4v-4.1l-19.9-11.5zm12.2 22l-19.9-11.5v4.1l19.9 11.5zm-19.8 11.7l19.9 11.5v-4.1l-19.9-11.5zm24.2-18.7l-7.2-4.2v4.2l7.2 4.1zm-17.3 13.2l7.1 4.1v-4.1l-7.1-4.2zm-44.4-29.7l-3.4-1.9v4.1l3.4 1.9zm30.2 31.1l4.4 2.5v-4.1l-4.4-2.5zm-21.2-16.4l-12.4-7.1v4.1l12.4 7.1zm7.5-33.7l-12.5-7.2v4.1l12.5 7.3zm-8.8 27.5v-4.1l-4.8-2.8v4.2zm34.3 0.7l9.6 5.5v-4.1l-9.6-5.5zm-4.3-12l4.5 2.6v-4.1l-4.5-2.6zm-16.9-0.3l18.2 10.6v-4.2l-18.2-10.5zm-12-1.5l-12.2-7v4.1l12.2 7zm42.2-4.2v4.2l9.6 5.5v-4.1zm12.5 11.3l8 4.7v-4.2l-8-4.6zm8 73.4l-17-9.8v4.1l17 9.8zm-6.9-53.7l6.9 4v-4.1l-6.9-4zm-4.4 6.9l11.3 6.6v-4.1l-11.3-6.6zm0.2 19.1l11.1 6.5v-4.1l-11.1-6.5zm-5.9-12.9l17 9.8v-4.1l-17-9.8zm13.4-20.8l3.6 2.1v-4.1l-3.6-2.1zm-51.2-39.1l12.9 7.4v-4.1l-12.9-7.4zm34.8 88.9l-7.2-4.2v4.1l7.2 4.2zm-33.7-73.4l-10.1-5.8v4.1l10.1 5.9zm-13.1-7.6l-8.1-4.7v4.1l8.1 4.7zm7 17.7l15.3 8.8v-4.1l-15.3-8.8zm-10.7-29.3l-4.4-2.6v4.1l4.4 2.6zm18.5 14.7l15.3 8.9v-4.2l-15.3-8.8zm13.1-1.9l15.4 8.9v-4.1l-15.4-9zm27.6 80.5l11.3 6.5v-4.1l-11.3-6.6zm-22.9-13.2l19.9 11.5v-4.1l-19.9-11.5zm-7.3-4.2l4.4 2.5v-4.1l-4.4-2.6zm-18.3-10.5l15.3 8.8v-4.1l-15.3-8.8z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    className: "eV",
    d: "m184.8 110.2l-3.9 3.6v0.1l6.1 2.6v3.1l-6.1-4.3v0.1l3.9 7.7-2.5 0.2-2.5-7.8v-0.1l-2.7 5-2.3-3 3.9-3.4v-0.1l-6-2.6v-3.1l5.9 4.3v-0.1l-3.8-7.8 2.5-0.2 2.5 7.9h0.1l2.4-5.1z"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    className: "eW",
    d: "m201.5 119.9l-3.8 3.5v0.1l6.1 2.6v3.2l-6.1-4.4v0.1l3.8 7.8-2.5 0.2-2.4-7.9h-0.1l-2.6 5-2.3-3 3.8-3.4v-0.1l-6-2.6v-3.1l6 4.3v-0.1l-3.8-7.9 2.4-0.2 2.5 7.9 0.1 0.1 2.5-5.1z"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    className: "eX",
    d: "m218.2 129.5l-3.8 3.6v0.1l6.1 2.6v3.1l-6.1-4.3v0.1l3.9 7.8-2.6 0.2-2.4-7.9h-0.1l-2.6 5-2.3-3 3.8-3.5v-0.1l-5.9-2.5v-3.2l5.9 4.3v-0.1l-3.8-7.8 2.5-0.2 2.5 7.9h0.1l2.4-5z"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    className: "eY",
    d: "m235 139.2l-3.9 3.6v0.1l6.1 2.6v3.1l-6.1-4.3v0.1l3.9 7.7-2.5 0.2-2.5-7.8v-0.1l-2.7 5-2.3-3 3.9-3.4v-0.1l-6-2.6v-3.1l5.9 4.3v-0.1l-3.8-7.8 2.5-0.2 2.5 7.8 0.1 0.1 2.4-5.1z"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    className: "eZ",
    d: "m251.7 148.9l-3.8 3.5v0.1l6.1 2.6v3.2l-6.1-4.4v0.1l3.8 7.8-2.5 0.2-2.4-7.9h-0.1l-2.6 5-2.3-3 3.8-3.4v-0.1l-6-2.6v-3.1l6 4.3v-0.1l-3.8-7.9 2.4-0.2 2.5 7.9 0.1 0.1 2.5-5.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      mixBlendMode: "color-dodge"
    }
  }, _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    className: "ej",
    d: "m258.3 110.4q-0.2-0.1-0.4-0.4-0.2-0.3-0.2-0.6v-2.7q0-0.4 0.2-0.6 0.2-0.1 0.6-0.2l7.3-1.4-7.3-9.8q-0.4-0.5-0.6-0.9-0.2-0.4-0.2-0.8v-2.7q0-0.3 0.2-0.4 0.2-0.1 0.4 0.1 0.3 0.1 0.6 0.6l10.2 13.9q0.5 0.6 0.7 1.1 0.2 0.5 0.2 0.9v0.9q0 0.4-0.2 0.7-0.2 0.2-0.7 0.3l-10.2 2.1q-0.3 0.1-0.6-0.1z"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    className: "ej",
    d: "m253.7 112.6l-2-1.2q-0.3-0.2-0.6-0.6-0.2-0.3-0.3-0.6l-10.3-34.2q0-0.2 0-0.4 0-0.3 0.1-0.4 0.2-0.1 0.5 0l2 1.2q0.3 0.2 0.6 0.5 0.2 0.4 0.3 0.8l10.2 34.1q0.1 0.2 0.1 0.4 0 0.3-0.2 0.4-0.2 0.1-0.4 0z"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    className: "ej",
    d: "m236.5 97.8q-0.3-0.2-0.6-0.6l-10.2-13.9q-0.5-0.6-0.7-1.1-0.2-0.5-0.2-0.9v-0.9q0-0.4 0.2-0.7 0.2-0.2 0.7-0.3l10.2-2.1q0.3-0.1 0.6 0 0.2 0.2 0.4 0.5 0.2 0.3 0.2 0.6v2.7q0 0.4-0.2 0.6-0.2 0.1-0.6 0.2l-7.3 1.4 7.3 9.8q0.4 0.5 0.6 0.9 0.2 0.4 0.2 0.8v2.7q0 0.3-0.2 0.4-0.2 0-0.4-0.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    className: "f0",
    d: "m619.4 258.3l44.7 26.1v-4.1l-44.7-26.1zm0-9.5l44.7 26v-4.1l-44.7-26zm0 26.4l44.7 26v-4.1l-44.7-26.1zm0 8.5l44.7 26v-4.1l-44.7-26zm0-53.9l44.7 26v-4.1l-44.7-26zm0-23.2v4.1l44.7 26.1v-4.1zm0 32.6l44.7 26.1v-4.1l-44.7-26.1zm0-19l44.7 26v-4.1l-44.7-26z"
  }))), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    className: "f1",
    d: "m176.4 120.2c-0.1 0.2-0.1 0.3 0 0z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    className: "f2",
    d: "m528.1 252.3l-2.5-1.4v-2q1 0.6 1.6 0.8 0.6 0.1 1-0.1 0.4-0.3 0.7-1l1.6 1v17.6l-2.4-1.4z"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "f3",
    d: "m534.9 268.8q-1-1.7-1-3.8v-9.3q0-2.1 1-2.7 0.9-0.6 2.7 0.4 1.8 1 2.7 2.7 1 1.7 1 3.9v9.2q0 2.1-1 2.7-0.9 0.6-2.7-0.4-1.8-1-2.7-2.7zm4-0.8v-9.6q0-1.8-1.3-2.5-1.2-0.7-1.2 1v9.6q0 1.8 1.2 2.5 1.3 0.7 1.3-1z"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "f4",
    d: "m544.3 274.2q-0.9-1.7-0.9-3.8v-9.2q0-2.1 0.9-2.8 1-0.6 2.7 0.5 1.8 1 2.7 2.7 1 1.7 1 3.8v9.2q0 2.2-1 2.8-0.9 0.6-2.7-0.4-1.7-1.1-2.7-2.8zm4-0.8v-9.6q0-1.7-1.3-2.4-1.2-0.8-1.2 1v9.6q0 1.7 1.2 2.4 1.3 0.8 1.3-1z"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "f5",
    d: "m553.7 279.7q-0.9-1.7-0.9-3.8v-9.3q0-2.1 0.9-2.7 1-0.6 2.7 0.4 1.8 1 2.8 2.7 0.9 1.7 0.9 3.8v9.3q0 2.1-0.9 2.7-1 0.6-2.8-0.4-1.7-1-2.7-2.7zm4-0.8v-9.6q0-1.8-1.3-2.5-1.2-0.7-1.2 1v9.6q0 1.8 1.2 2.5 1.3 0.7 1.3-1z"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    className: "f6",
    d: "m565.8 274.1l-2.6-1.5v-1.9q1.1 0.6 1.7 0.7 0.6 0.2 1-0.1 0.4-0.2 0.6-0.9l1.7 0.9v17.6l-2.4-1.4z"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "f7",
    d: "m572.6 290.5q-1-1.7-1-3.8v-9.2q0-2.1 1-2.7 0.9-0.7 2.7 0.4 1.8 1 2.7 2.7 0.9 1.7 0.9 3.8v9.3q0 2.1-0.9 2.7-0.9 0.6-2.7-0.4-1.8-1.1-2.7-2.8zm3.9-0.8v-9.6q0-1.7-1.2-2.4-1.3-0.7-1.3 1v9.6q0 1.7 1.3 2.5 1.2 0.7 1.2-1.1z"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    className: "f8",
    d: "m584.6 285l-2.5-1.5v-1.9q1 0.5 1.6 0.7 0.7 0.2 1-0.1 0.4-0.2 0.7-0.9l1.6 0.9v17.6l-2.4-1.4z"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "f9",
    d: "m591.4 301.4q-0.9-1.7-0.9-3.8v-9.2q0-2.2 0.9-2.8 1-0.6 2.7 0.4 1.8 1.1 2.7 2.8 1 1.7 1 3.8v9.2q0 2.1-1 2.8-0.9 0.6-2.7-0.5-1.7-1-2.7-2.7zm4-0.8v-9.6q0-1.7-1.3-2.4-1.2-0.8-1.2 1v9.6q0 1.7 1.2 2.4 1.3 0.8 1.3-1z"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    className: "fa",
    d: "m603.4 295.9l-2.5-1.5v-2q1.1 0.6 1.7 0.8 0.6 0.1 1-0.1 0.3-0.3 0.6-1l1.7 1v17.6l-2.5-1.4z"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    className: "fb",
    d: "m612.9 301.3l-2.6-1.5v-1.9q1.1 0.6 1.7 0.7 0.6 0.2 1-0.1 0.4-0.2 0.7-0.9l1.6 0.9v17.6l-2.4-1.4z"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    className: "fc",
    d: "m622.3 306.7l-2.5-1.4v-2q1 0.6 1.6 0.8 0.6 0.1 1-0.1 0.4-0.3 0.7-1l1.6 0.9v17.6l-2.4-1.3z"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "fd",
    d: "m629.1 323.2q-0.9-1.7-0.9-3.8v-9.3q0-2.1 0.9-2.7 0.9-0.6 2.7 0.4 1.8 1 2.7 2.7 1 1.7 1 3.8v9.3q0 2.1-1 2.7-0.9 0.6-2.7-0.4-1.8-1-2.7-2.7zm4-0.8v-9.6q0-1.8-1.3-2.5-1.2-0.7-1.2 1v9.6q0 1.8 1.2 2.5 1.3 0.7 1.3-1z"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "fe",
    d: "m638.5 328.6q-0.9-1.7-0.9-3.8v-9.2q0-2.2 0.9-2.8 1-0.6 2.7 0.4 1.8 1.1 2.8 2.8 0.9 1.7 0.9 3.8v9.2q0 2.1-0.9 2.8-1 0.6-2.8-0.5-1.7-1-2.7-2.7zm4-0.8v-9.6q0-1.7-1.3-2.4-1.2-0.8-1.2 1v9.6q0 1.7 1.2 2.4 1.3 0.8 1.3-1z"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    className: "ff",
    d: "m528.1 273.5l-2.5-1.4v-2q1 0.6 1.6 0.8 0.6 0.1 1-0.1 0.4-0.3 0.7-1l1.6 1v17.6l-2.4-1.4z"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    className: "fg",
    d: "m537.5 279l-2.5-1.5v-1.9q1 0.6 1.6 0.7 0.7 0.2 1-0.1 0.4-0.2 0.7-0.9l1.6 0.9v17.6l-2.4-1.4z"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "fh",
    d: "m544.3 295.4q-0.9-1.7-0.9-3.8v-9.2q0-2.1 0.9-2.8 1-0.6 2.7 0.5 1.8 1 2.7 2.7 1 1.7 1 3.8v9.3q0 2.1-1 2.7-0.9 0.6-2.7-0.4-1.7-1.1-2.7-2.8zm4-0.8v-9.6q0-1.7-1.3-2.4-1.2-0.7-1.2 1v9.6q0 1.7 1.2 2.4 1.3 0.8 1.3-1z"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    className: "fi",
    d: "m556.3 289.9l-2.5-1.5v-2q1 0.6 1.7 0.8 0.6 0.2 1-0.1 0.3-0.2 0.6-1l1.6 1v17.6l-2.4-1.4z"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "fj",
    d: "m563.2 306.3q-1-1.7-1-3.8v-9.2q0-2.2 1-2.8 0.9-0.6 2.7 0.4 1.7 1.1 2.7 2.8 0.9 1.7 0.9 3.8v9.2q0 2.1-0.9 2.8-1 0.6-2.7-0.5-1.8-1-2.7-2.7zm3.9-0.8v-9.6q0-1.7-1.2-2.4-1.3-0.8-1.3 1v9.6q0 1.7 1.3 2.4 1.2 0.7 1.2-1z"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    className: "fk",
    d: "m575.2 300.7l-2.5-1.4v-2q1 0.6 1.6 0.8 0.6 0.1 1-0.1 0.4-0.3 0.7-1l1.6 1v17.6l-2.4-1.4z"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "fl",
    d: "m582 317.2q-0.9-1.7-0.9-3.8v-9.3q0-2.1 0.9-2.7 0.9-0.6 2.7 0.4 1.8 1 2.7 2.7 1 1.7 1 3.9v9.2q0 2.1-1 2.7-0.9 0.6-2.7-0.4-1.8-1-2.7-2.7zm4-0.8v-9.6q0-1.7-1.3-2.5-1.2-0.7-1.2 1v9.7q0 1.7 1.2 2.4 1.3 0.7 1.3-1z"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    className: "fm",
    d: "m594 311.6l-2.5-1.4v-2q1 0.6 1.7 0.8 0.6 0.1 1-0.1 0.3-0.3 0.6-1l1.6 0.9v17.6l-2.4-1.4z"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    className: "fn",
    d: "m603.4 317.1l-2.5-1.5v-2q1.1 0.6 1.7 0.8 0.6 0.2 1-0.1 0.3-0.2 0.6-1l1.7 1v17.6l-2.5-1.4z"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    className: "fo",
    d: "m612.9 322.5l-2.6-1.5v-1.9q1.1 0.6 1.7 0.7 0.6 0.2 1-0.1 0.4-0.2 0.7-0.9l1.6 0.9v17.6l-2.4-1.4z"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "fp",
    d: "m619.7 339q-1-1.7-1-3.9v-9.2q0-2.1 1-2.7 0.9-0.6 2.7 0.4 1.8 1 2.7 2.7 1 1.7 1 3.8v9.3q0 2.1-1 2.7-0.9 0.6-2.7-0.4-1.8-1-2.7-2.7zm3.9-0.8v-9.7q0-1.7-1.2-2.4-1.3-0.7-1.3 1v9.6q0 1.7 1.3 2.5 1.2 0.7 1.2-1z"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "fq",
    d: "m629.1 344.4q-0.9-1.7-0.9-3.8v-9.3q0-2.1 0.9-2.7 0.9-0.6 2.7 0.4 1.8 1 2.7 2.7 1 1.7 1 3.9v9.2q0 2.1-1 2.7-0.9 0.6-2.7-0.4-1.8-1-2.7-2.7zm4-0.8v-9.6q0-1.8-1.3-2.5-1.2-0.7-1.2 1v9.6q0 1.8 1.2 2.5 1.3 0.7 1.3-1z"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    className: "fr",
    d: "m641.1 338.8l-2.5-1.4v-2q1 0.6 1.7 0.8 0.6 0.1 1-0.1 0.3-0.3 0.6-1l1.6 0.9v17.6l-2.4-1.4z"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "fs",
    d: "m525.5 305.8q-1-1.7-1-3.8v-9.3q0-2.1 1-2.7 0.9-0.6 2.7 0.4 1.8 1 2.7 2.7 0.9 1.7 0.9 3.8v9.3q0 2.1-0.9 2.7-0.9 0.6-2.7-0.4-1.8-1-2.7-2.7zm3.9-0.8v-9.6q0-1.8-1.2-2.5-1.3-0.7-1.3 1v9.6q0 1.8 1.3 2.5 1.2 0.7 1.2-1z"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "ft",
    d: "m534.9 311.2q-1-1.7-1-3.8v-9.3q0-2.1 1-2.7 0.9-0.6 2.7 0.4 1.8 1.1 2.7 2.8 1 1.7 1 3.8v9.2q0 2.1-1 2.8-0.9 0.6-2.7-0.5-1.8-1-2.7-2.7zm4-0.8v-9.6q0-1.7-1.3-2.4-1.2-0.8-1.2 1v9.6q0 1.7 1.2 2.4 1.3 0.7 1.3-1z"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    className: "fu",
    d: "m546.9 305.6l-2.5-1.4v-2q1 0.6 1.7 0.8 0.6 0.1 0.9-0.1 0.4-0.3 0.7-1l1.6 1v17.6l-2.4-1.4z"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "fv",
    d: "m553.7 322.1q-0.9-1.7-0.9-3.8v-9.3q0-2.1 0.9-2.7 1-0.6 2.7 0.4 1.8 1 2.8 2.7 0.9 1.7 0.9 3.9v9.2q0 2.1-0.9 2.7-1 0.6-2.8-0.4-1.7-1-2.7-2.7zm4-0.8v-9.6q0-1.8-1.3-2.5-1.2-0.7-1.2 1v9.6q0 1.8 1.2 2.5 1.3 0.7 1.3-1z"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    className: "fw",
    d: "m565.8 316.5l-2.6-1.4v-2q1.1 0.6 1.7 0.8 0.6 0.1 1-0.1 0.4-0.3 0.6-1l1.7 0.9v17.6l-2.4-1.4z"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    className: "fx",
    d: "m575.2 322l-2.5-1.5v-2q1 0.6 1.6 0.8 0.6 0.2 1-0.1 0.4-0.2 0.7-1l1.6 1v17.6l-2.4-1.4z"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    className: "fy",
    d: "m584.6 327.4l-2.5-1.5v-1.9q1 0.6 1.6 0.7 0.7 0.2 1-0.1 0.4-0.2 0.7-0.9l1.6 0.9v17.6l-2.4-1.4z"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "fz",
    d: "m591.4 343.8q-0.9-1.7-0.9-3.8v-9.2q0-2.1 0.9-2.7 1-0.7 2.7 0.4 1.8 1 2.7 2.7 1 1.7 1 3.8v9.3q0 2.1-1 2.7-0.9 0.6-2.7-0.4-1.7-1.1-2.7-2.8zm4-0.8v-9.6q0-1.7-1.3-2.4-1.2-0.7-1.2 1v9.6q0 1.7 1.2 2.5 1.3 0.7 1.3-1.1z"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "fA",
    d: "m600.8 349.3q-0.9-1.7-0.9-3.8v-9.3q0-2.1 0.9-2.7 1-0.6 2.8 0.4 1.7 1 2.7 2.7 0.9 1.7 0.9 3.8v9.3q0 2.1-0.9 2.7-1 0.6-2.7-0.4-1.8-1-2.8-2.7zm4-0.8v-9.6q0-1.8-1.2-2.5-1.3-0.7-1.3 1v9.6q0 1.8 1.3 2.5 1.2 0.7 1.2-1z"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    className: "fB",
    d: "m612.9 343.7l-2.6-1.4v-2q1.1 0.6 1.7 0.7 0.6 0.2 1 0 0.4-0.3 0.7-1l1.6 0.9v17.6l-2.4-1.4z"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "fC",
    d: "m619.7 360.2q-1-1.7-1-3.8v-9.3q0-2.1 1-2.7 0.9-0.6 2.7 0.4 1.8 1 2.7 2.7 1 1.7 1 3.8v9.3q0 2.1-1 2.7-0.9 0.6-2.7-0.4-1.8-1-2.7-2.7zm3.9-0.8v-9.6q0-1.8-1.2-2.5-1.3-0.7-1.3 1v9.6q0 1.8 1.3 2.5 1.2 0.7 1.2-1z"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    className: "fD",
    d: "m631.7 354.6l-2.5-1.5v-1.9q1 0.6 1.6 0.7 0.7 0.2 1-0.1 0.4-0.2 0.7-0.9l1.6 0.9v17.6l-2.4-1.4z"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "fE",
    d: "m638.5 371q-0.9-1.7-0.9-3.8v-9.2q0-2.1 0.9-2.7 1-0.7 2.7 0.4 1.8 1 2.8 2.7 0.9 1.7 0.9 3.8v9.3q0 2.1-0.9 2.7-1 0.6-2.8-0.4-1.7-1.1-2.7-2.8zm4-0.8v-9.6q0-1.7-1.3-2.4-1.2-0.7-1.2 1v9.6q0 1.7 1.2 2.5 1.3 0.7 1.3-1.1z"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    className: "fF",
    d: "m528.1 316l-2.5-1.5v-1.9q1 0.5 1.6 0.7 0.6 0.2 1-0.1 0.4-0.2 0.7-0.9l1.6 0.9v17.6l-2.4-1.4z"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    className: "fG",
    d: "m537.5 321.4l-2.5-1.4v-2q1 0.6 1.6 0.7 0.7 0.2 1 0 0.4-0.3 0.7-1l1.6 0.9v17.6l-2.4-1.4z"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "fH",
    d: "m544.3 337.9q-0.9-1.7-0.9-3.9v-9.2q0-2.1 0.9-2.7 1-0.6 2.7 0.4 1.8 1 2.7 2.7 1 1.7 1 3.8v9.3q0 2.1-1 2.7-0.9 0.6-2.7-0.4-1.7-1-2.7-2.7zm4-0.8v-9.6q0-1.8-1.3-2.5-1.2-0.7-1.2 1v9.6q0 1.8 1.2 2.5 1.3 0.7 1.3-1z"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "fI",
    d: "m553.7 343.3q-0.9-1.7-0.9-3.8v-9.3q0-2.1 0.9-2.7 1-0.6 2.7 0.4 1.8 1.1 2.8 2.7 0.9 1.8 0.9 3.9v9.2q0 2.1-0.9 2.7-1 0.7-2.8-0.4-1.7-1-2.7-2.7zm4-0.8v-9.6q0-1.7-1.3-2.5-1.2-0.7-1.2 1.1v9.6q0 1.7 1.2 2.4 1.3 0.7 1.3-1z"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "fJ",
    d: "m563.2 348.7q-1-1.7-1-3.8v-9.2q0-2.1 1-2.7 0.9-0.7 2.7 0.4 1.7 1 2.7 2.7 0.9 1.7 0.9 3.8v9.3q0 2.1-0.9 2.7-1 0.6-2.7-0.4-1.8-1.1-2.7-2.8zm3.9-0.8v-9.6q0-1.7-1.2-2.4-1.3-0.7-1.3 1v9.6q0 1.7 1.3 2.4 1.2 0.8 1.2-1z"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "fK",
    d: "m572.6 354.2q-1-1.7-1-3.8v-9.3q0-2.1 1-2.7 0.9-0.6 2.7 0.4 1.8 1 2.7 2.7 0.9 1.7 0.9 3.8v9.3q0 2.1-0.9 2.7-0.9 0.6-2.7-0.4-1.8-1-2.7-2.7zm3.9-0.8v-9.6q0-1.8-1.2-2.5-1.3-0.7-1.3 1v9.6q0 1.8 1.3 2.5 1.2 0.7 1.2-1z"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    className: "fL",
    d: "m584.6 348.6l-2.5-1.5v-1.9q1 0.6 1.6 0.7 0.7 0.2 1 0 0.4-0.3 0.7-1l1.6 0.9v17.6l-2.4-1.4z"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "fM",
    d: "m591.4 365.1q-0.9-1.7-0.9-3.9v-9.2q0-2.1 0.9-2.7 1-0.6 2.7 0.4 1.8 1 2.7 2.7 1 1.7 1 3.8v9.3q0 2.1-1 2.7-0.9 0.6-2.7-0.4-1.7-1-2.7-2.7zm4-0.8v-9.6q0-1.8-1.3-2.5-1.2-0.7-1.2 1v9.6q0 1.7 1.2 2.5 1.3 0.7 1.3-1z"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    className: "fN",
    d: "m603.4 359.5l-2.5-1.5v-1.9q1.1 0.6 1.7 0.7 0.6 0.2 1-0.1 0.3-0.2 0.6-0.9l1.7 0.9v17.6l-2.5-1.4z"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "fO",
    d: "m610.3 375.9q-1-1.7-1-3.8v-9.2q0-2.1 1-2.8 0.9-0.6 2.7 0.5 1.7 1 2.7 2.7 0.9 1.7 0.9 3.8v9.2q0 2.2-0.9 2.8-1 0.6-2.7-0.4-1.8-1.1-2.7-2.8zm3.9-0.8v-9.6q0-1.7-1.2-2.4-1.3-0.7-1.3 1v9.6q0 1.7 1.3 2.4 1.2 0.8 1.2-1z"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    className: "fP",
    d: "m622.3 370.4l-2.5-1.5v-2q1 0.6 1.6 0.8 0.6 0.2 1-0.1 0.4-0.2 0.7-1l1.6 1v17.6l-2.4-1.4z"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    className: "fQ",
    d: "m631.7 375.8l-2.5-1.5v-1.9q1 0.6 1.6 0.7 0.7 0.2 1-0.1 0.4-0.2 0.7-0.9l1.6 0.9v17.6l-2.4-1.4z"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "fR",
    d: "m638.5 392.3q-0.9-1.7-0.9-3.9v-9.2q0-2.1 0.9-2.7 1-0.6 2.7 0.4 1.8 1 2.8 2.7 0.9 1.7 0.9 3.8v9.3q0 2.1-0.9 2.7-1 0.6-2.8-0.4-1.7-1-2.7-2.7zm4-0.8v-9.7q0-1.7-1.3-2.4-1.2-0.7-1.2 1v9.6q0 1.7 1.2 2.5 1.3 0.7 1.3-1z"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    className: "fS",
    d: "m528.1 337.2l-2.5-1.5v-1.9q1 0.6 1.6 0.7 0.6 0.2 1-0.1 0.4-0.2 0.7-0.9l1.6 0.9v17.6l-2.4-1.4z"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "fT",
    d: "m534.9 353.6q-1-1.7-1-3.8v-9.2q0-2.1 1-2.8 0.9-0.6 2.7 0.5 1.8 1 2.7 2.7 1 1.7 1 3.8v9.2q0 2.2-1 2.8-0.9 0.6-2.7-0.4-1.8-1.1-2.7-2.8zm4-0.8v-9.6q0-1.7-1.3-2.4-1.2-0.7-1.2 1v9.6q0 1.7 1.2 2.4 1.3 0.8 1.3-1z"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "fU",
    d: "m544.3 359.1q-0.9-1.7-0.9-3.8v-9.3q0-2.1 0.9-2.7 1-0.6 2.7 0.4 1.8 1 2.7 2.7 1 1.7 1 3.8v9.3q0 2.1-1 2.7-0.9 0.6-2.7-0.4-1.7-1-2.7-2.7zm4-0.8v-9.6q0-1.8-1.3-2.5-1.2-0.7-1.2 1v9.6q0 1.8 1.2 2.5 1.3 0.7 1.3-1z"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "fV",
    d: "m553.7 364.5q-0.9-1.7-0.9-3.8v-9.3q0-2.1 0.9-2.7 1-0.6 2.7 0.4 1.8 1.1 2.8 2.8 0.9 1.7 0.9 3.8v9.2q0 2.1-0.9 2.7-1 0.7-2.8-0.4-1.7-1-2.7-2.7zm4-0.8v-9.6q0-1.7-1.3-2.5-1.2-0.7-1.2 1.1v9.6q0 1.7 1.2 2.4 1.3 0.7 1.3-1z"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    className: "fW",
    d: "m565.8 358.9l-2.6-1.4v-2q1.1 0.6 1.7 0.8 0.6 0.1 1-0.1 0.4-0.3 0.6-1l1.7 1v17.6l-2.4-1.4z"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "fX",
    d: "m572.6 375.4q-1-1.7-1-3.8v-9.3q0-2.1 1-2.7 0.9-0.6 2.7 0.4 1.8 1 2.7 2.7 0.9 1.7 0.9 3.9v9.2q0 2.1-0.9 2.7-0.9 0.6-2.7-0.4-1.8-1-2.7-2.7zm3.9-0.8v-9.6q0-1.8-1.2-2.5-1.3-0.7-1.3 1v9.6q0 1.8 1.3 2.5 1.2 0.7 1.2-1z"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    className: "fY",
    d: "m584.6 369.8l-2.5-1.4v-2q1 0.6 1.6 0.8 0.7 0.1 1-0.1 0.4-0.3 0.7-1l1.6 0.9v17.6l-2.4-1.4z"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "fZ",
    d: "m591.4 386.3q-0.9-1.7-0.9-3.8v-9.3q0-2.1 0.9-2.7 1-0.6 2.7 0.4 1.8 1 2.7 2.7 1 1.7 1 3.8v9.3q0 2.1-1 2.7-0.9 0.6-2.7-0.4-1.7-1-2.7-2.7zm4-0.8v-9.6q0-1.8-1.3-2.5-1.2-0.7-1.2 1v9.6q0 1.8 1.2 2.5 1.3 0.7 1.3-1z"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    className: "g0",
    d: "m603.4 380.7l-2.5-1.5v-1.9q1.1 0.6 1.7 0.7 0.6 0.2 1-0.1 0.3-0.2 0.6-0.9l1.7 0.9v17.6l-2.5-1.4z"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    className: "g1",
    d: "m612.9 386.1l-2.6-1.4v-2q1.1 0.6 1.7 0.8 0.6 0.1 1-0.1 0.4-0.3 0.7-1l1.6 0.9v17.6l-2.4-1.3z"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    className: "g2",
    d: "m622.3 391.6l-2.5-1.5v-1.9q1 0.6 1.6 0.7 0.6 0.2 1-0.1 0.4-0.2 0.7-0.9l1.6 0.9v17.6l-2.4-1.4z"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "g3",
    d: "m629.1 408q-0.9-1.7-0.9-3.8v-9.2q0-2.2 0.9-2.8 0.9-0.6 2.7 0.4 1.8 1.1 2.7 2.8 1 1.7 1 3.8v9.2q0 2.2-1 2.8-0.9 0.6-2.7-0.4-1.8-1.1-2.7-2.8zm4-0.8v-9.6q0-1.7-1.3-2.4-1.2-0.8-1.2 1v9.6q0 1.7 1.2 2.4 1.3 0.8 1.3-1z"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "g4",
    d: "m638.5 413.5q-0.9-1.7-0.9-3.8v-9.3q0-2.1 0.9-2.7 1-0.6 2.7 0.4 1.8 1 2.8 2.7 0.9 1.7 0.9 3.8v9.3q0 2.1-0.9 2.7-1 0.6-2.8-0.4-1.7-1-2.7-2.7zm4-0.8v-9.6q0-1.8-1.3-2.5-1.2-0.7-1.2 1v9.6q0 1.8 1.2 2.5 1.3 0.7 1.3-1z"
  }))), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    className: "ei",
    d: "m663.6 268.7q-1.3-0.7-2.5-0.8 0-0.1 0-0.1c0-7.6-5.3-16.7-11.8-20.5-5.3-3.1-9.8-1.7-11.3 2.9q-0.6-0.5-1.3-0.9c-4.3-2.5-7.8-0.5-7.8 4.5 0 4.9 3.5 11 7.8 13.5 2.2 1.2 24.4 14 26.9 15.5 3.4 2 6.2 0.4 6.2-3.5 0-3.9-2.8-8.6-6.2-10.6z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "g5",
    d: "m475.9 124.2l7.2 4.1q3.6 2.1 5.4 5.3 1.8 3.3 1.8 7.6v3.5q0 4.3-1.8 5.4-1.8 1.2-5.4-0.9l-2.3-1.3v14.4l-4.9-2.8zm7.2 20q1.1 0.7 1.7 0.3 0.6-0.4 0.6-2.2v-4.2q0-1.8-0.6-2.9-0.6-1.1-1.7-1.8l-2.3-1.3v10.8z"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    className: "g5",
    d: "m492.9 134l4.8 2.8v14.4l5.2 3v-14.4l4.9 2.8v35.3l-4.9-2.8v-15.9l-5.2-3v15.9l-4.8-2.8z"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "g5",
    d: "m511.4 144.7l7.1 4.1q3.6 2.1 5.4 5.3 1.8 3.3 1.8 7.6v3.4q0 4.3-1.8 5.5-1.8 1.2-5.4-0.9l-2.3-1.3v14.4l-4.8-2.8zm7.1 20q1.2 0.7 1.8 0.3 0.6-0.4 0.6-2.3v-4.1q0-1.9-0.6-3-0.6-1.1-1.8-1.7l-2.3-1.4v10.9z"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    className: "g5",
    d: "m627.3 402.3q-1.8-3.3-1.8-7.4v-19q0-4.2 1.8-5.4 1.8-1.2 5.3 0.8 3.5 2 5.3 5.3 1.8 3.4 1.8 7.5v3.7l-4.5-2.6v-4.1q0-3.3-2.4-4.7-2.5-1.4-2.5 1.9v19.8q0 3.2 2.5 4.6 2.4 1.4 2.4-1.9v-5.4l4.5 2.7v5q0 4.1-1.8 5.3-1.8 1.3-5.3-0.8-3.5-2-5.3-5.3z"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    className: "g5",
    d: "m643.7 411.8q-1.8-3.4-1.8-7.7v-2l4.6 2.6v2.5q0 3.4 2.5 4.8 1.2 0.8 1.9 0.3 0.6-0.5 0.6-2.3 0-2.3-0.9-4.5-0.9-2.2-3.2-5.9-3-4.8-4.2-7.9-1.2-3.1-1.2-6.2 0-4.2 1.8-5.4 1.9-1.3 5.4 0.8 3.5 2 5.3 5.3 1.7 3.3 1.7 7.6v1.5l-4.5-2.6v-1.9q0-1.8-0.6-3-0.7-1.2-1.9-1.8-2.4-1.4-2.4 1.9 0 2 0.9 4.1 0.9 2.2 3.3 6 3 4.8 4.2 7.9 1.1 3.1 1.1 6.5 0 4.3-1.8 5.5-1.9 1.3-5.5-0.8-3.5-2-5.3-5.3z"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    className: "g5",
    d: "m660.1 421.2q-1.8-3.3-1.8-7.6v-2l4.5 2.6v2.4q0 3.5 2.5 4.9 1.3 0.7 1.9 0.2 0.7-0.4 0.7-2.3 0-2.2-0.9-4.4-0.9-2.2-3.3-6-3-4.7-4.2-7.8-1.1-3.2-1.1-6.3 0-4.1 1.8-5.4 1.9-1.2 5.4 0.8 3.4 2 5.2 5.4 1.8 3.3 1.8 7.6v1.4l-4.6-2.6v-1.8q0-1.8-0.6-3-0.6-1.2-1.8-1.9-2.4-1.4-2.4 2 0 1.9 0.9 4.1 0.9 2.2 3.3 5.9 3 4.8 4.2 7.9 1.1 3.2 1.1 6.5 0 4.3-1.9 5.6-1.8 1.2-5.4-0.8-3.5-2.1-5.3-5.4z"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    className: "g6",
    d: "m583 537.9q-1.8-3.3-1.8-7.6v-2l4.5 2.6v2.4q0 3.5 2.5 4.9 1.3 0.7 1.9 0.3 0.6-0.5 0.6-2.4 0-2.2-0.8-4.4-0.9-2.2-3.3-5.9-3-4.8-4.2-7.9-1.2-3.2-1.2-6.2 0-4.2 1.9-5.5 1.8-1.2 5.4 0.8 3.4 2.1 5.2 5.4 1.8 3.3 1.8 7.6v1.5l-4.6-2.7v-1.8q0-1.8-0.6-3-0.6-1.2-1.8-1.9-2.4-1.4-2.4 2 0 1.9 0.9 4.1 0.9 2.2 3.3 5.9 3 4.8 4.1 8 1.2 3.1 1.2 6.4 0 4.4-1.9 5.6-1.9 1.2-5.4-0.8-3.5-2-5.3-5.4z"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "g6",
    d: "m608.6 554.4q-1.4-0.2-3.3-1.3-3.5-2-5.4-5.4-1.9-3.4-1.9-7.7v-18.6q0-4.2 1.9-5.4 1.9-1.3 5.4 0.8 3.6 2.1 5.5 5.5 1.9 3.4 1.9 7.6v18.6q0 3.5-1.4 5 0.3 0.7 0.7 1.1 0.4 0.3 1.1 0.8l0.8 0.4v5l-1.3-0.7q-3.3-1.9-4-5.7zm-0.7-8.3v-19.3q0-3.5-2.6-5-2.5-1.4-2.5 2.1v19.3q0 3.4 2.5 4.9 2.6 1.4 2.6-2z"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    className: "g6",
    d: "m616 523.4l4.8 2.8v30.3l8 4.6v5l-12.8-7.3z"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    className: "eS",
    d: "m86.6 281.3l-5.4-20.3 5.1 2.9 3.3 13.3h0.1l3.3-9.4 4.6 2.6-5.3 14.2 5.6 21.3-5.1-2.9-3.6-14.4-3.6 10.2-4.6-2.7z"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    className: "eS",
    d: "m100.2 271.9l6.9 4 3 27 0.1 0.1 3.1-23.5 6.9 4v35.3l-4.6-2.6v-26.8l-3.6 24.7-4-2.4-3.5-28.7-0.1-0.1v26.8l-4.2-2.5z"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    className: "eS",
    d: "m123.8 285.6l4.9 2.7v30.3l7.9 4.6v5.1l-12.8-7.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    className: "g7",
    d: "m383.6 199.3q-0.3-0.2-0.4-0.5-0.2-0.2-0.2-0.5v-2.5q0-0.4 0.2-0.5 0.1-0.2 0.5-0.3l6.8-1.3-6.8-9.1q-0.4-0.4-0.5-0.8-0.2-0.3-0.2-0.7v-2.5q0-0.3 0.2-0.4 0.1-0.1 0.4 0 0.2 0.2 0.5 0.7l9.5 12.8q0.4 0.6 0.6 1.1 0.2 0.4 0.2 0.8v0.8q0 0.5-0.2 0.7-0.2 0.2-0.6 0.2l-9.5 2q-0.3 0.1-0.5 0z"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    className: "g7",
    d: "m379.3 201.2l-1.9-1q-0.3-0.2-0.5-0.6-0.2-0.3-0.3-0.6l-9.6-31.7q0-0.2 0-0.4 0-0.3 0.1-0.4 0.2-0.1 0.4 0.1l1.9 1q0.3 0.2 0.5 0.6 0.2 0.3 0.4 0.6l9.5 31.7q0 0.2 0 0.4 0 0.3-0.2 0.4-0.1 0.1-0.3-0.1z"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    className: "g7",
    d: "m363.2 187.5q-0.2-0.1-0.5-0.6l-9.5-12.9q-0.4-0.5-0.6-1-0.2-0.4-0.2-0.8v-0.8q0-0.5 0.2-0.7 0.2-0.2 0.6-0.3l9.5-1.9q0.3-0.1 0.5 0 0.3 0.1 0.4 0.4 0.2 0.3 0.2 0.6v2.5q0 0.4-0.2 0.5-0.1 0.2-0.5 0.3l-6.8 1.3 6.8 9q0.4 0.5 0.5 0.9 0.2 0.3 0.2 0.7v2.5q0 0.3-0.2 0.4-0.1 0.1-0.4-0.1z"
  }))), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    className: "g8",
    d: "m193.4 167.1v4.3l29.3 16.6v-4.3z"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    className: "g9",
    d: "m193.4 299.6v4.3l29.3 16.7v-4.3z"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    className: "ga",
    d: "m218.8 261.4l-21.8-12.4v4.3l21.8 12.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDev);
export default __webpack_public_path__ + "static/media/dev.2771198035e716bc8bcb1dee01594e77.svg";
export { ForwardRef as ReactComponent };